// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseURL: string;
};

export enum OpsTileStatus {
  OK = 'ok',
  WARNING = 'warning',
  CRITICAL = 'critical',
  UNKNOWN = 'unknown',
}

export type OpsOverviewTileDto = {
  key: string;
  domain: string;
  label: string;
  value: string;
  sub?: string;
  status: OpsTileStatus;
  spark?: Array<number>;
};

export type OpsOverviewDto = {
  generatedAt: string;
  tiles: Array<OpsOverviewTileDto>;
};

export enum OpsMetricsDomain {
  BILLING = 'billing',
  NOTIFICATIONS = 'notifications',
  GROWTH = 'growth',
  JOBS = 'jobs',
  INTEGRATIONS = 'integrations',
}

export type RecomputeOpsMetricsDto = {
  date: string;
  domains?: Array<OpsMetricsDomain>;
};

export enum OpsMetricsRecomputeStatus {
  ENQUEUED = 'enqueued',
  IN_FLIGHT = 'in_flight',
  NOTHING_TO_COMPUTE = 'nothing_to_compute',
}

export type OpsMetricsRecomputeResultDto = {
  date: string;
  status: OpsMetricsRecomputeStatus;
  domains: Array<OpsMetricsDomain>;
  skippedDomains: Array<OpsMetricsDomain>;
};

export type OpsMetricsPointDto = {
  date: string;
  metrics: {
    [key: string]: number;
  };
  computedAt: string;
};

export type OpsMetricsSeriesDto = {
  domain: OpsMetricsDomain;
  from: string;
  to: string;
  points: Array<OpsMetricsPointDto>;
};

export enum OpsDependencyKey {
  MONGO = 'mongo',
  REDIS = 'redis',
  QUEUE = 'queue',
}

export type OpsDependencyHealthDto = {
  key: OpsDependencyKey;
  label: string;
  up: boolean;
  latencyMs: number;
  error?: string;
};

export type OpsRedisMemoryDto = {
  usedBytes: number;
  maxBytes: number;
  policy?: string | null;
  evictedKeys: number;
};

export enum AppStage {
  LOCAL = 'local',
  DEV = 'dev',
  PROD = 'prod',
}

export type OpsReleaseDto = {
  version: string;
  commit?: string;
  stage: AppStage;
  nodeEnv: string;
  startedAt: string;
  uptimeSeconds: number;
  releaseUrl?: string;
  commitUrl?: string;
  logsUrl?: string;
};

export type OpsMigrationStatusDto = {
  appliedCount: number;
  pending: Array<string>;
  checksumMismatches: Array<string>;
};

export type OpsHealthDto = {
  generatedAt: string;
  status: OpsTileStatus;
  dependencies: Array<OpsDependencyHealthDto>;
  redisMemory?: OpsRedisMemoryDto | null;
  release: OpsReleaseDto;
  migrations?: OpsMigrationStatusDto | null;
};

export type DeliveryThresholdsDto = {
  warnRate: number;
  criticalRate: number;
  minAttempts: number;
};

export enum DeliveryChannel {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push',
  IN_APP = 'inApp',
  WALLET = 'wallet',
}

export type DeliveryOutcomeCountsDto = {
  sent: number;
  delivered: number;
  failed: number;
  skipped: number;
  bounced: number;
  complained: number;
};

export type DeliveryChannelHealthDto = {
  channel: DeliveryChannel;
  last24h: DeliveryOutcomeCountsDto;
  last7d: DeliveryOutcomeCountsDto;
  failureRate24h: number | null;
  failureRate7d: number | null;
  status: OpsTileStatus;
};

export enum DeliverySource {
  NOTIFICATION = 'notification',
  TRANSACTIONAL = 'transactional',
  FEEDBACK = 'feedback',
  OTP = 'otp',
  WALLET = 'wallet',
}

export type DeliverySourceBreakdownDto = {
  channel: DeliveryChannel;
  source: DeliverySource;
  last24h: DeliveryOutcomeCountsDto;
  last7d: DeliveryOutcomeCountsDto;
};

export type DeliveryFailingTypeDto = {
  type: string;
  channel: DeliveryChannel;
  count: number;
  lastError: string | null;
};

export type DeliverySkippedReasonDto = {
  channel: DeliveryChannel;
  reason: string;
  count: number;
};

export type DeliveryPushTokenHealthDto = {
  tokens24h: number;
  invalid24h: number;
  tokens7d: number;
  invalid7d: number;
  invalidRate7d: number | null;
};

export type NotificationsOpsSummaryDto = {
  generatedAt: string;
  thresholds: DeliveryThresholdsDto;
  providerEventsSeen: boolean;
  status: OpsTileStatus;
  channels: Array<DeliveryChannelHealthDto>;
  sources: Array<DeliverySourceBreakdownDto>;
  topFailingTypes: Array<DeliveryFailingTypeDto>;
  skippedReasons: Array<DeliverySkippedReasonDto>;
  pushTokens: DeliveryPushTokenHealthDto;
};

export type SearchNotificationDeliveriesDto = {
  workspaceId?: string;
  userId?: string;
  recipient?: string;
  channel?: DeliveryChannel;
  limit?: number;
  before?: string;
};

export type DeliveryPushCountsDto = {
  tokens: number;
  sent: number;
  invalid: number;
  failed: number;
};

export type NotificationDeliveryRowDto = {
  id: string;
  createdAt: string;
  channel: DeliveryChannel;
  source: DeliverySource;
  type: string;
  status: string;
  skippedReason: string | null;
  error: string | null;
  recipientMasked: string | null;
  provider: string | null;
  providerMessageId: string | null;
  attempt: number | null;
  workspaceId: string | null;
  userId: string | null;
  push: DeliveryPushCountsDto | null;
  bounceType?: string | null;
};

export type NotificationDeliverySearchResultDto = {
  rows: Array<NotificationDeliveryRowDto>;
  nextBefore: string | null;
};

export type OpsQueueDto = {
  name: string;
  available: boolean;
  waiting: number;
  active: number;
  delayed: number;
  prioritized: number;
  failed: number;
  recentFailed: number;
  lastFailedAt: string | null;
  completed: number;
  isPaused: boolean;
  workers: number;
};

export enum OpsSchedulerStatus {
  OK = 'ok',
  OVERDUE = 'overdue',
  MISSING = 'missing',
  UNKNOWN = 'unknown',
}

export type OpsSchedulerDto = {
  schedulerId: string;
  name: string;
  pattern: string;
  intervalSeconds: number | null;
  next: string | null;
  lastRun: string | null;
  status: OpsSchedulerStatus;
};

export type OpsJobsDto = {
  generatedAt: string;
  failureWindowSeconds: number;
  queues: Array<OpsQueueDto>;
  schedulers: Array<OpsSchedulerDto>;
};

export type OpsJobFailureDto = {
  id: string;
  queue: string;
  jobId: string;
  jobName: string;
  failedReason: string;
  attemptsMade: number;
  createdAt: string;
};

export type OpsJobFailurePageDto = {
  from: string;
  to: string;
  page: number;
  limit: number;
  total: number;
  items: Array<OpsJobFailureDto>;
};

export type OpsJobFailureDayDto = {
  date: string;
  total: number;
  byQueue: {
    [key: string]: number;
  };
};

export type OpsJobFailureTrendDto = {
  from: string;
  to: string;
  days: Array<OpsJobFailureDayDto>;
};

export enum DataIntegrityMode {
  CHECK = 'check',
  REPAIR = 'repair',
}

export enum DataIntegrityScope {
  OWNERS = 'owners',
  REFERENCES = 'references',
  FILES = 'files',
  RETENTION = 'retention',
  INDEXES = 'indexes',
}

export type RunDataIntegrityDto = {
  mode: DataIntegrityMode;
  dryRun?: boolean;
  scopes?: Array<DataIntegrityScope>;
};

export enum DataDeletionStatus {
  PENDING = 'pending',
  RUNNING = 'running',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum DataIntegrityRepairAction {
  DELETE = 'delete',
  NULLIFY = 'nullify',
  RELEASE = 'release',
  HOOK = 'hook',
  RETAIN = 'retain',
  MANUAL = 'manual',
}

export type DataIntegrityFindingDto = {
  entity: string;
  path: string;
  target: string;
  policy: string;
  count: number;
  repaired: number;
  sampleIds: Array<string>;
  action: DataIntegrityRepairAction;
};

export type DataIntegrityReportDto = {
  id: string;
  mode: DataIntegrityMode;
  dryRun: boolean;
  totalDangling: number;
  totalRetained: number;
  durationMs: number;
  findings: Array<DataIntegrityFindingDto>;
  createdAt: string;
};

export type DataDeletionLogDto = {
  id: string;
  rootEntity: string;
  rootId: string;
  status: DataDeletionStatus;
  requestedVia: string;
  requestedAt: string;
  completedAt?: string | null;
  attempts: number;
  lastError?: string | null;
  counts: {
    [key: string]: number;
  };
};

export type FileDto = {
  id: string;
  /**
   * File path for serving the file (e.g. for profile image display)
   */
  path?: string;
};

export type RoleDto = {
  id: string;
};

export type StatusDto = {
  id: string;
};

export type CreateUserDto = {
  email: string;
  firstName: string;
  lastName: string;
  username: string;
  photo?: FileDto;
  role?: RoleDto;
  status?: StatusDto;
};

export type FileType = {
  id: string;
  readonly path: string;
};

export type Role = {
  readonly id: string;
  readonly name: string;
};

export type Status = {
  readonly id: string;
  readonly name: string;
};

export type User = {
  readonly id: string;
  readonly email: string;
  readonly provider: string;
  readonly username: string;
  readonly firstName: string;
  readonly lastName: string;
  photo: FileType;
  role: Role;
  status: Status;
  readonly phone?: string | null;
  readonly phoneVerified?: boolean;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
};

export type InfinityPaginationUserResponseDto = {
  readonly data: Array<User>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type AdminSetUserPasswordDto = {
  password: string;
};

export type UpdateUserDto = {
  email?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  photo?: FileDto;
  role?: RoleDto;
  status?: StatusDto;
};

export type UsernameProposalRequestDto = {
  firstName?: string;
  lastName?: string;
  baseUsername?: string;
  count?: number;
};

export type UsernameProposalResponseDto = {
  suggestions: Array<string>;
  recommended: string;
};

export type AdminUserSearchResultDto = {
  id: string;
  email?: string | null;
  displayName: string;
  username?: string | null;
  /**
   * Names of workspaces the user belongs to
   */
  workspaceNames: Array<string>;
  photo?: FileDto | null;
  /**
   * True when an admin-provisioned password is set (App Review / password login).
   */
  hasPassword: boolean;
};

export type FileResponseDto = {
  file: FileType;
};

export type AuthEmailLoginDto = {
  email: string;
  /**
   * Optional redirect url for entering the verification code. Supports {{email}} and {{magicCode}} placeholders.
   */
  redirectUrl?: string;
};

export type AuthMagicLinkRequestResponseDto = {
  readonly expiresAt: string;
  readonly expiresInMinutes: number;
};

export type AuthEmailLoginResolveDto = {
  email: string;
};

export type AuthLoginResolveResponseDto = {
  /**
   * True when the account has an admin-provisioned password and may use password login.
   */
  hasPassword: boolean;
};

export type AuthMagicLinkVerifyDto = {
  /**
   * Email address that received the login code
   */
  email: string;
  /**
   * 6 digit login code
   */
  code: string;
};

export type LoginResponseDto = {
  readonly token: string;
  readonly refreshToken: string;
  readonly tokenExpires: number;
  user: User;
  readonly redirectUrl: string;
};

export type AuthEmailPasswordLoginDto = {
  email: string;
  password: string;
};

export type AuthPublicConfigDto = {
  /**
   * Whether new accounts can be created via email registration. When false, the app should hide the sign-up form.
   */
  registrationEnabled: boolean;
  /**
   * Whether Apple Wallet pass signing is configured. When false, the app should hide Add to Wallet.
   */
  walletEnabled: boolean;
};

export type AuthRegisterLoginDto = {
  email: string;
  firstName: string;
  lastName: string;
  username?: string;
  /**
   * Optional redirect url for entering the verification code. Supports {{email}} and {{magicCode}} placeholders.
   */
  redirectUrl?: string;
};

export type AuthConfirmEmailDto = {
  hash: string;
};

export enum LocaleEnum {
  DE = 'de',
  EN = 'en',
}

export type ReplyPromptConfig = {
  readonly tone: string;
  readonly considerations: string;
  readonly mustInclude: string;
  readonly templateId: string;
  readonly mergedContext: string;
};

export type AutoReplyConfig = {
  readonly enabled: boolean;
  readonly minStars: number;
  readonly minDelayMinutes: number;
  readonly excludeWithText: boolean;
  readonly excludeNegativeSentiment: boolean;
  readonly autoPublish: boolean;
  readonly excludedAspects: Array<string>;
};

export enum WorkspacePlan {
  FREE = 'free',
  PLUS = 'plus',
  TEAMS = 'teams',
  ENTERPRISE = 'enterprise',
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIALING = 'trialing',
  PAST_DUE = 'past_due',
  CANCELED = 'canceled',
  UNPAID = 'unpaid',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAUSED = 'paused',
}

export enum BillingCycle {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export enum PendingPlanChangeKind {
  DOWNGRADE = 'downgrade',
  CANCEL = 'cancel',
}

export enum BillingGrantPlan {
  PLUS = 'plus',
  TEAMS = 'teams',
  ENTERPRISE = 'enterprise',
}

export enum BillingGrantReason {
  INTERNAL = 'internal',
  SPONSORED = 'sponsored',
  PILOT = 'pilot',
}

export type BillingGrant = {
  plan: BillingGrantPlan;
  /**
   * When omitted, quota.members falls back to the base plan default.
   */
  memberLimit?: {
    [key: string]: unknown;
  };
  /**
   * When omitted, reputation locations are unlimited for this grant.
   */
  reputationLocationLimit?: {
    [key: string]: unknown;
  };
  reason: BillingGrantReason;
  grantedBy: string;
  grantedAt: string;
  /**
   * When omitted, the grant does not expire.
   */
  expiresAt?: string;
};

export type Workspace = {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly website: string;
  readonly email: string;
  readonly username: string;
  readonly leadsAlwaysSharedWithWorkspace: boolean;
  readonly feedbackPaygEnabled: boolean;
  readonly defaultReputationPreset: string;
  defaultLocale: LocaleEnum;
  replyPromptConfig: ReplyPromptConfig;
  autoReplyConfig: AutoReplyConfig;
  photo: FileType;
  plan: WorkspacePlan;
  subscriptionStatus?: SubscriptionStatus | null;
  seats: number;
  /**
   * Billed reputation-location add-on quantity from the billing mirror
   */
  reputationLocations: number;
  currentPeriodEnd?: string | null;
  graceUntil?: string | null;
  /**
   * Stripe Customer id for this workspace
   */
  stripeCustomerId?: string | null;
  billingCycle?: BillingCycle | null;
  /**
   * Whether the subscription is set to cancel at period end
   */
  cancelAtPeriodEnd?: boolean;
  scheduledPlan?: WorkspacePlan | null;
  scheduledBillingCycle?: BillingCycle | null;
  scheduledChangeAt?: string | null;
  scheduledChangeType?: PendingPlanChangeKind | null;
  /**
   * Platform-admin billing grant. When active, overrides Stripe for entitlements.
   */
  billingGrant?: BillingGrant | null;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
};

/**
 * Member role in the workspace
 */
export enum WorkspaceMemberRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

/**
 * Membership status
 */
export enum WorkspaceMemberStatus {
  PENDING = 'pending',
  ACTIVE = 'active',
  SUSPENDED = 'suspended',
  REJECTED = 'rejected',
}

export type WorkspaceMembershipDto = {
  /**
   * Workspace details
   */
  workspace: Workspace;
  /**
   * Member role in the workspace
   */
  role: WorkspaceMemberRole;
  /**
   * Membership status
   */
  status: WorkspaceMemberStatus;
};

export type ImpersonationActorDto = {
  /**
   * Platform admin user id performing the impersonation
   */
  id: string;
  /**
   * Display name of the platform admin
   */
  displayName?: string;
};

export type ImpersonationContextDto = {
  /**
   * Platform admin who started impersonation
   */
  actor: ImpersonationActorDto;
  /**
   * When impersonation started (ISO-8601)
   */
  startedAt: string;
  /**
   * Optional support ticket or reason supplied at start
   */
  reason?: string;
};

export type AuthMeResponseDto = {
  readonly id: string;
  readonly email: string;
  readonly provider: string;
  readonly username: string;
  readonly firstName: string;
  readonly lastName: string;
  photo: FileType;
  role: Role;
  status: Status;
  readonly phone?: string | null;
  readonly phoneVerified?: boolean;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
  /**
   * User workspace memberships with roles
   */
  workspaceMemberships?: Array<WorkspaceMembershipDto>;
  /**
   * Present when the session is an admin impersonation of this user
   */
  impersonation?: ImpersonationContextDto;
  /**
   * Whether outbound SMS is configured so phone verification codes can be sent
   */
  smsVerificationAvailable: boolean;
};

export type AuthIntercomIdentityResponseDto = {
  /**
   * Stable user id for Intercom (e.g. app/{userId})
   */
  user_id: string;
  /**
   * User display name (e.g. first + last name) for Intercom
   */
  name?: string;
  /**
   * User email if available
   */
  email?: string;
  /**
   * HMAC-SHA256 of user_id for Intercom Secure Mode; only present when INTERCOM_SECRET_KEY is set
   */
  user_hash?: string;
};

export type RefreshResponseDto = {
  readonly token: string;
  readonly refreshToken: string;
  readonly tokenExpires: number;
};

export type AuthUpdateDto = {
  photo?: FileDto | null;
  firstName?: string;
  lastName?: string;
  username?: string;
};

export type AuthRequestEmailChangeDto = {
  email: string;
  /**
   * Optional redirect url for email confirmation. Supports {{email}} and {{hash}} placeholders.
   */
  redirectUrl?: string;
};

export type AuthPhoneRequestVerificationDto = {
  phone: string;
};

export type AuthPhoneVerifyDto = {
  code: string;
};

export type StartImpersonationDto = {
  /**
   * Target user id to impersonate
   */
  userId: string;
  /**
   * Optional workspace id hint for client deep-link after impersonation starts
   */
  workspaceId?: string;
  /**
   * Optional support ticket id or free-text reason for audit
   */
  reason?: string;
};

export type NotificationCapabilitiesDto = {
  pushEnabled: boolean;
};

export enum DevicePushPlatform {
  IOS = 'ios',
  ANDROID = 'android',
}

export type RegisterDevicePushTokenDto = {
  token: string;
  platform: DevicePushPlatform;
  appVersion?: string | null;
};

export type RegisterDevicePushTokenResponseDto = {
  registered: boolean;
};

export type RevokeDevicePushTokenDto = {
  token: string;
};

export type RevokeDevicePushTokenResponseDto = {
  revoked: boolean;
};

export type NotificationChannelMatrixDto = {
  email: boolean;
  inApp: boolean;
  sms: boolean;
  push: boolean;
};

export type NotificationTypeDefinitionDto = {
  id: string;
  domain: string;
  label: string;
  description: string;
  configurable: boolean;
  workspaceConfigurable: boolean;
  userConfigurable: boolean;
  defaultChannels: NotificationChannelMatrixDto;
};

export type UserNotification = {
  id: string;
  userId: string;
  workspaceId?: string | null;
  type: string;
  title: string;
  body: string;
  deepLink?: string | null;
  sourceRef?: string | null;
  readAt?: string | null;
  createdAt: string;
};

export type UnreadNotificationCountDto = {
  count: number;
};

export type MarkAllNotificationsReadResponseDto = {
  markedCount: number;
};

export type UpdateUserNotificationPreferenceItemDto = {
  typeId: string;
  channels: NotificationChannelMatrixDto;
};

export type UpdateUserNotificationPreferencesDto = {
  workspaceId?: string | null;
  preferences: Array<UpdateUserNotificationPreferenceItemDto>;
};

export type UserNotificationPreferenceDto = {
  type: NotificationTypeDefinitionDto;
  channels: NotificationChannelMatrixDto;
};

export type ApplyPushGrantDefaultsDto = {
  workspaceId: string;
};

export type ApplyPushGrantDefaultsResponseDto = {
  updatedTypeIds: Array<string>;
};

export type WorkspaceTeamStatusDto = {
  readonly hasTeam: boolean;
  readonly activeMemberCount: number;
  readonly teamCount: number;
};

/**
 * Effective permission set for the current user in this workspace
 */
export enum Permission {
  WORKSPACE_READ = 'workspace:read',
  WORKSPACE_UPDATE = 'workspace:update',
  WORKSPACE_DELETE = 'workspace:delete',
  WORKSPACE_MANAGE_SETTINGS = 'workspace:manage_settings',
  MEMBERS_READ = 'members:read',
  MEMBERS_INVITE = 'members:invite',
  MEMBERS_UPDATE_ROLE = 'members:update_role',
  MEMBERS_REMOVE = 'members:remove',
  ROLES_MANAGE = 'roles:manage',
  TEAMS_READ = 'teams:read',
  TEAMS_MANAGE = 'teams:manage',
  LEADS_READ = 'leads:read',
  LEADS_READ_OTHERS = 'leads:read_others',
  LEADS_UPDATE = 'leads:update',
  LEADS_UPDATE_OTHERS = 'leads:update_others',
  LEADS_EXPORT = 'leads:export',
  EVENTS_READ = 'events:read',
  EVENTS_MANAGE = 'events:manage',
  PROFILES_READ = 'profiles:read',
  PROFILES_UPDATE = 'profiles:update',
  PROFILES_MANAGE_TEMPLATES = 'profiles:manage_templates',
  PRODUCTS_READ = 'products:read',
  PRODUCTS_MANAGE = 'products:manage',
  LOCATIONS_READ = 'locations:read',
  LOCATIONS_MANAGE = 'locations:manage',
  INTEGRATIONS_READ = 'integrations:read',
  INTEGRATIONS_MANAGE = 'integrations:manage',
  REPUTATION_READ = 'reputation:read',
  REPUTATION_REPLY = 'reputation:reply',
  REPUTATION_CONFIGURE = 'reputation:configure',
  FEEDBACK_READ = 'feedback:read',
  FEEDBACK_INVITE = 'feedback:invite',
  FEEDBACK_MANAGE = 'feedback:manage',
  BILLING_READ = 'billing:read',
  BILLING_MANAGE = 'billing:manage',
}

export type MyWorkspacePermissionsDto = {
  /**
   * Effective permission set for the current user in this workspace
   */
  permissions: Array<Permission>;
};

export type ReplyPromptConfigDto = {
  /**
   * Tonalität (z.B. freundlich und kurz, formell)
   */
  tone?: {
    [key: string]: unknown;
  };
  /**
   * Was bei der Antwort zu berücksichtigen ist
   */
  considerations?: {
    [key: string]: unknown;
  };
  /**
   * Was die Antwort enthalten soll
   */
  mustInclude?: {
    [key: string]: unknown;
  };
  /**
   * ID der gewählten Vorlage (für Anzeige/Re-Apply)
   */
  templateId?: {
    [key: string]: unknown;
  };
  /**
   * Zusammengebauter Kontext für den KI-Prompt
   */
  mergedContext?: {
    [key: string]: unknown;
  };
};

export type AutoReplyConfigDto = {
  /**
   * Whether auto-reply is enabled for this scope (location or workspace default).
   */
  enabled?: boolean;
  /**
   * Minimum star rating required for auto-reply (1–5).
   */
  minStars?: number;
  /**
   * Minimum delay in minutes before an auto-reply is published.
   */
  minDelayMinutes?: number;
  /**
   * When true, reviews with text are excluded from auto-reply (star-only reviews).
   */
  excludeWithText?: boolean;
  /**
   * When true, reviews with negative sentiment analysis are excluded from auto-reply.
   */
  excludeNegativeSentiment?: boolean;
  /**
   * When true, eligible reviews are auto-published after minDelayMinutes. When false, only KI drafts are created for human review.
   */
  autoPublish?: boolean;
  /**
   * Aspect keys that always route to a human (never auto-replied).
   */
  excludedAspects?: Array<string>;
};

export type CreateWorkspaceDto = {
  name: string;
  description?: string;
  website?: string;
  email?: string;
  username?: string;
  photo?: FileDto | null;
  /**
   * When true, all workspace leads are visible to every active member.
   */
  leadsAlwaysSharedWithWorkspace?: boolean;
  /**
   * When true, Feedback invite recipients beyond the included quota are billed via Stripe meter overage (PAYG).
   */
  feedbackPaygEnabled?: boolean;
  /**
   * Default industry preset for new locations without an override.
   */
  defaultReputationPreset?: string | null;
  /**
   * Default language for Feedback templates and guest-facing copy. Accepts BCP-47 tags (e.g. de-DE → de). Defaults to de when omitted.
   */
  defaultLocale?: LocaleEnum;
  replyPromptConfig?: ReplyPromptConfigDto | null;
  autoReplyConfig?: AutoReplyConfigDto | null;
};

export type WorkspaceUsernameProposalRequestDto = {
  workspaceName?: string;
  baseUsername?: string;
  count?: number;
  /**
   * Workspace ID to exclude from uniqueness (for updates)
   */
  excludeWorkspaceId?: string;
};

export type WorkspaceUsernameProposalResponseDto = {
  suggestions: Array<string>;
  recommended: string;
};

export type InfinityPaginationWorkspaceResponseDto = {
  readonly data: Array<Workspace>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type UpdateWorkspaceDto = {
  name?: string;
  description?: string;
  website?: string;
  email?: string;
  username?: string;
  photo?: FileDto | null;
  /**
   * When true, all workspace leads are visible to every active member.
   */
  leadsAlwaysSharedWithWorkspace?: boolean;
  /**
   * When true, Feedback invite recipients beyond the included quota are billed via Stripe meter overage (PAYG).
   */
  feedbackPaygEnabled?: boolean;
  /**
   * Default industry preset for new locations without an override.
   */
  defaultReputationPreset?: string | null;
  /**
   * Default language for Feedback templates and guest-facing copy. Accepts BCP-47 tags (e.g. de-DE → de). Defaults to de when omitted.
   */
  defaultLocale?: LocaleEnum;
  replyPromptConfig?: ReplyPromptConfigDto | null;
  autoReplyConfig?: AutoReplyConfigDto | null;
};

export type InviteUserDto = {
  /**
   * Email address of the user to invite
   */
  email: string;
  /**
   * Built-in role preset for the invited user. Mutually exclusive with customRoleId.
   */
  role?: WorkspaceMemberRole;
  /**
   * Custom workspace role id for the invited user. Mutually exclusive with role.
   */
  customRoleId?: string;
  /**
   * Optional redirect URL after accepting the invitation. Supports {workspaceId} placeholder.
   */
  acceptRedirectUrl?: string;
  /**
   * Optional redirect URL after declining the invitation. Supports {workspaceId} placeholder.
   */
  declineRedirectUrl?: string;
};

export type WorkspaceMemberWithDetailsDto = {
  readonly id: string;
  readonly userId: string;
  readonly workspaceId: string;
  role: WorkspaceMemberRole;
  readonly customRoleId: string;
  status: WorkspaceMemberStatus;
  readonly invitedBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
  workspace: Workspace;
  invitedByUser: User;
};

export type WorkspaceMember = {
  readonly id: string;
  readonly userId: string;
  readonly workspaceId: string;
  role: WorkspaceMemberRole;
  readonly customRoleId: string;
  status: WorkspaceMemberStatus;
  readonly invitedBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
};

export enum WorkspaceMemberQuerySortBy {
  CREATED_AT = 'createdAt',
  NAME = 'name',
  ROLE = 'role',
  STATUS = 'status',
}

export enum QuerySortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export type WorkspaceMemberWithUserDto = {
  readonly id: string;
  readonly userId: string;
  readonly workspaceId: string;
  role: WorkspaceMemberRole;
  readonly customRoleId: string;
  status: WorkspaceMemberStatus;
  readonly invitedBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
  /**
   * User details for this workspace member
   */
  user?: User;
  /**
   * User who invited this member
   */
  invitedByUser?: User;
  /**
   * Invitee email for privileged viewers (pending invites have no display name)
   */
  email?: string | null;
};

export type InfinityPaginationWorkspaceMemberWithUserDtoResponseDto = {
  readonly data: Array<WorkspaceMemberWithUserDto>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type WorkspaceMemberLookupUserDto = {
  id: string;
  username?: {
    [key: string]: unknown;
  } | null;
  firstName?: {
    [key: string]: unknown;
  } | null;
  lastName?: {
    [key: string]: unknown;
  } | null;
  photo?: FileDto | null;
};

export type WorkspaceMemberLookupRowDto = {
  id: string;
  userId: string;
  workspaceId: string;
  role: WorkspaceMemberRole;
  status: WorkspaceMemberStatus;
  invitedBy?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: {
    [key: string]: unknown;
  } | null;
  user?: WorkspaceMemberLookupUserDto;
};

export type InfinityPaginationWorkspaceMemberLookupRowDtoResponseDto = {
  readonly data: Array<WorkspaceMemberLookupRowDto>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type UpdateMemberRoleDto = {
  /**
   * Built-in role preset. Mutually exclusive with customRoleId.
   */
  role?: WorkspaceMemberRole;
  /**
   * Custom workspace role id. Mutually exclusive with role.
   */
  customRoleId?: string;
};

export type MyMembershipDto = {
  /**
   * Workspace details
   */
  workspace: Workspace;
  /**
   * Member role in the workspace
   */
  role: WorkspaceMemberRole;
  /**
   * Custom role id when the member uses a workspace-defined role preset
   */
  customRoleId?: string | null;
  /**
   * Membership status
   */
  status: WorkspaceMemberStatus;
  /**
   * Effective permission set for this membership (empty when not active)
   */
  permissions: Array<Permission>;
};

export type EntitlementUsageMembersDto = {
  active: number;
  /**
   * Pending invitations
   */
  pending: number;
  /**
   * -1 means unlimited
   */
  limit: number;
};

export type EntitlementUsageReputationLocationsDto = {
  connected: number;
  included: number;
  billed: number;
};

export type EntitlementUsageFeedbackInviteRecipientsDto = {
  /**
   * Billable initial sends in the current subscription period
   */
  used: number;
  /**
   * Included recipients for the plan (-1 unlimited)
   */
  included: number;
  /**
   * Whether PAYG overage is enabled for this workspace
   */
  paygEnabled: boolean;
  /**
   * Start of the usage period (Stripe period or calendar month)
   */
  periodStart?: string | null;
  /**
   * End of the usage period (exclusive)
   */
  periodEnd?: string | null;
};

export type EntitlementUsageDto = {
  members: EntitlementUsageMembersDto;
  reputationLocations: EntitlementUsageReputationLocationsDto;
  feedbackInviteRecipients: EntitlementUsageFeedbackInviteRecipientsDto;
};

export type ScheduledPlanChangeDto = {
  plan: WorkspacePlan | null;
  billingCycle: BillingCycle | null;
  effectiveAt: string | null;
  changeType: PendingPlanChangeKind | null;
};

export type WorkspaceEntitlementsDto = {
  plan: WorkspacePlan;
  /**
   * Plan stored on the workspace billing mirror (before status downgrade)
   */
  mirroredPlan: WorkspacePlan;
  status: SubscriptionStatus | null;
  seats: number;
  /**
   * Billed reputation-location add-on quantity from the billing mirror
   */
  reputationLocations: number;
  features: {
    [key: string]: boolean;
  };
  quotas: {
    [key: string]: number;
  };
  usage: EntitlementUsageDto;
  scheduledChange: ScheduledPlanChangeDto | null;
  billingGrant?: {
    plan?: string;
    memberLimit?: number | null;
    reputationLocationLimit?: number | null;
    reason?: string;
    grantedAt?: string;
    expiresAt?: string | null;
  } | null;
  /**
   * True when a platform-admin billing grant drives entitlements.
   */
  hasActiveBillingGrant: boolean;
};

export type WorkspaceRoleListItemDto = {
  /**
   * Role id (ObjectId for custom roles; built-in enum value for system roles)
   */
  id: string;
  /**
   * Set for built-in system roles (owner/admin/member)
   */
  builtinRole?: WorkspaceMemberRole;
  workspaceId: string;
  name: string;
  description?: string;
  permissions: Array<Permission>;
  isSystem: boolean;
  color?: string;
};

export type CreateWorkspaceRoleDto = {
  name: string;
  description?: string;
  /**
   * Catalog permissions granted by this role
   */
  permissions: Array<Permission>;
  color?: string;
};

export type WorkspaceRole = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  description?: string;
  /**
   * Catalog permissions granted by this role
   */
  permissions: Array<string>;
  readonly isSystem: boolean;
  color?: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
};

export type UpdateWorkspaceRoleDto = {
  name?: string;
  description?: string;
  /**
   * Catalog permissions granted by this role
   */
  permissions?: Array<Permission>;
  color?: string;
};

export type TeamWithCountsDto = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  description?: string;
  color?: string;
  readonly createdBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
  readonly memberCount: number;
  readonly viewerIsMember: boolean;
};

export type InfinityPaginationTeamWithCountsDtoResponseDto = {
  readonly data: Array<TeamWithCountsDto>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type CreateTeamDto = {
  name: string;
  description?: string;
  color?: string;
};

export type Team = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  description?: string;
  color?: string;
  readonly createdBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
};

export type UpdateTeamDto = {
  name?: string;
  description?: string;
  color?: string;
};

export type TeamMemberWithUserDto = {
  readonly id: string;
  readonly teamId: string;
  readonly workspaceId: string;
  readonly workspaceMemberId: string;
  readonly userId: string;
  readonly addedBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
  user?: User;
  readonly workspaceMemberRole: string;
};

export type AddTeamMemberDto = {
  /**
   * The `WorkspaceMember` id of the user to add to this team. Must belong to the same workspace.
   */
  workspaceMemberId: string;
};

export enum ProfileVisibility {
  PRIVATE = 'private',
  UNLISTED = 'unlisted',
}

export enum ProfileLanguage {
  AUTO = 'auto',
  DE = 'de',
  EN = 'en',
}

export enum ProfileModuleType {
  BIOGRAPHY = 'biography',
  CONTACT_INFO = 'contact_info',
  SOCIALS = 'socials',
  LINKS = 'links',
  VIDEO = 'video',
  IMAGES = 'images',
  FILES = 'files',
  GOOGLE_MAPS = 'google_maps',
  TEAM_MEMBERS = 'team_members',
}

export type ProfileModuleDto = {
  id?: string;
  type: ProfileModuleType;
  order: number;
  enabled: boolean;
  config: {
    [key: string]: unknown;
  };
  style?: {
    [key: string]: unknown;
  };
};

export enum ProfileLayout {
  CLASSIC = 'classic',
  CARDS = 'cards',
  CENTERED = 'centered',
}

export enum ProfileTheme {
  DARK = 'dark',
  LIGHT = 'light',
  AUTO = 'auto',
}

export enum ProfileHeaderStyle {
  IMAGE = 'image',
  GRADIENT = 'gradient',
  MINIMAL = 'minimal',
}

export enum ProfileButtonShape {
  ROUNDED = 'rounded',
  PILL = 'pill',
  SQUARE = 'square',
}

export type ProfileStylingDto = {
  layout?: ProfileLayout;
  theme?: ProfileTheme;
  headerStyle?: ProfileHeaderStyle;
  headerImage?: FileDto | null;
  buttonShape?: ProfileButtonShape;
  accentColor?: string;
};

/**
 * Form visibility mode: off, manual, or auto_open
 */
export enum LeadFormVisibilityMode {
  OFF = 'off',
  MANUAL = 'manual',
  AUTO_OPEN = 'auto_open',
}

export enum LeadFormFieldType {
  NAME = 'name',
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  EMAIL = 'email',
  PHONE = 'phone',
  COMPANY = 'company',
  JOB_TITLE = 'job_title',
  MESSAGE = 'message',
  CUSTOM = 'custom',
}

export type LeadFormFieldDto = {
  id?: string;
  type: LeadFormFieldType;
  label: string;
  required: boolean;
  order: number;
  config?: {
    [key: string]: unknown;
  };
};

export type ProfileLeadFormDto = {
  enabled: boolean;
  /**
   * Form visibility mode: off, manual, or auto_open
   */
  visibilityMode?: LeadFormVisibilityMode;
  fields: Array<LeadFormFieldDto>;
  notificationEmails?: Array<string>;
  notificationSms?: Array<string>;
  /**
   * Delay in seconds before auto-opening the form (0-15). Only used when visibilityMode is auto_open.
   */
  autoOpenDelay?: number;
};

export enum CalendlyDisplayType {
  BUTTON = 'button',
  INLINE = 'inline',
}

export type ProfileCalendlyIntegrationDto = {
  enabled?: boolean;
  url?: string;
  displayType?: CalendlyDisplayType;
  buttonText?: string;
};

export type ProfileIntegrationsDto = {
  calendly?: ProfileCalendlyIntegrationDto;
};

export type ProfileTemplateContentDto = {
  visibility?: ProfileVisibility;
  language?: ProfileLanguage;
  jobTitle?: {
    [key: string]: unknown;
  };
  company?: {
    [key: string]: unknown;
  };
  location?: {
    [key: string]: unknown;
  };
  title?: {
    [key: string]: unknown;
  };
  profileImage?: FileDto;
  showProfileImage?: boolean;
  showUp2promoBranding?: boolean;
  leadsAutoShareWithWorkspace?: boolean;
  modules?: Array<ProfileModuleDto>;
  styling?: ProfileStylingDto;
  leadForm?: ProfileLeadFormDto;
  integrations?: ProfileIntegrationsDto;
};

export enum ProfileTemplateFieldMode {
  LOCKED = 'locked',
  FREE = 'free',
}

export type ProfileTemplateFieldPoliciesDto = {
  visibility?: ProfileTemplateFieldMode;
  language?: ProfileTemplateFieldMode;
  showProfileImage?: ProfileTemplateFieldMode;
  showUp2promoBranding?: ProfileTemplateFieldMode;
  accentColor?: ProfileTemplateFieldMode;
  layout?: ProfileTemplateFieldMode;
  theme?: ProfileTemplateFieldMode;
  headerStyle?: ProfileTemplateFieldMode;
  headerImage?: ProfileTemplateFieldMode;
  buttonShape?: ProfileTemplateFieldMode;
  leadsAutoShareWithWorkspace?: ProfileTemplateFieldMode;
  jobTitle?: ProfileTemplateFieldMode;
  company?: ProfileTemplateFieldMode;
  location?: ProfileTemplateFieldMode;
  leadForm?: ProfileTemplateFieldMode;
};

export type CreateProfileTemplateDto = {
  name: string;
  description?: string;
  content: ProfileTemplateContentDto;
  fieldPolicies?: ProfileTemplateFieldPoliciesDto;
  /**
   * Teams this template is assigned to (DEV-14).
   */
  teamIds?: Array<string>;
};

export type ProfileStyling = {
  layout?: ProfileLayout;
  theme?: ProfileTheme;
  headerStyle?: ProfileHeaderStyle;
  headerImage?: FileType | null;
  buttonShape?: ProfileButtonShape;
  accentColor?: string;
};

export type LeadFormField = {
  readonly id: string;
  type: LeadFormFieldType;
  readonly label: string;
  readonly required: boolean;
  readonly order: number;
};

export type ProfileLeadForm = {
  readonly enabled: boolean;
  visibilityMode: LeadFormVisibilityMode;
  readonly fields: Array<LeadFormField>;
  readonly notificationEmails: Array<string>;
  readonly notificationSms: Array<string>;
  readonly autoOpenDelay: number;
};

export type ProfileCalendlyIntegration = {
  readonly enabled: boolean;
  readonly url: string;
  displayType: CalendlyDisplayType;
  readonly buttonText: string;
};

export type ProfileIntegrations = {
  calendly: ProfileCalendlyIntegration;
};

export type ProfileTemplateContent = {
  visibility?: ProfileVisibility;
  language?: ProfileLanguage;
  jobTitle?: string | null;
  company?: string | null;
  location?: string | null;
  title?: string | null;
  showProfileImage?: boolean;
  showUp2promoBranding?: boolean;
  leadsAutoShareWithWorkspace?: boolean;
  modules?: Array<unknown>;
  styling?: ProfileStyling;
  leadForm?: ProfileLeadForm;
  integrations?: ProfileIntegrations;
};

/**
 * draft = editable template, member values preparable; published = live; syncing = profile jobs running, member values locked
 */
export enum ProfileTemplatePublishStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  SYNCING = 'syncing',
}

export type ProfileTemplate = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  description?: string;
  content: ProfileTemplateContent;
  teamIds: Array<string>;
  /**
   * draft = editable template, member values preparable; published = live; syncing = profile jobs running, member values locked
   */
  publishStatus: ProfileTemplatePublishStatus;
  readonly createdBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  /**
   * Monotonic revision bumped when content or governance policies change.
   */
  revision: number;
  readonly deletedAt: string;
};

export type InfinityPaginationProfileTemplateResponseDto = {
  readonly data: Array<ProfileTemplate>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type UpdateProfileTemplateDto = {
  name?: string;
  description?: string;
  content?: ProfileTemplateContentDto;
  fieldPolicies?: ProfileTemplateFieldPoliciesDto;
  /**
   * Teams this template is assigned to (DEV-14).
   */
  teamIds?: Array<string>;
};

export type ProfileTemplateRevisionSummary = {
  readonly id: string;
  revision: number;
  name: string;
  description?: string;
  teamIds: Array<string>;
  /**
   * Stable hash of published governance for change detection in lists.
   */
  contentSignature: string;
  readonly publishedBy: string;
  readonly publishedAt: string;
};

export type ProfileTemplateRevision = {
  readonly id: string;
  readonly templateId: string;
  readonly workspaceId: string;
  revision: number;
  name: string;
  description?: string;
  teamIds: Array<string>;
  contentSignature: string;
  readonly publishedBy: string;
  readonly publishedAt: string;
};

export enum TemplateMemberValueColumnKind {
  FIELD = 'field',
  SOCIAL = 'social',
  MODULE_ENTRY = 'moduleEntry',
  SETTING = 'setting',
}

export type BulkMemberValuesResponseDto = {
  /**
   * Map of userId → cell value from each member profile
   */
  values: {
    [key: string]: unknown;
  };
};

export type TemplateMemberValueColumnDto = {
  kind: TemplateMemberValueColumnKind;
  key?: string;
  platform?: string;
  entryId?: string;
  moduleId?: string;
};

export type BulkSetMemberValuesDto = {
  column: TemplateMemberValueColumnDto;
  /**
   * Map of userId → new cell value (empty string clears to profile default)
   */
  updates: {
    [key: string]: unknown;
  };
};

export type ApplyProfileTemplateDto = {
  /**
   * Profile to apply the template to.
   */
  profileId: string;
};

export type ProfileModule = {
  readonly id: string;
  readonly profileId: string;
  type: ProfileModuleType;
  readonly order: number;
  readonly enabled: boolean;
};

export type Profile = {
  readonly id: string;
  readonly user: string;
  readonly workspace: string;
  readonly publicHash: string;
  visibility: ProfileVisibility;
  language: ProfileLanguage;
  readonly jobTitle: string;
  readonly company: string;
  readonly location: string;
  readonly title: string;
  profileImage: FileType;
  readonly showProfileImage: boolean;
  readonly showUp2promoBranding: boolean;
  readonly leadsAutoShareWithWorkspace: boolean;
  ownerPhoto: FileType;
  workspacePhoto: FileType;
  readonly workspaceDefaultLocale: string;
  readonly modules: Array<ProfileModule>;
  styling: ProfileStyling;
  leadForm: ProfileLeadForm;
  integrations: ProfileIntegrations;
  readonly profileTemplateSyncedAt: string;
  /**
   * Template revision last applied to this profile (not lock policies).
   */
  profileTemplateSyncedRevision?: number;
  /**
   * True while a template sync job is queued or running.
   */
  profileTemplateSyncPending?: boolean;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export enum CheckoutWorkspacePlan {
  PLUS = 'plus',
  TEAMS = 'teams',
}

export type CreateCheckoutSessionDto = {
  plan: CheckoutWorkspacePlan;
  billingCycle: BillingCycle;
};

export type BillingSessionResponseDto = {
  /**
   * Stripe-hosted Checkout or Customer Portal URL
   */
  url: string;
};

export enum ChangeWorkspacePlan {
  FREE = 'free',
  PLUS = 'plus',
  TEAMS = 'teams',
}

export type ChangePlanRequestDto = {
  plan: ChangeWorkspacePlan;
  billingCycle: BillingCycle;
};

export enum PlanChangeKind {
  UPGRADE = 'upgrade',
  DOWNGRADE = 'downgrade',
  CANCEL = 'cancel',
  NOOP = 'noop',
}

export enum BillingChangeTiming {
  IMMEDIATE = 'immediate',
  PERIOD_END = 'period_end',
}

export type PlanChangeComplianceWarningDto = {
  code: string;
  message: string;
};

export type PreviewPlanChangeResponseDto = {
  kind: PlanChangeKind;
  timing: BillingChangeTiming;
  currentPlan: ChangeWorkspacePlan;
  currentBillingCycle: BillingCycle;
  targetPlan: ChangeWorkspacePlan;
  targetBillingCycle: BillingCycle;
  effectiveAt?: string | null;
  warnings: Array<PlanChangeComplianceWarningDto>;
  /**
   * Whether additional reputation-location add-ons will be billed after the change
   */
  willIncurLocationAddon: boolean;
};

export type ChangeSubscriptionPlanResponseDto = {
  success: boolean;
  plan: ChangeWorkspacePlan;
  billingCycle: BillingCycle;
  timing: BillingChangeTiming;
  effectiveAt?: string | null;
};

/**
 * Open the portal directly in this flow instead of its home page.
 */
export enum BillingPortalFlow {
  PAYMENT_METHOD_UPDATE = 'payment_method_update',
}

export type CreatePortalSessionDto = {
  /**
   * Open the portal directly in this flow instead of its home page.
   */
  flow?: BillingPortalFlow;
};

export type BillingGrantSummaryDto = {
  plan: BillingGrantPlan;
  memberLimit?: number | null;
  reputationLocationLimit?: number | null;
  reason: BillingGrantReason;
  grantedAt: string;
  expiresAt?: string | null;
};

export type AdminWorkspaceSearchResultDto = {
  id: string;
  name: string;
  username: string | null;
  plan: WorkspacePlan;
  billingGrant?: BillingGrantSummaryDto | null;
  activeMembers: number;
  connectedReputationLocations: number;
  /**
   * Whether the workspace has an active Stripe subscription.
   */
  hasActiveSubscription: boolean;
};

export type BillingGrantConflictDto = {
  hasActiveSubscription: boolean;
  subscriptionPlan?: string | null;
  activeMembers: number;
  connectedReputationLocations: number;
};

/**
 * Required when the workspace has an active Stripe subscription.
 */
export enum BillingGrantRefundPolicy {
  PRORATED = 'prorated',
  FULL = 'full',
  NONE = 'none',
}

export type UpsertBillingGrantDto = {
  plan: BillingGrantPlan;
  memberLimit?: number;
  reputationLocationLimit?: number;
  reason: BillingGrantReason;
  expiresAt?: string;
  /**
   * Required when the workspace has an active Stripe subscription.
   */
  subscriptionRefundPolicy?: BillingGrantRefundPolicy;
};

export type CreateProfileDto = {
  /**
   * Workspace ID. Required; every profile belongs to a workspace.
   */
  workspace: string;
  visibility?: ProfileVisibility;
  language?: ProfileLanguage;
  jobTitle?: {
    [key: string]: unknown;
  };
  company?: {
    [key: string]: unknown;
  };
  location?: {
    [key: string]: unknown;
  };
  title?: {
    [key: string]: unknown;
  };
  profileImage?: FileDto;
  /**
   * Whether to show profile/avatar image on the public profile page. Default true.
   */
  showProfileImage?: boolean;
  /**
   * Whether to show up2promo branding on the public profile page. Default true.
   */
  showUp2promoBranding?: boolean;
  /**
   * When enabled, new leads from this profile default to shared with the workspace unless overridden per lead.
   */
  leadsAutoShareWithWorkspace?: boolean;
  modules?: Array<ProfileModuleDto>;
  styling?: ProfileStylingDto;
  leadForm?: ProfileLeadFormDto;
  integrations?: ProfileIntegrationsDto;
};

export type UpdateProfileDto = {
  /**
   * Workspace ID. Required; every profile belongs to a workspace.
   */
  workspace?: string;
  visibility?: ProfileVisibility;
  language?: ProfileLanguage;
  jobTitle?: {
    [key: string]: unknown;
  };
  company?: {
    [key: string]: unknown;
  };
  location?: {
    [key: string]: unknown;
  };
  title?: {
    [key: string]: unknown;
  };
  profileImage?: FileDto;
  /**
   * Whether to show profile/avatar image on the public profile page. Default true.
   */
  showProfileImage?: boolean;
  /**
   * Whether to show up2promo branding on the public profile page. Default true.
   */
  showUp2promoBranding?: boolean;
  /**
   * When enabled, new leads from this profile default to shared with the workspace unless overridden per lead.
   */
  leadsAutoShareWithWorkspace?: boolean;
  modules?: Array<ProfileModuleDto>;
  styling?: ProfileStylingDto;
  leadForm?: ProfileLeadFormDto;
  integrations?: ProfileIntegrationsDto;
};

export type WalletCardStatusDto = {
  /**
   * At least one device has registered this Wallet Card. Not a guarantee that the owner’s current phone holds it.
   */
  installed: boolean;
  /**
   * Installed and every registered device holds the current Card Fingerprint.
   */
  upToDate: boolean;
  deviceCount: number;
  /**
   * Registered devices still holding an older Card Fingerprint.
   */
  staleDeviceCount: number;
  /**
   * Fingerprint of the card content as it would be issued now.
   */
  fingerprint: string;
  /**
   * Pass type identifier of the issued card, so the device can look it up in its own Wallet.
   */
  passTypeIdentifier: string;
  lastRegisteredAt?: string | null;
};

export enum ProfileViewSource {
  WALLET = 'wallet',
  PROFILE_QR = 'profile_qr',
  DIRECT = 'direct',
  PRODUCT = 'product',
  UNKNOWN = 'unknown',
}

export type ResolveProfilePublicHashDto = {
  readonly profileId: string;
  readonly publicHash: string;
  readonly workspaceUsername: string;
  readonly username: string;
  source: ProfileViewSource;
};

export enum ProfileUsageRangeDays {
  _7 = 7,
  _30 = 30,
}

export enum PeriodChangeDirection {
  UP = 'up',
  DOWN = 'down',
  FLAT = 'flat',
  NEW = 'new',
}

export type PeriodChangeDto = {
  percent: number | null;
  direction: PeriodChangeDirection;
};

export type ProfileUsageSeriesPointDto = {
  date: string;
  views: number;
};

export type ProfileUsageSourceCountDto = {
  source: ProfileViewSource;
  count: number;
};

export enum ProductScanSource {
  QR = 'qr',
  NFC = 'nfc',
  UNKNOWN = 'unknown',
}

export type ProfileUsageProductSourceCountDto = {
  source: ProductScanSource;
  count: number;
};

export type ProfileUsageDto = {
  rangeDays: ProfileUsageRangeDays;
  /**
   * First UTC day the plan still shows (`quota.analytics_history_days`). Views before it read as zero; set only when the current or previous window reaches past it (ADR-0025 §4).
   */
  historyLimitedTo?: string;
  total: number;
  previousTotal: number;
  periodChange: PeriodChangeDto;
  series: Array<ProfileUsageSeriesPointDto>;
  sources: Array<ProfileUsageSourceCountDto>;
  productSources: Array<ProfileUsageProductSourceCountDto>;
  /**
   * sources.product count.
   */
  viaProductCount?: number;
  lastViewedAt?: string | null;
};

export enum ProductBehavior {
  URL = 'URL',
  PROFILE = 'PROFILE',
  GOOGLE_REVIEW = 'GOOGLE_REVIEW',
  INSTAGRAM = 'INSTAGRAM',
  MENU = 'MENU',
  FACEBOOK = 'FACEBOOK',
  TIKTOK = 'TIKTOK',
}

export type ProductTargetInputDto = {
  kind: ProductBehavior;
  /**
   * Required for URL.
   */
  url?: string;
  /**
   * Required for PROFILE.
   */
  userId?: string;
  /**
   * Required for location kinds (GOOGLE_REVIEW, INSTAGRAM, MENU, FACEBOOK, TIKTOK); must belong to the workspace. Ignored for other kinds.
   */
  locationId?: string;
};

export enum ProductForm {
  STAND = 'STAND',
  BADGE = 'BADGE',
  CARD = 'CARD',
}

export enum ProductMaterial {
  PVC = 'PVC',
  METAL = 'METAL',
  ACRYL = 'ACRYL',
  GENERIC = 'GENERIC',
}

export type ProductItemInputDto = {
  form?: ProductForm;
  material?: ProductMaterial;
  size?: string;
  color?: string;
  /**
   * Factory language, e.g. `de`.
   */
  language?: string;
  sku?: string;
  behavior?: ProductBehavior;
};

/**
 * Google-review funnel. Anything but direct_review requires feature.feedback.
 */
export enum FeedbackInviteMode {
  FEEDBACK_ONLY = 'feedback_only',
  FEEDBACK_THEN_OPTIONAL_REVIEW = 'feedback_then_optional_review',
  DIRECT_REVIEW = 'direct_review',
}

export enum FeedbackQuestionType {
  SHORT_TEXT = 'short_text',
  LONG_TEXT = 'long_text',
  YES_NO = 'yes_no',
  NPS_0_10 = 'nps_0_10',
  RATING_1_5 = 'rating_1_5',
  SINGLE_SELECT = 'single_select',
  MULTI_SELECT = 'multi_select',
}

export type FeedbackQuestionDto = {
  /**
   * Stable id; generated when omitted
   */
  id?: string;
  type: FeedbackQuestionType;
  label: string;
  required?: boolean;
  options?: Array<string>;
};

export type ProductFeedbackInputDto = {
  /**
   * Google-review funnel. Anything but direct_review requires feature.feedback.
   */
  mode?: FeedbackInviteMode;
  reviewThreshold?: number;
  questions?: Array<FeedbackQuestionDto>;
};

export type CreateProductDto = {
  hash: string;
  target: ProductTargetInputDto;
  /**
   * The owner's name for the product.
   */
  label: string;
  item?: ProductItemInputDto;
  feedback?: ProductFeedbackInputDto;
};

export enum ProductState {
  BLANK = 'BLANK',
  CONFIGURED_UNOWNED = 'CONFIGURED_UNOWNED',
  CLAIMED = 'CLAIMED',
}

export type ProductTargetDto = {
  kind: ProductBehavior;
  /**
   * URL targets only.
   */
  url?: string;
  /**
   * PROFILE targets: the user whose workspace profile is shown.
   */
  userId?: string;
  /**
   * Location targets (and location-bound PROFILE targets).
   */
  locationId?: string;
};

export type ProductItemDto = {
  behavior?: ProductBehavior;
  form?: ProductForm;
  material?: ProductMaterial;
  size?: string;
  color?: string;
  /**
   * Factory language (lowercase), e.g. `de`.
   */
  language?: string;
  sku?: string;
};

export enum FulfillmentStage {
  GENERATED = 'GENERATED',
  PROGRAMMED = 'PROGRAMMED',
}

export type ProductFulfillmentDto = {
  stage?: FulfillmentStage;
};

export type ProductFeedbackDto = {
  mode: FeedbackInviteMode;
  reviewThreshold: number;
  questions: Array<FeedbackQuestionDto>;
};

export type ProductHistoryDto = {
  releaseCount: number;
  lastReleasedAt?: string;
};

export type ProductScanSeriesPointDto = {
  date: string;
  count: number;
};

export type ProductDto = {
  id: string;
  /**
   * Public printed hash. Immutable.
   */
  hash: string;
  state: ProductState;
  /**
   * Owner workspace (CLAIMED only).
   */
  workspaceId?: string;
  target?: ProductTargetDto;
  item: ProductItemDto;
  fulfillment: ProductFulfillmentDto;
  feedback?: ProductFeedbackDto;
  /**
   * The owner's name for the product.
   */
  label?: string;
  history?: ProductHistoryDto;
  createdAt: string;
  updatedAt: string;
  /**
   * Scans in the last `includeScansDays` days (list only).
   */
  scanCount?: number;
  /**
   * Daily scans for `includeScanSeriesDays` days (list only).
   */
  scanSeries?: Array<ProductScanSeriesPointDto>;
};

export type ProductContactDto = {
  /**
   * Setup contact; receives the reset code.
   */
  email: string;
  /**
   * Mail locale, e.g. `de`.
   */
  locale: string;
};

export type CreateProductWithMailDto = {
  hash: string;
  target: ProductTargetInputDto;
  /**
   * The owner's name for the product.
   */
  label: string;
  item?: ProductItemInputDto;
  feedback?: ProductFeedbackInputDto;
  contact: ProductContactDto;
};

export enum ClaimRequestStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
  SUPERSEDED = 'SUPERSEDED',
  REJECTED = 'REJECTED',
}

export enum ClaimMethod {
  EMAIL = 'EMAIL',
  MANUAL = 'MANUAL',
}

export type ClaimRequestViewDto = {
  id: string;
  /**
   * Product hash
   */
  hash: string;
  productId: string;
  workspaceId: string;
  method: ClaimMethod;
  status: ClaimRequestStatus;
  /**
   * EMAIL: masked address the verification mail went to
   */
  maskedEmail?: string;
  /**
   * MANUAL: note for the admin review
   */
  note?: string;
  expiresAt: string;
  lastSentAt?: string;
  /**
   * Verification mails re-sent so far
   */
  resendCount: number;
  /**
   * When the request left PENDING
   */
  resolvedAt?: string;
  /**
   * REJECTED only: the reason the up2promo team gave
   */
  rejectionReason?: string;
  createdAt: string;
};

export type ClaimRequestCountDto = {
  /**
   * Unexpired PENDING requests (admin: MANUAL ones of every workspace; app: the workspace’s own)
   */
  pending: number;
};

export type ProductListResponseDto = {
  readonly data: Array<ProductDto>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
  /**
   * First UTC day the plan still shows (`quota.analytics_history_days`). Set only when `includeScansDays` / `includeScanSeriesDays` were cut (ADR-0025 §4).
   */
  historyLimitedTo?: string;
};

export type ProductFacetValueDto = {
  /**
   * Facet value; __unknown__ means missing/unknown
   */
  value: string;
  count: number;
};

export type ProductFacetsDto = {
  behaviors: Array<ProductFacetValueDto>;
  forms: Array<ProductFacetValueDto>;
  materials: Array<ProductFacetValueDto>;
  colors: Array<ProductFacetValueDto>;
  sizes: Array<ProductFacetValueDto>;
  languages: Array<ProductFacetValueDto>;
  locationIds: Array<ProductFacetValueDto>;
};

export enum ProductHashResolutionKind {
  READY_FOR_SETUP = 'ready_for_setup',
  ALREADY_IN_WORKSPACE = 'already_in_workspace',
  ASSIGNED_TO_OTHER_USER = 'assigned_to_other_user',
  OTHER_WORKSPACE = 'other_workspace',
  SEND_CLAIM_EMAIL = 'send_claim_email',
  CLAIM_PENDING = 'claim_pending',
  CLAIM_MANUAL = 'claim_manual',
}

export type ProductHashResolutionDto = {
  kind: ProductHashResolutionKind;
  hash: string;
  /**
   * Factory behaviour of the printed item (the setup type hint, DEV-456).
   */
  behavior?: ProductBehavior;
  /**
   * Own-workspace kinds only (`already_in_workspace`, `assigned_to_other_user`).
   */
  productId?: string;
  /**
   * `claim_pending` only: method of the live request.
   */
  claimMethod?: ClaimMethod;
};

export type ProductScansDto = {
  hash: string;
  /**
   * Days in `series`: the requested days, cut to the plan.
   */
  days: number;
  /**
   * First UTC day the plan still shows (`quota.analytics_history_days`). Set only when the requested days were cut (ADR-0025 §4).
   */
  historyLimitedTo?: string;
  /**
   * Scans in the window.
   */
  total: number;
  /**
   * Zero-filled, oldest first.
   */
  series: Array<ProductScanSeriesPointDto>;
};

export type UpdateProductDto = {
  /**
   * Replaces the target as a unit.
   */
  target?: ProductTargetInputDto;
  /**
   * Empty string clears the label.
   */
  label?: string;
  feedback?: ProductFeedbackInputDto;
  /**
   * Delete the scan history of this product (fresh statistics after reconfiguration).
   */
  resetUsage?: boolean;
};

export type ClaimRequestDto = {
  /**
   * Hash of the link mapping (product) to claim
   */
  hash: string;
  /**
   * Full URL of the claim verify page in the app. The verification email will link here with a token. E.g. https://app.example.com/claim/verify
   */
  claimVerifyUrl?: string;
  /**
   * Mail language when the setup contact has none stored (e.g. de, en)
   */
  locale?: string;
};

export type ClaimRequestResponseDto = {
  /**
   * Whether a verification email was sent
   */
  sent: boolean;
  /**
   * Message for the user
   */
  message?: string;
  request?: ClaimRequestViewDto;
};

export type ClaimRequestManualDto = {
  /**
   * Hash of the product to claim
   */
  hash: string;
  /**
   * Note for the up2promo team (e.g. order number, proof)
   */
  note?: string;
};

export type ClaimResendDto = {
  /**
   * Claim verify page in the app (allowlisted origins only)
   */
  claimVerifyUrl?: string;
};

export type ProductUsageSummarizedBodyDto = {
  startTime: string;
  endTime: string;
  filter?: string;
  fieldName: string;
};

export type ProductUsageDataDto = {
  _id: string;
  timestamp: string;
  hash?: string;
  count?: number;
  placeName?: string;
  targetUrl?: string;
};

export type ProductUsageBodyDto = {
  startTime: string;
  endTime: string;
  filter?: string;
};

export type PublicProductDto = {
  hash: string;
  state: ProductState;
  /**
   * Factory behaviour of the printed item.
   */
  behavior?: ProductBehavior;
  form?: ProductForm;
  material?: ProductMaterial;
  /**
   * Not BLANK: the hash has a setup or an owner.
   */
  configured: boolean;
  /**
   * CONFIGURED_UNOWNED: a workspace can claim it (e-mail or manual).
   */
  claimable: boolean;
  /**
   * CONFIGURED_UNOWNED only: the URL the forwarder redirects to (public anyway).
   */
  targetUrl?: string;
};

/**
 * Printed short code (`?t=` on QR/NFC URLs) matching the product; null when unknown.
 */
export enum LegacyProductCode {
  GO = 'GO',
  IG = 'IG',
  ME = 'ME',
  TT = 'TT',
  FB = 'FB',
  CU = 'CU',
  BC = 'BC',
}

export type ResolveProductResponseDto = {
  targetUrl: string;
  /**
   * Target kind of the product; null for an unknown hash.
   */
  kind?: ProductBehavior | null;
  /**
   * Printed short code (`?t=` on QR/NFC URLs) matching the product; null when unknown.
   */
  legacyCode?: LegacyProductCode | null;
};

export type SetupProductDto = {
  hash: string;
  /**
   * Redirect target.
   */
  url: string;
  label?: string;
  contact?: ProductContactDto;
  /**
   * Factory identity hint (e.g. the `?t=` code as behaviour). Only fills keys the product does not have yet; `language` is ignored.
   */
  item?: ProductItemInputDto;
};

export type VerifyResetCodeResponseDto = {
  success: boolean;
  message: string;
};

export type ClaimVerifyDto = {
  /**
   * One-time claim token from verification email
   */
  token: string;
};

export type ClaimVerifyResponseDto = {
  /**
   * Whether the product was successfully claimed
   */
  success: boolean;
  /**
   * Message for the user
   */
  message?: string;
  /**
   * Hash of the claimed product
   */
  hash?: string;
};

export enum ProductEventType {
  REGISTERED = 'REGISTERED',
  GOODS_RECEIVED = 'GOODS_RECEIVED',
  PROGRAMMED = 'PROGRAMMED',
  CHIP_RESET = 'CHIP_RESET',
  SET_UP = 'SET_UP',
  CLAIM_REQUESTED = 'CLAIM_REQUESTED',
  CLAIM_SUPERSEDED = 'CLAIM_SUPERSEDED',
  CLAIM_REJECTED = 'CLAIM_REJECTED',
  CLAIMED = 'CLAIMED',
  UPDATED = 'UPDATED',
  FEEDBACK_CHANGED = 'FEEDBACK_CHANGED',
  RELEASED = 'RELEASED',
  PACKED = 'PACKED',
  ORDER_RECORDED = 'ORDER_RECORDED',
  LOCATION_CLEARED = 'LOCATION_CLEARED',
  USAGE_RESET = 'USAGE_RESET',
  RESET_CODE_MAIL_SENT = 'RESET_CODE_MAIL_SENT',
  CLAIM_MAIL_SENT = 'CLAIM_MAIL_SENT',
  SETUP_CONTACT_VIEWED = 'SETUP_CONTACT_VIEWED',
}

export enum ProductEventAudience {
  WORKSPACE = 'workspace',
  PLATFORM = 'platform',
}

export enum ProductEventActorKind {
  USER = 'user',
  PLATFORM_ADMIN = 'platform_admin',
  SYSTEM = 'system',
  PUBLIC = 'public',
}

export type ProductEventPersonDto = {
  /**
   * Null once the user is deleted.
   */
  userId?: string | null;
  /**
   * Name (or masked e-mail) of the user. Null once the user is deleted.
   */
  displayName?: string | null;
};

export type ProductEventActorDto = {
  kind: ProductEventActorKind;
  /**
   * `user` / `platform_admin` (admin view). Null when the user was deleted or is hidden from this audience.
   */
  userId?: string | null;
  /**
   * Name (or masked e-mail) of the acting user. Null when deleted or hidden.
   */
  displayName?: string | null;
  /**
   * True when the acting user no longer exists (render as "deleted user").
   */
  deleted: boolean;
  /**
   * `system`: job or hook name.
   */
  job?: string;
  /**
   * Admin view only: the platform admin who impersonated the acting user.
   */
  impersonatedBy?: ProductEventPersonDto;
};

export type ProductEventChangeDto = {
  field: string;
  /**
   * Value before. Absent when the field was not set.
   */
  from?:
    | string
    | number
    | boolean
    | Array<unknown>
    | {
        [key: string]: unknown;
      };
  /**
   * Value after. Absent when the field was cleared.
   */
  to?:
    | string
    | number
    | boolean
    | Array<unknown>
    | {
        [key: string]: unknown;
      };
};

export type ProductEventDto = {
  id: string;
  type: ProductEventType;
  audience: ProductEventAudience;
  /**
   * Admin view only: owning workspace at event time (null for platform events).
   */
  workspaceId?: string | null;
  actor: ProductEventActorDto;
  changes: Array<ProductEventChangeDto>;
  metadata?: {
    [key: string]: string | number | boolean;
  };
  occurredAt: string;
};

export type ProductEventWorkspaceDto = {
  id: string;
  name: string;
};

export type ProductEventPageDto = {
  data: Array<ProductEventDto>;
  /**
   * Admin view only: names of the owning workspaces on this page. Deleted (tombstoned) workspaces are left out and stay anonymous.
   */
  workspaces?: Array<ProductEventWorkspaceDto>;
  /**
   * Pass as `cursor` for the next (older) page; null at the end.
   */
  nextCursor: string | null;
};

export type LocationCoordinates = {
  readonly latitude: number;
  readonly longitude: number;
};

export enum ExternalLinkType {
  MENU = 'menu',
  INSTAGRAM = 'instagram',
  FACEBOOK = 'facebook',
  TIKTOK = 'tiktok',
}

export type ExternalLinkItem = {
  type: ExternalLinkType;
  readonly value: string;
};

export type LocationAddressDetails = {
  readonly formatted: string;
  readonly postalCode: string;
  readonly street: string;
  readonly streetNumber: string;
  readonly locality: string;
  readonly administrativeArea: string;
  readonly administrativeAreaLevel2: string;
  readonly country: string;
  readonly countryCode: string;
};

export type Location = {
  readonly id: string;
  readonly workspaceId: string;
  readonly name: string;
  coordinates: LocationCoordinates;
  readonly reviewExternalIds: {
    [key: string]: string;
  };
  readonly externalLinks: Array<ExternalLinkItem>;
  readonly address: string;
  readonly contactEmail: string;
  readonly contactPhone: string;
  addressDetails: LocationAddressDetails;
  replyPromptConfig: ReplyPromptConfig;
  autoReplyConfig: AutoReplyConfig;
  readonly reputationPreset: string;
  readonly reviewChannelOptOut: {
    [key: string]: boolean;
  };
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
};

export type InfinityPaginationLocationResponseDto = {
  readonly data: Array<Location>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type LocationCoordinatesDto = {
  /**
   * Latitude
   */
  latitude: number;
  /**
   * Longitude
   */
  longitude: number;
};

export type ExternalLinkItemDto = {
  /**
   * Link type
   */
  type: ExternalLinkType;
  /**
   * URL for menu/Facebook page, username for Instagram/TikTok (without @)
   */
  value: string;
};

export type AddressDetailsDto = {
  /**
   * Full formatted address line (e.g. from Google Places)
   */
  formatted?: string;
  postalCode?: string;
  street?: string;
  streetNumber?: string;
  locality?: string;
  administrativeArea?: string;
  administrativeAreaLevel2?: string;
  country?: string;
  countryCode?: string;
};

export type CreateLocationDto = {
  name: string;
  coordinates?: LocationCoordinatesDto | null;
  /**
   * Per-provider review listing IDs (e.g. google → Place ID). Null clears the map; null/empty values clear that provider. Does not require Business Profile OAuth.
   */
  reviewExternalIds?: {
    [key: string]: string | null;
  } | null;
  /**
   * External links (menu URL, Instagram username)
   */
  externalLinks?: Array<ExternalLinkItemDto>;
  /**
   * Contact email for this location
   */
  contactEmail?: string;
  /**
   * Contact phone number for this location
   */
  contactPhone?: string;
  addressDetails?: AddressDetailsDto | null;
  /**
   * Reputation industry preset id (e.g. restaurant, hotel). Null uses the workspace default, then Generic.
   */
  reputationPreset?: string | null;
};

export type UpdateLocationDto = {
  name?: string;
  coordinates?: LocationCoordinatesDto | null;
  /**
   * Per-provider review listing IDs (e.g. google → Place ID). Null clears the map; null/empty values clear that provider. Does not require Business Profile OAuth.
   */
  reviewExternalIds?: {
    [key: string]: string | null;
  } | null;
  /**
   * External links (menu URL, Instagram username)
   */
  externalLinks?: Array<ExternalLinkItemDto>;
  /**
   * Contact email for this location
   */
  contactEmail?: string;
  /**
   * Contact phone number for this location
   */
  contactPhone?: string;
  addressDetails?: AddressDetailsDto | null;
  /**
   * Reputation industry preset id (e.g. restaurant, hotel). Null uses the workspace default, then Generic.
   */
  reputationPreset?: string | null;
  replyPromptConfig?: ReplyPromptConfigDto;
  autoReplyConfig?: AutoReplyConfigDto;
};

export type GooglePlaceDto = {
  /**
   * Google Places API place ID
   */
  id: string;
  name: string;
  address: string;
  /**
   * Place types from Google Places API.
   */
  types?: Array<string>;
  latitude?: number;
  longitude?: number;
  postalCode?: string;
  street?: string;
  streetNumber?: string;
  locality?: string;
  administrativeArea?: string;
  administrativeAreaLevel2?: string;
  country?: string;
  countryCode?: string;
};

export type AdminLocationSearchResultDto = {
  id: string;
  workspaceId: string;
  name: string;
  address?: string | null;
};

/**
 * Initial status of the lead
 */
export enum LeadStatus {
  NEW = 'new',
  CONTACTED = 'contacted',
  QUALIFIED = 'qualified',
  WON = 'won',
  LOST = 'lost',
}

/**
 * Source of the lead
 */
export enum LeadSource {
  PUBLIC_FORM = 'public_form',
  MANUAL = 'manual',
  BUSINESS_CARD = 'business_card',
  CONTACT_EXCHANGE = 'contact_exchange',
}

/**
 * Lead visibility within the workspace. When omitted, the workspace/profile default applies.
 */
export enum LeadVisibility {
  PRIVATE = 'private',
  WORKSPACE = 'workspace',
}

/**
 * Attachment kind; inferred from mimeType when omitted (business_card must be set explicitly)
 */
export enum LeadAttachmentKind {
  IMAGE = 'image',
  DOCUMENT = 'document',
  BUSINESS_CARD = 'business_card',
}

export type LeadAttachmentInputDto = {
  /**
   * Uploaded file ID from POST /files/upload
   */
  fileId: string;
  /**
   * Attachment kind; inferred from mimeType when omitted (business_card must be set explicitly)
   */
  kind?: LeadAttachmentKind;
  /**
   * Display name (defaults to uploaded filename when known)
   */
  title?: string | null;
  /**
   * MIME type of the uploaded file
   */
  mimeType?: string | null;
};

export type CreateLeadDto = {
  /**
   * Profile ID that this lead belongs to. Optional for manual leads (allows creating leads without a profile).
   */
  profileId?: string | null;
  /**
   * Workspace ID that this lead belongs to. Required when profileId is omitted; otherwise taken from the profile. Every lead must belong to a workspace.
   */
  workspaceId?: string;
  /**
   * First / given name of the lead
   */
  firstName?: string | null;
  /**
   * Last / family name of the lead
   */
  lastName?: string | null;
  /**
   * Email address
   */
  email?: string | null;
  /**
   * Phone number (E.164 format)
   */
  phone?: string | null;
  /**
   * Workspace/Business name
   */
  companyName?: string | null;
  /**
   * Current role or position
   */
  jobTitle?: string | null;
  /**
   * Postal / street address
   */
  address?: string | null;
  /**
   * Message/Note from the lead
   */
  message?: string | null;
  /**
   * Initial status of the lead
   */
  status?: LeadStatus;
  /**
   * Source of the lead
   */
  source?: LeadSource;
  /**
   * Whether consent was accepted
   */
  consentAccepted?: boolean | null;
  /**
   * Additional field values for custom/dropdown fields
   */
  customFields?: {
    [key: string]: string;
  } | null;
  /**
   * Responsible workspace member (omit = you; null = unassigned)
   */
  assigneeUserId?: string | null;
  /**
   * Lead visibility within the workspace. When omitted, the workspace/profile default applies.
   */
  visibility?: LeadVisibility;
  /**
   * Files to attach when creating the lead (e.g. scanned business card image)
   */
  attachments?: Array<LeadAttachmentInputDto>;
  /**
   * Workspace Event ids to link on create (e.g. adding a lead from an event page). Past events are allowed. Requires feature.lead_events.
   */
  eventIds?: Array<string>;
  /**
   * When true, create the lead even if a contact duplicate already exists (authenticated create only).
   */
  allowDuplicate?: boolean;
};

export type LeadNote = {
  readonly id: string;
  readonly content: string;
  /**
   * User who wrote the note
   */
  authorUserId?: string | null;
  readonly createdAt: string;
  /**
   * Last edit by the author; null when never edited
   */
  updatedAt?: string | null;
};

export type LeadAttachment = {
  readonly id: string;
  kind: LeadAttachmentKind;
  title?: string | null;
  mimeType?: string | null;
  /**
   * User who uploaded the attachment
   */
  uploadedByUserId?: string | null;
  readonly order: number;
  readonly createdAt: string;
  file: FileType;
};

export enum LeadActivityType {
  CREATED = 'created',
  STATUS_CHANGED = 'status_changed',
  DESCRIPTION_UPDATED = 'description_updated',
  FIELD_UPDATED = 'field_updated',
  NOTE_ADDED = 'note_added',
  TAG_ADDED = 'tag_added',
  TAG_REMOVED = 'tag_removed',
  EVENT_ADDED = 'event_added',
  EVENT_REMOVED = 'event_removed',
  ASSIGNEE_CHANGED = 'assignee_changed',
  WORKSPACE_SHARING_UPDATED = 'workspace_sharing_updated',
  ATTACHMENT_ADDED = 'attachment_added',
  ATTACHMENT_REMOVED = 'attachment_removed',
  CONTACTED_VIA = 'contacted_via',
  ARCHIVED = 'archived',
  UNARCHIVED = 'unarchived',
}

export type LeadActivity = {
  readonly id: string;
  type: LeadActivityType;
  /**
   * User who performed the action
   */
  actorUserId?: string | null;
  readonly createdAt: string;
};

/**
 * Present when this lead was returned for a search query.
 */
export enum LeadSearchMatchReason {
  NAME = 'name',
  COMPANY = 'company',
  JOB_TITLE = 'job_title',
  EMAIL = 'email',
  PHONE = 'phone',
  TAG = 'tag',
  EVENT = 'event',
  NOTE = 'note',
  MESSAGE = 'message',
}

export type Lead = {
  readonly id: string;
  /**
   * Profile this lead belongs to. Null or omitted for manual leads without a profile.
   */
  readonly profileId?: string | null;
  /**
   * Record owner (Besitzer). Null when the owner left the workspace or deleted their account; the lead is then workspace-visible.
   */
  userId?: string | null;
  /**
   * Authenticated user who created the record (Erfasst von); null for anonymous public form submissions.
   */
  readonly createdByUserId?: string | null;
  /**
   * Workspace member responsible for this lead (Zuständig)
   */
  readonly assigneeUserId?: string | null;
  readonly workspaceId: string;
  /**
   * Persisted visibility. Workspace always-share policy may make effective visibility workspace on read.
   */
  visibility: LeadVisibility;
  /**
   * When set, the lead is archived (hidden from default list/board). Not a pipeline status.
   */
  readonly archivedAt?: string | null;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly phone: string;
  readonly companyName: string;
  /**
   * Current role or position
   */
  jobTitle?: string | null;
  /**
   * Postal / street address for CRM and contact export
   */
  address?: string | null;
  readonly message: string;
  /**
   * Internal description for this lead (CRM notes)
   */
  description?: string | null;
  status: LeadStatus;
  /**
   * Position within status for board/list ordering (lower = first). Null until ordered.
   */
  readonly order?: number | null;
  readonly tags: Array<string>;
  /**
   * Linked workspace Event ids (lead-events)
   */
  readonly eventIds?: Array<string>;
  /**
   * Event id → display name for linked and activity-referenced events, including soft-deleted events
   */
  readonly eventNames?: {
    [key: string]: string;
  };
  readonly notes: Array<LeadNote>;
  readonly attachments: Array<LeadAttachment>;
  readonly activity: Array<LeadActivity>;
  source: LeadSource;
  /**
   * Public profile represented by this lead, when applicable
   */
  readonly sourceProfileId?: string | null;
  /**
   * Public profile URL represented by this lead, when applicable
   */
  readonly sourceProfileUrl?: string | null;
  readonly consentAccepted: boolean;
  readonly emailsSentAt: string;
  readonly emailFailureReason: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  /**
   * Present when this lead was returned for a search query.
   */
  matchReasons?: Array<LeadSearchMatchReason>;
  /**
   * Short excerpt when the match was a note (or similar).
   */
  matchExcerpt?: string | null;
};

/**
 * MIME type of the image
 */
export enum BusinessCardScanMimeType {
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_PNG = 'image/png',
  IMAGE_WEBP = 'image/webp',
}

export type ScanBusinessCardDto = {
  /**
   * Base64-encoded image data (without data: URL prefix)
   */
  imageBase64: string;
  /**
   * MIME type of the image
   */
  mimeType?: BusinessCardScanMimeType;
};

export enum BusinessCardFieldScanStatus {
  FOUND = 'found',
  MISSING = 'missing',
}

export type BusinessCardExtractedFieldDto = {
  readonly value: string;
  status: BusinessCardFieldScanStatus;
};

export type ScanBusinessCardResultDto = {
  firstName: BusinessCardExtractedFieldDto;
  lastName: BusinessCardExtractedFieldDto;
  email: BusinessCardExtractedFieldDto;
  phone: BusinessCardExtractedFieldDto;
  companyName: BusinessCardExtractedFieldDto;
  jobTitle: BusinessCardExtractedFieldDto;
  website: BusinessCardExtractedFieldDto;
  address: BusinessCardExtractedFieldDto;
  /**
   * Unused. Job title and website are dedicated Lead fields; do not fold them into notes.
   */
  suggestedMessage?: string | null;
};

export type ExchangeBusinessCardDto = {
  scannerProfileId: string;
  targetProfileId: string;
  firstName: string;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  companyName?: string | null;
  /**
   * Current role or position
   */
  jobTitle?: string | null;
  message?: string | null;
  /**
   * Explicit confirmation of the reciprocal contact exchange
   */
  consentAccepted: boolean;
  /**
   * Existing scanner-side lead to keep after duplicate resolution. Completes the reciprocal exchange without creating another scanner lead.
   */
  resolvedScannerLeadId?: string;
  /**
   * When true, create a new scanner-side lead even if a contact duplicate exists.
   */
  allowDuplicateScannerLead?: boolean;
};

export type ExchangeBusinessCardResponseDto = {
  targetOwnerLead: Lead;
  scannerLead: Lead;
};

export enum LeadListScope {
  MINE = 'mine',
  WORKSPACE = 'workspace',
  OTHERS_PRIVATE = 'others_private',
}

export enum LeadQuerySortBy {
  CREATED_AT = 'createdAt',
  NAME = 'name',
  STATUS = 'status',
  ORDER = 'order',
}

export type LeadScopeCountsDto = {
  mine: number;
  workspace: number;
  /**
   * Only meaningful for workspace admins/owners; else 0.
   */
  othersPrivate: number;
  /**
   * Archived leads hidden from the default inbox for the active list scope (same ACL/filters as the list query).
   */
  archivedHidden: number;
};

export type LeadSearchSuggestionDto = {
  query: string;
  label?: string | null;
};

export type LeadListResponseDto = {
  items: Array<Lead>;
  scopeCounts: LeadScopeCountsDto;
  scope?: LeadListScope;
  /**
   * Fuzzy “did you mean” suggestions when search has no hits.
   */
  suggestions?: Array<LeadSearchSuggestionDto>;
};

export type BulkUpdateLeadsDto = {
  /**
   * Lead IDs to update (max 100)
   */
  leadIds: Array<string>;
  /**
   * Set the same status on all selected leads
   */
  setStatus?: LeadStatus;
  /**
   * Set the same assignee on all selected leads (null = unassigned)
   */
  setAssigneeUserId?: string | null;
  /**
   * Tags to add to each selected lead
   */
  addTags?: Array<string>;
  /**
   * Tags to remove from each selected lead
   */
  removeTags?: Array<string>;
  /**
   * Event ids to add to each selected lead (requires feature.lead_events)
   */
  addEventIds?: Array<string>;
  /**
   * Event ids to remove from each selected lead
   */
  removeEventIds?: Array<string>;
};

export type UpdateLeadDto = {
  /**
   * First / given name of the lead
   */
  firstName?: string;
  /**
   * Last / family name of the lead
   */
  lastName?: string;
  /**
   * Email address
   */
  email?: string | null;
  /**
   * Phone number
   */
  phone?: string | null;
  /**
   * Workspace/Business name
   */
  companyName?: string | null;
  /**
   * Current role or position
   */
  jobTitle?: string | null;
  /**
   * Postal / street address
   */
  address?: string | null;
  /**
   * Message/Note from the lead
   */
  message?: string | null;
  /**
   * Internal description for this lead
   */
  description?: string | null;
  /**
   * Status of the lead
   */
  status?: LeadStatus;
  /**
   * Position within status for board ordering (lower = first)
   */
  order?: number | null;
  /**
   * Tags for the lead
   */
  tags?: Array<string>;
  /**
   * Linked workspace Event ids (full replace). Requires feature.lead_events.
   */
  eventIds?: Array<string>;
  /**
   * Responsible workspace member (null clears assignee / unassigned)
   */
  assigneeUserId?: string | null;
  /**
   * Lead visibility within the workspace
   */
  visibility?: LeadVisibility;
  /**
   * When true, archive the lead (sets archivedAt). When false, restore from archive.
   */
  archived?: boolean;
};

export enum LeadContactChannel {
  CALL = 'call',
  EMAIL = 'email',
  SMS = 'sms',
}

export type ContactLeadViaDto = {
  channel: LeadContactChannel;
  /**
   * Optional note (e.g. call duration)
   */
  detail?: string;
};

export type AddLeadNoteDto = {
  /**
   * Note content
   */
  content: string;
};

export type UpdateLeadNoteDto = {
  /**
   * New note content
   */
  content: string;
};

export type ReorderLeadAttachmentsDto = {
  /**
   * Attachment IDs in the desired display order (must include every attachment on the lead)
   */
  attachmentIds: Array<string>;
};

export type SubmitPublicLeadFormDto = {
  /**
   * First / given name
   */
  firstName: string;
  /**
   * Last / family name (optional for minimal forms)
   */
  lastName?: string | null;
  /**
   * Email address
   */
  email: string;
  /**
   * Phone number
   */
  phone: string;
  /**
   * Workspace/Business name
   */
  companyName?: string | null;
  /**
   * Current role or position
   */
  jobTitle?: string | null;
  /**
   * Message/Note
   */
  message?: string | null;
  /**
   * Whether consent was accepted
   */
  consentAccepted?: boolean | null;
  /**
   * Additional field values for dropdown/custom fields, keyed by field config key
   */
  customFields?: {
    [key: string]: string;
  } | null;
};

export type PublicLeadFormSubmittedDto = {
  submitted: boolean;
};

export enum LeadEventLifecycleStatus {
  ACTIVE = 'active',
  UPCOMING = 'upcoming',
  PAST = 'past',
}

export enum LeadEventRosterMode {
  EVERYONE = 'everyone',
  SELECTED = 'selected',
}

export type LeadEventWithStatusDto = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  location?: string;
  startsAt: string;
  endsAt: string;
  autoTag: string;
  autoTagEnabled: boolean;
  rosterMode: LeadEventRosterMode;
  rosterUserIds: Array<string>;
  rosterTeamIds: Array<string>;
  description?: string | null;
  coverImageAssetId?: string | null;
  readonly createdByUserId: string;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly deletedAt: string;
  status: LeadEventLifecycleStatus;
  coverImage?: FileType | null;
  leadCount: number;
  qualifiedPlusCount: number;
};

export type CreateLeadEventDto = {
  name: string;
  location?: string | null;
  startsAt: string;
  endsAt: string;
  /**
   * Defaults to event name when omitted
   */
  autoTag?: string;
  autoTagEnabled?: boolean;
  rosterMode?: LeadEventRosterMode;
  rosterUserIds?: Array<string>;
  rosterTeamIds?: Array<string>;
  description?: string | null;
  coverImageAssetId?: string | null;
};

export type LeadEventRosterResolvedMemberDto = {
  userId: string;
};

export type LeadEventRosterResolvedDto = {
  totalPeople: number;
  directUserCount: number;
  teamCount: number;
  peopleViaTeams: number;
  members: Array<LeadEventRosterResolvedMemberDto>;
};

export type LeadEventAnalyticsMemberCountDto = {
  userId: string;
  count: number;
};

export type LeadEventAnalyticsDto = {
  totalLeads: number;
  bySource: {
    [key: string]: number;
  };
  byRosterMember: Array<LeadEventAnalyticsMemberCountDto>;
  byStatus: {
    [key: string]: number;
  };
};

export type UpdateLeadEventDto = {
  name?: string;
  location?: string | null;
  startsAt?: string;
  endsAt?: string;
  autoTag?: string;
  autoTagEnabled?: boolean;
  rosterMode?: LeadEventRosterMode;
  rosterUserIds?: Array<string>;
  rosterTeamIds?: Array<string>;
  description?: string | null;
  coverImageAssetId?: string | null;
};

export type UpdateLeadEventRosterDto = {
  rosterMode: LeadEventRosterMode;
  rosterUserIds?: Array<string>;
  rosterTeamIds?: Array<string>;
};

export enum StatusBoardRangeDays {
  _7 = 7,
  _30 = 30,
  _90 = 90,
}

export type StatusBoardCapabilitiesDto = {
  canReadProducts: boolean;
  canManageProducts: boolean;
  canReadLocations: boolean;
  canManageLocations: boolean;
  canReadReputation: boolean;
  canConfigureReputation: boolean;
  canReadFeedback: boolean;
  canReadLeads: boolean;
  canReadProfiles: boolean;
};

export enum StatusBoardPeriodChangeDirection {
  UP = 'up',
  DOWN = 'down',
  FLAT = 'flat',
  NEW = 'new',
}

export type StatusBoardPeriodChangeDto = {
  percent: number | null;
  direction: StatusBoardPeriodChangeDirection;
};

export type StatusBoardScanPointDto = {
  date: string;
  scans: number;
};

export type StatusBoardScanSourceDto = {
  source: ProductScanSource;
  count: number;
};

export type StatusBoardLinkTargetDto = {
  type: ProductBehavior;
  productCount: number;
  scans: number;
  /**
   * Share of products with this type, 0..100.
   */
  share: number;
};

export type StatusBoardTopCardDto = {
  /**
   * Profile-owner user id.
   */
  userId: string;
  name: string;
  initials: string;
  /**
   * Display-ready owner photo URL (LOCAL absolute or S3 presigned). Same resolver as FileType.path.
   */
  avatarPath?: string | null;
  meta?: string | null;
  taps: number;
};

export type StatusBoardProductsDto = {
  totalProducts: number;
  totalScans: number;
  previousPeriodScans: number;
  periodChange: StatusBoardPeriodChangeDto;
  activeProductsCount: number;
  scanSeries: Array<StatusBoardScanPointDto>;
  previousScanSeries: Array<StatusBoardScanPointDto>;
  /**
   * Product-tap breakdown by scan source (qr | nfc | unknown). Empty for member-scoped views without workspace-wide usage series.
   */
  scanSources: Array<StatusBoardScanSourceDto>;
  linkTargets: Array<StatusBoardLinkTargetDto>;
  topBusinessCards: Array<StatusBoardTopCardDto>;
};

export type SentimentSplitDto = {
  positive: number;
  neutral: number;
  negative: number;
};

export type RatingDistributionDto = {
  1: number;
  2: number;
  3: number;
  4: number;
  5: number;
};

export type ReputationKpiPointDto = {
  /**
   * Bucket start (YYYY-MM-DD).
   */
  date: string;
  /**
   * Reputation score after accumulating reviews up to this bucket.
   */
  score: number;
  /**
   * Running average rating up to this bucket, 0..5.
   */
  averageRating: number;
  /**
   * Running respondedTextCount / textReviewCount, 0..1.
   */
  responseRateWithText: number;
  /**
   * New reviews inside this bucket.
   */
  reviewCount: number;
};

export type CriticalReviewDto = {
  id: string;
  locationId: string;
  rating: number;
  text: string;
  authorName: string;
  sourceUpdatedAt: string;
  sentiment: string | null;
  responded: boolean;
};

export type LocationRankDto = {
  locationId: string;
  locationName: string;
  averageRating: number;
  totalReviews: number;
  /**
   * Positive reviews / total, 0..1.
   */
  positiveShare: number;
};

export type LocationRankingDto = {
  top: Array<LocationRankDto>;
  bottom: Array<LocationRankDto>;
};

export enum ReputationInsightSeverity {
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
}

export enum ReputationInsightActionKind {
  INBOX = 'inbox',
  ANALYTICS = 'analytics',
  LOCATION = 'location',
}

export type ReputationInsightActionDto = {
  kind: ReputationInsightActionKind;
  locationId?: string;
  aspect?: string;
  sentiment?: string;
};

export type ReputationInsightDto = {
  /**
   * Stable key for frontend i18n lookup.
   */
  key: string;
  severity: ReputationInsightSeverity;
  params: {
    [key: string]: string | number;
  };
  action?: ReputationInsightActionDto;
};

export enum ReputationScoreConfidence {
  READY = 'ready',
  LOW = 'low',
}

export enum ReputationScoreComponentKey {
  RATING = 'rating',
  VOLUME = 'volume',
  RESPONSE_RATE = 'responseRate',
  SENTIMENT = 'sentiment',
  RESPONSE_SPEED = 'responseSpeed',
}

export type ReputationScoreComponentDto = {
  key: ReputationScoreComponentKey;
  /**
   * Weight in the composite (0..1). Sum of active weights is 1.
   */
  weight: number;
  /**
   * Component sub-score before weighting, 0..100.
   */
  value: number;
  /**
   * Weighted contribution to the final score (value × weight).
   */
  contribution: number;
};

export type ReputationScoreDto = {
  /**
   * Composite reputation score, 0..100.
   */
  score: number;
  scoreConfidence: ReputationScoreConfidence;
  /**
   * Formula version — any weight change bumps this (customer-visible).
   */
  scoreVersion: string;
  scoreComponents: Array<ReputationScoreComponentDto>;
};

export enum CompetitorTeaserReadiness {
  NONE = 'none',
  PARTIAL = 'partial',
  READY = 'ready',
}

export type CompetitorTeaserAggregateDto = {
  /**
   * Review-weighted average rating across tracked locations.
   */
  yourAverageRating: number;
  /**
   * Total synced reviews across tracked locations.
   */
  yourReviewCount: number;
  /**
   * Mean competitor rating across all tracked comparisons.
   */
  fieldAverageRating?: number;
  /**
   * Comparisons where your rating is ahead of the competitor.
   */
  aheadCount: number;
  /**
   * Comparisons where the competitor rating is ahead of yours.
   */
  behindCount: number;
  /**
   * Comparisons treated as tied (gap within epsilon).
   */
  tiedCount: number;
};

export type CompetitorTeaserHighlightDto = {
  locationId: string;
  locationName: string;
  competitorName: string;
  yourRating?: number;
  competitorRating?: number;
  /**
   * Synced review count for your location.
   */
  yourReviewCount?: number;
  /**
   * Google Places total review count for the competitor.
   */
  competitorReviewCount?: number;
  /**
   * competitorRating − yourRating (positive = competitor ahead).
   */
  ratingGap: number;
};

export type CompetitorTeaserDto = {
  status: CompetitorTeaserReadiness;
  /**
   * Locations with at least one tracked competitor.
   */
  trackedLocationCount?: number;
  /**
   * Total locations in the current overview scope.
   */
  totalLocationCount?: number;
  /**
   * Total competitors tracked in the current scope.
   */
  totalCompetitorCount?: number;
  /**
   * Cross-location summary when viewing all locations with multiple tracked sites.
   */
  aggregate?: CompetitorTeaserAggregateDto;
  /**
   * Top comparisons on overview (shows all when few; capped at 5 when many).
   */
  highlights?: Array<CompetitorTeaserHighlightDto>;
  locationId?: string;
  locationName?: string;
  competitorName?: string;
  yourRating?: number;
  competitorRating?: number;
  /**
   * competitorRating − yourRating (positive = competitor ahead).
   */
  ratingGap?: number;
};

export type ReputationOverviewDto = {
  /**
   * Unreplied low-rating or negative reviews across all synced reviews.
   */
  unrepliedCriticalCount: number;
  /**
   * Active reviews not yet seen in the workspace inbox (explicit seenAt null). Used for nav attention badges.
   */
  unseenCount: number;
  totalReviews: number;
  averageRating: number;
  sentimentSplit: SentimentSplitDto;
  ratingDistribution: RatingDistributionDto;
  /**
   * Reviews with a published reply.
   */
  respondedCount: number;
  /**
   * respondedCount / totalReviews, 0..1.
   */
  responseRate: number;
  /**
   * Reviews that contain a written comment.
   */
  textReviewCount: number;
  /**
   * Reviews with text that have a published reply.
   */
  respondedTextCount: number;
  /**
   * respondedTextCount / textReviewCount, 0..1.
   */
  responseRateWithText: number;
  /**
   * Running score / rating / response-rate series over the requested window (sparklines).
   */
  kpiSeries: Array<ReputationKpiPointDto>;
  /**
   * Mean hours from review to published reply; null when no reply has a publish time.
   */
  averageResponseHours: number | null;
  recentCritical: Array<CriticalReviewDto>;
  /**
   * Linked Google Business Profile location count.
   */
  linkedLocationCount: number;
  locationCount: number;
  /**
   * Best and worst locations by rating (workspace scope only, min. 2 reviews per location).
   */
  locationRanking: LocationRankingDto;
  /**
   * Linked Google locations with zero synced reviews (visibility gap for Status Board).
   */
  locationsWithoutReviews: Array<LocationRankDto>;
  insights: Array<ReputationInsightDto>;
  score: ReputationScoreDto;
  competitorTeaser: CompetitorTeaserDto;
};

/**
 * ready — summary available; generating — another request is building it; unavailable — AI or cache unavailable.
 */
export enum ReputationSummaryStatus {
  READY = 'ready',
  GENERATING = 'generating',
  UNAVAILABLE = 'unavailable',
}

export type ReputationSummaryDto = {
  /**
   * ready — summary available; generating — another request is building it; unavailable — AI or cache unavailable.
   */
  status: ReputationSummaryStatus;
  /**
   * Short AI-generated narrative summary of current reputation.
   */
  summary?: string;
  /**
   * 1–3 concrete recommended next steps.
   */
  actionItems?: Array<string>;
  /**
   * ISO timestamp when the summary was generated.
   */
  generatedAt?: string;
};

/**
 * Review sync readiness for this channel location.
 */
export enum ChannelSyncStatus {
  NOT_LINKED = 'not_linked',
  PENDING = 'pending',
  SYNCING = 'syncing',
  SYNCED = 'synced',
  FAILED = 'failed',
}

export type ChannelLocationStatusDto = {
  locationId: string;
  /**
   * Provider key, e.g. "google".
   */
  provider: string;
  /**
   * Whether this location is linked on the provider.
   */
  linked: boolean;
  /**
   * Review sync readiness for this channel location.
   */
  syncStatus: ChannelSyncStatus;
  providerLocationId?: string | null;
  placeId?: string | null;
  title?: string | null;
  lastSyncedAt?: string | null;
  lastFullSyncAt?: string | null;
  lastSyncFailedAt?: string | null;
  /**
   * When deferred taxonomy re-analysis may start after a preset change.
   */
  taxonomyReanalysisDueAt?: string | null;
  /**
   * Reviews at this location still pending analysis at the current version.
   */
  pendingAnalysisCount: number;
};

export type StatusBoardLocationRowDto = {
  id: string;
  name?: string | null;
  /**
   * Formatted address, shown under the location name.
   */
  address?: string | null;
};

export type StatusBoardSeriesPointDto = {
  date: string;
  value: number;
};

export type StatusBoardLeadsDto = {
  newCount: number;
  /**
   * Leads created per day in the current rangeDays window.
   */
  createdSeries: Array<StatusBoardSeriesPointDto>;
};

export type FeedbackStatsDto = {
  total: number;
  newCount: number;
  seenCount: number;
  resolvedCount: number;
  /**
   * new + seen (unresolved) for Status Board / Reputation strip
   */
  unrepliedCount: number;
  averageStars?: number | null;
};

export type StatusBoardProfileDto = {
  hasProfile: boolean;
};

export type StatusBoardProfileViewSourceDto = {
  source: ProfileViewSource;
  count: number;
};

export type StatusBoardProfileViewPointDto = {
  date: string;
  views: number;
};

export type StatusBoardProfileViewsDto = {
  totalViews: number;
  previousPeriodViews: number;
  periodChange: StatusBoardPeriodChangeDto;
  sources: Array<StatusBoardProfileViewSourceDto>;
  viewSeries: Array<StatusBoardProfileViewPointDto>;
  previousViewSeries: Array<StatusBoardProfileViewPointDto>;
  /**
   * Count of views with source=product (dual-written from a physical PROFILE card scan) — already included in totalViews.
   */
  viaProductCount: number;
};

export type StatusBoardDto = {
  rangeDays: StatusBoardRangeDays;
  /**
   * First UTC day the plan still shows (`quota.analytics_history_days`). Product scans and profile views before it read as zero; set only when the current or previous window reaches past it (ADR-0025 §4).
   */
  historyLimitedTo?: string;
  /**
   * ISO start of current window.
   */
  periodStart: string;
  /**
   * ISO end of current window.
   */
  periodEnd: string;
  previousPeriodStart: string;
  previousPeriodEnd: string;
  capabilities: StatusBoardCapabilitiesDto;
  products?: StatusBoardProductsDto | null;
  reputation?: ReputationOverviewDto | null;
  reputationSummary?: ReputationSummaryDto | null;
  channelLocations?: Array<ChannelLocationStatusDto> | null;
  locations?: Array<StatusBoardLocationRowDto> | null;
  leads?: StatusBoardLeadsDto | null;
  feedback?: FeedbackStatsDto | null;
  /**
   * Feedback entries created per day in the current rangeDays window.
   */
  feedbackEntrySeries?: Array<StatusBoardSeriesPointDto> | null;
  /**
   * Google review volume per day in the current rangeDays window.
   */
  reviewVolumeSeries?: Array<StatusBoardSeriesPointDto> | null;
  profile?: StatusBoardProfileDto | null;
  profileViews?: StatusBoardProfileViewsDto | null;
};

export enum SentimentPolarity {
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative',
}

export enum ReviewRespondedFilter {
  TRUE = 'true',
  FALSE = 'false',
}

export type ReviewSentimentDto = {
  polarity: SentimentPolarity;
  score: number;
};

export type ReviewAspectDto = {
  /**
   * Stable aspect key (for filtering).
   */
  key: string;
  /**
   * Localized display label for the current locale.
   */
  label: string;
  sentiment: SentimentPolarity;
  score: number;
};

export type ReviewReplyDto = {
  id: string;
  reviewId: string;
  text: string;
  status: string;
  publishedAt?: {
    [key: string]: unknown;
  } | null;
  errorMessage?: {
    [key: string]: unknown;
  } | null;
  createdByAI?: boolean | null;
  autoPublished?: boolean | null;
};

export type ReviewReplyDraftDto = {
  id: string;
  reviewId: string;
  text: string;
  status: string;
  createdByAI?: boolean | null;
  /**
   * Scheduled publish time when status is pending.
   */
  publishDueAt?: {
    [key: string]: unknown;
  } | null;
};

export type ReviewWithReplyDto = {
  id: string;
  locationId: string;
  provider: string;
  providerReviewId: string;
  rating: number;
  text: string;
  authorName: string;
  reviewedAt: string;
  sourceUpdatedAt: string;
  status: string;
  /**
   * ISO timestamp when first seen in-app. null = unseen; omitted on legacy rows treated as seen.
   */
  seenAt?: string | null;
  sentiment?: ReviewSentimentDto | null;
  aspects: Array<ReviewAspectDto>;
  topics: Array<string>;
  reply?: ReviewReplyDto | null;
  replyDraft?: ReviewReplyDraftDto | null;
};

export type ListReviewsResponseDto = {
  reviews: Array<ReviewWithReplyDto>;
};

export type SuggestReplyDto = {
  /**
   * Review ID to generate a reply suggestion for
   */
  reviewId: string;
};

export type SuggestReplyPreviewDto = {
  /**
   * Review IDs to generate reply suggestions for (max 5)
   */
  reviewIds: Array<string>;
  /**
   * Reply style to preview instead of the saved one, so Setup can show unsaved edits live. Omit to use the saved workspace/location style.
   */
  replyPromptConfig?: ReplyPromptConfigDto;
};

export type BulkCreateReplyDraftsDto = {
  /**
   * Review IDs to generate AI drafts for (max 25).
   */
  reviewIds: Array<string>;
};

/**
 * pending — job accepted (poll by batchId); completed/failed — batch terminal states.
 */
export enum BulkReplyDraftBatchStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export type BulkReplyDraftResultItemDto = {
  reviewId: string;
  success: boolean;
  draft?: {
    id?: string;
    reviewId?: string;
    text?: string;
    status?: string;
    createdByAI?: boolean;
  };
  error?: string;
};

export type BulkCreateReplyDraftsResponseDto = {
  /**
   * pending — job accepted (poll by batchId); completed/failed — batch terminal states.
   */
  status: BulkReplyDraftBatchStatus;
  /**
   * Batch id for async polling.
   */
  batchId?: string;
  /**
   * Per-review outcomes when status is completed.
   */
  results?: Array<BulkReplyDraftResultItemDto>;
  /**
   * Error message when status is failed.
   */
  error?: string;
};

export type BulkReplyDraftBatchStatusDto = {
  batchId: string;
  status: BulkReplyDraftBatchStatus;
  results?: Array<BulkReplyDraftResultItemDto>;
  error?: string;
};

export type CreateReplyDraftDto = {
  /**
   * Reply text
   */
  text: string;
  /**
   * User who created the draft
   */
  createdByUserId?: string;
  /**
   * Whether created by AI
   */
  createdByAI?: boolean;
  /**
   * AI metadata
   */
  aiMeta?: {
    [key: string]: unknown;
  };
};

export type ReputationPresetDto = {
  id: string;
  /**
   * Localized display label for the preset.
   */
  label: string;
};

export type ReputationPresetListDto = {
  presets: Array<ReputationPresetDto>;
};

export type DriverDto = {
  /**
   * Stable aspect key (for filtering/drilldown).
   */
  key: string;
  /**
   * Localized display label for the current locale.
   */
  label: string;
  sentiment: SentimentPolarity;
  /**
   * Number of reviews mentioning this aspect+sentiment.
   */
  count: number;
  /**
   * Sample review ids for drilldown.
   */
  sampleReviewIds: Array<string>;
};

export type DriversResponseDto = {
  positive: Array<DriverDto>;
  negative: Array<DriverDto>;
};

/**
 * Bucket size for each point in the series.
 */
export enum SentimentTrendGranularity {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
}

export type SentimentTrendRangeDto = {
  /**
   * Inclusive series start (ISO 8601).
   */
  from: string;
  /**
   * Inclusive series end (ISO 8601).
   */
  to: string;
};

export type SentimentTrendPointDto = {
  date: string;
  positive: number;
  neutral: number;
  negative: number;
};

export type SentimentTrendSeriesDto = {
  /**
   * Bucket size for each point in the series.
   */
  granularity: SentimentTrendGranularity;
  range: SentimentTrendRangeDto;
  /**
   * Complete bucket series covering range; missing buckets are zero-filled.
   */
  points: Array<SentimentTrendPointDto>;
};

export type AspectBreakdownDto = {
  /**
   * Stable aspect key (for filtering/drilldown).
   */
  key: string;
  /**
   * Localized display label for the current locale.
   */
  label: string;
  positive: number;
  neutral: number;
  negative: number;
  /**
   * Total mentions across all sentiments.
   */
  total: number;
};

export type TopicCountDto = {
  topic: string;
  count: number;
};

export type LocationBreakdownDto = {
  locationId: string;
  totalReviews: number;
  averageRating: number;
  sentimentSplit: SentimentSplitDto;
  respondedCount: number;
  /**
   * respondedCount / totalReviews, 0..1.
   */
  responseRate: number;
  /**
   * Reviews that contain a written comment.
   */
  textReviewCount: number;
  /**
   * Reviews with text that have a published reply.
   */
  respondedTextCount: number;
  /**
   * respondedTextCount / textReviewCount, 0..1.
   */
  responseRateWithText: number;
  score: ReputationScoreDto;
};

export type AspectHeatmapColumnDto = {
  /**
   * Stable aspect key for inbox drilldown.
   */
  key: string;
  /**
   * Localized display label.
   */
  label: string;
};

export type AspectHeatmapCellDto = {
  key: string;
  /**
   * Positive mentions / total mentions, 0..1. Null when no data.
   */
  positiveShare: number | null;
  total: number;
  /**
   * Positive minus negative mentions (0 when no data).
   */
  net: number;
};

export type AspectHeatmapLocationRowDto = {
  locationId: string;
  cells: Array<AspectHeatmapCellDto>;
};

export type AspectHeatmapDto = {
  /**
   * Column headers — union of aspect keys with mentions in scope (ADR 0005).
   */
  aspects: Array<AspectHeatmapColumnDto>;
  locations: Array<AspectHeatmapLocationRowDto>;
};

export type ReputationAnalyticsDto = {
  totalReviews: number;
  averageRating: number;
  sentimentSplit: SentimentSplitDto;
  ratingDistribution: RatingDistributionDto;
  respondedCount: number;
  /**
   * respondedCount / totalReviews, 0..1.
   */
  responseRate: number;
  /**
   * Reviews that contain a written comment.
   */
  textReviewCount: number;
  /**
   * Reviews with text that have a published reply.
   */
  respondedTextCount: number;
  /**
   * respondedTextCount / textReviewCount, 0..1.
   */
  responseRateWithText: number;
  trend: SentimentTrendSeriesDto;
  /**
   * Running score / rating / response-rate per trend bucket (same buckets as `trend`).
   */
  kpiSeries: Array<ReputationKpiPointDto>;
  aspects: Array<AspectBreakdownDto>;
  topics: Array<TopicCountDto>;
  locations: Array<LocationBreakdownDto>;
  locationCount: number;
  score: ReputationScoreDto;
  /**
   * Location × aspect sentiment matrix (workspace scope, multi-location only).
   */
  heatmap: AspectHeatmapDto;
};

export type PaginatedReviewsResponseDto = {
  reviews: Array<ReviewWithReplyDto>;
  /**
   * Total reviews matching the active filters.
   */
  total: number;
  page: number;
  pageSize: number;
  /**
   * Whether more pages are available.
   */
  hasMore: boolean;
};

export type MarkReviewsSeenDto = {
  /**
   * Specific review ids to mark seen. Omit or empty to mark all unseen reviews in the workspace scope.
   */
  reviewIds?: Array<string>;
};

export type MarkReviewsSeenResponseDto = {
  /**
   * Number of reviews updated from unseen to seen.
   */
  markedCount: number;
};

export type CompetitorTrendPointDto = {
  date: string;
  rating?: number;
  reviewCount?: number;
};

export type OwnLocationCompareDto = {
  averageRating: number;
  totalReviews: number;
  /**
   * Rating change over the selected period (end − start).
   */
  ratingDelta?: number;
  /**
   * Review count change over the selected period (end − start).
   */
  reviewCountDelta?: number;
  /**
   * Cumulative average rating by day from synced reviews (for trend chart).
   */
  periodTrend?: Array<CompetitorTrendPointDto>;
};

export type CompetitorSampledReviewDto = {
  authorName: string;
  rating: number;
  text: string;
  relativeTimeDescription?: string;
  publishedAt?: string;
};

export enum CompetitorPollStatus {
  OK = 'ok',
  STALE = 'stale',
  ERROR = 'error',
}

export type CompetitorCompareItemDto = {
  id: string;
  competitorPlaceId: string;
  name: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  rating?: number;
  reviewCount?: number;
  sampledReviews: Array<CompetitorSampledReviewDto>;
  lastPolledAt?: string;
  pollStatus: CompetitorPollStatus;
  ratingDelta?: number;
  reviewCountDelta?: number;
  /**
   * Trend points within the selected period.
   */
  periodTrend: Array<CompetitorTrendPointDto>;
};

export type CompetitorCompareDto = {
  locationId: string;
  locationName: string;
  own: OwnLocationCompareDto;
  competitors: Array<CompetitorCompareItemDto>;
  /**
   * Explains Places-only competitor data limits (ADR 0004). Present when competitors exist.
   */
  dataLimitationNote: string;
};

export type CompetitorCompareListDto = {
  locations: Array<CompetitorCompareDto>;
};

export type ChannelLocationStatusListDto = {
  channelLocations: Array<ChannelLocationStatusDto>;
};

export enum IntegrationProvider {
  GOOGLE = 'google',
  TRUSTPILOT = 'trustpilot',
}

export type IntegrationStatusDto = {
  provider: IntegrationProvider;
  connected: boolean;
  metadata?: {
    [key: string]: unknown;
  };
};

export type IntegrationsListResponseDto = {
  integrations: Array<IntegrationStatusDto>;
};

export type LinkGooglePlaceDto = {
  /**
   * Google Places API place ID to link. If omitted, location.reviewExternalIds.google is used.
   */
  placeId?: string;
  /**
   * GBP resource name (accounts/.../locations/...). If provided, placeId is not resolved from API.
   */
  googleBusinessLocationName?: string;
  /**
   * Display title for the linked place.
   */
  title?: string;
};

export type CompetitorBenchmarkDto = {
  id: string;
  competitorPlaceId: string;
  name: string;
  address?: string;
  latitude?: number;
  longitude?: number;
  rating?: number;
  reviewCount?: number;
  sampledReviews: Array<CompetitorSampledReviewDto>;
  lastPolledAt?: string;
  pollStatus: CompetitorPollStatus;
};

export type CompetitorBenchmarkListDto = {
  competitors: Array<CompetitorBenchmarkDto>;
};

export enum CompetitorNearbyRadius {
  _1000 = 1000,
  _3000 = 3000,
  _5000 = 5000,
  _10000 = 10000,
}

export type CompetitorNearbyOwnDto = {
  name: string;
  latitude: number;
  longitude: number;
};

export type CompetitorNearbyPlaceDto = {
  placeId: string;
  name: string;
  address?: string;
  rating?: number;
  reviewCount?: number;
  latitude: number;
  longitude: number;
  types: Array<string>;
  /**
   * True when this place is already a tracked competitor
   */
  alreadyTracked: boolean;
  /**
   * Tracked competitor id when alreadyTracked is true
   */
  competitorId?: string;
};

/**
 * Set when discovery is skipped (e.g. online_store / generic preset)
 */
export enum CompetitorNearbySkipReason {
  UNSUPPORTED_PRESET = 'unsupported_preset',
}

export type CompetitorNearbyListDto = {
  presetId: string;
  radiusMeters: number;
  own: CompetitorNearbyOwnDto;
  places: Array<CompetitorNearbyPlaceDto>;
  /**
   * Set when discovery is skipped (e.g. online_store / generic preset)
   */
  reason?: CompetitorNearbySkipReason;
};

/**
 * ready — briefing available; generating — another request is building it; unavailable — nothing tracked or AI unavailable.
 */
export enum CompetitorBoardSummaryStatus {
  READY = 'ready',
  GENERATING = 'generating',
  UNAVAILABLE = 'unavailable',
}

export type CompetitorBriefingSectionDto = {
  /**
   * Short verdict, e.g. "Level on rating".
   */
  headline: string;
  /**
   * One or two sentences with concrete numbers.
   */
  body: string;
};

export type CompetitorBoardSummaryDto = {
  /**
   * ready — briefing available; generating — another request is building it; unavailable — nothing tracked or AI unavailable.
   */
  status: CompetitorBoardSummaryStatus;
  /**
   * How your rating compares with tracked competitors.
   */
  quality?: CompetitorBriefingSectionDto;
  /**
   * How your review volume compares with tracked competitors.
   */
  volume?: CompetitorBriefingSectionDto;
  /**
   * The most effective next lever to close the gap.
   */
  lever?: CompetitorBriefingSectionDto;
  /**
   * ISO timestamp when the briefing was generated.
   */
  generatedAt?: string;
};

export type AddCompetitorDto = {
  /**
   * Google Places place ID for the competitor
   */
  competitorPlaceId: string;
  name: string;
  address?: string;
  /**
   * Latitude from nearby discovery (optional; poll may backfill)
   */
  latitude?: number;
  /**
   * Longitude from nearby discovery (optional; poll may backfill)
   */
  longitude?: number;
};

export enum FeedbackStatus {
  NEW = 'new',
  SEEN = 'seen',
  RESOLVED = 'resolved',
}

export type FeedbackAnswer = {
  questionId: string;
  /**
   * Answer value — string, number, boolean, or string[]
   */
  value: {
    [key: string]: unknown;
  };
  questionLabel?: string;
};

export type FeedbackNote = {
  authorUserId: string;
  body: string;
  createdAt: string;
};

export enum FeedbackSource {
  INVITE = 'invite',
  PRODUCT = 'product',
  API = 'api',
}

export type Feedback = {
  readonly id: string;
  readonly workspaceId: string;
  locationId: string;
  inviteId?: string | null;
  recipientId?: string | null;
  productId?: string | null;
  scanId?: string | null;
  stars: number;
  comment?: string | null;
  answers: Array<FeedbackAnswer>;
  status: FeedbackStatus;
  notes: Array<FeedbackNote>;
  source: FeedbackSource;
  guestEmail?: string | null;
  guestName?: string | null;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export type PatchFeedbackEntryDto = {
  status?: FeedbackStatus;
  /**
   * Internal merchant note (not visible to recipient)
   */
  note?: string;
};

export type FeedbackContact = {
  readonly id: string;
  readonly workspaceId: string;
  email: string;
  name?: string | null;
  feedbackMailOptOut: boolean;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export type FeedbackQuestion = {
  id: string;
  type: FeedbackQuestionType;
  label: string;
  required: boolean;
  options?: Array<string>;
};

export type FeedbackFormTemplate = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  description?: string | null;
  title: string;
  questions: Array<FeedbackQuestion>;
  showUp2promoBranding: boolean;
  accentColor?: string | null;
  isStarter: boolean;
  readonly createdByUserId: string;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export type CreateFeedbackFormTemplateDto = {
  name: string;
  description?: string | null;
  title: string;
  questions?: Array<FeedbackQuestionDto>;
  /**
   * Whether to show up2promo branding on the public collector. Default true. Only Plus+ may set false.
   */
  showUp2promoBranding?: boolean;
  /**
   * Accent color for the guest feedback form. Channel Blue when omitted.
   */
  accentColor?: string | null;
};

export type UpdateFeedbackFormTemplateDto = {
  name?: string;
  description?: string | null;
  title?: string;
  questions?: Array<FeedbackQuestionDto>;
  /**
   * Whether to show up2promo branding on the public collector. Only Plus+ may set false.
   */
  showUp2promoBranding?: boolean;
  /**
   * Accent color for the guest feedback form. Channel Blue when omitted.
   */
  accentColor?: string | null;
};

export enum FeedbackInviteLocale {
  DE = 'de',
  EN = 'en',
}

export type FeedbackInviteReminder = {
  delayDays: number;
  subject?: string | null;
  body?: string | null;
};

export type FeedbackMailTemplate = {
  readonly id: string;
  readonly workspaceId: string;
  name: string;
  description?: string | null;
  locale: FeedbackInviteLocale;
  subject: string;
  body: string;
  accentColor?: string | null;
  reminders: Array<FeedbackInviteReminder>;
  isStarter: boolean;
  readonly createdByUserId: string;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export type FeedbackInviteReminderDto = {
  delayDays: number;
  subject?: string | null;
  body?: string | null;
};

export type CreateFeedbackMailTemplateDto = {
  name: string;
  description?: string | null;
  locale?: FeedbackInviteLocale;
  subject: string;
  body: string;
  /**
   * Accent color for the guest feedback email button. Channel Blue when omitted.
   */
  accentColor?: string | null;
  reminders?: Array<FeedbackInviteReminderDto>;
};

export type UpdateFeedbackMailTemplateDto = {
  name?: string;
  description?: string | null;
  locale?: FeedbackInviteLocale;
  subject?: string;
  body?: string;
  /**
   * Accent color for the guest feedback email button. Channel Blue when omitted.
   */
  accentColor?: string | null;
  reminders?: Array<FeedbackInviteReminderDto>;
};

export enum FeedbackInviteStatus {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  SENDING = 'sending',
  ACTIVE = 'active',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export type FeedbackInviteBrandingSnapshot = {
  logoUrl?: string | null;
  accentColor?: string | null;
  mailAccentColor?: string | null;
  workspaceName?: string | null;
  showUp2promoBranding?: boolean;
};

export type FeedbackInvite = {
  readonly id: string;
  readonly workspaceId: string;
  locationId: string;
  mode: FeedbackInviteMode;
  reviewThreshold: number;
  locale: FeedbackInviteLocale;
  title: string;
  contextLabel?: string | null;
  subject: string;
  body: string;
  sendAt?: string | null;
  reminders: Array<FeedbackInviteReminder>;
  expiryDays: number;
  expiresAt?: string | null;
  status: FeedbackInviteStatus;
  questions: Array<FeedbackQuestion>;
  formTemplateId?: string | null;
  mailTemplateId?: string | null;
  brandingSnapshot?: FeedbackInviteBrandingSnapshot;
  readonly createdByUserId: string;
  firstSentAt?: string | null;
  /**
   * Recipient count for list rows (enriched on list endpoints)
   */
  recipientCount?: number;
  /**
   * Completed recipient count for list rows
   */
  completedCount?: number;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export type FeedbackInviteRecipientInputDto = {
  email: string;
  name?: string | null;
};

export type CreateFeedbackInviteDto = {
  locationId: string;
  mode: FeedbackInviteMode;
  reviewThreshold?: number;
  locale?: FeedbackInviteLocale;
  /**
   * Hydrates title + questions snapshot from a form template
   */
  formTemplateId?: string;
  /**
   * Hydrates subject/body/reminders/locale from a mail template
   */
  mailTemplateId?: string;
  /**
   * Required when formTemplateId is omitted
   */
  title?: string;
  contextLabel?: string | null;
  /**
   * Required when mailTemplateId is omitted
   */
  subject?: string;
  /**
   * Required when mailTemplateId is omitted
   */
  body?: string;
  /**
   * null / omitted = send on confirm
   */
  sendAt?: string | null;
  reminders?: Array<FeedbackInviteReminderDto>;
  expiryDays?: number;
  questions?: Array<FeedbackQuestionDto>;
  recipients: Array<FeedbackInviteRecipientInputDto>;
};

export enum FeedbackInviteRecipientStatus {
  PENDING = 'pending',
  SENT = 'sent',
  OPENED = 'opened',
  COMPLETED = 'completed',
  BOUNCED = 'bounced',
  UNSUBSCRIBED = 'unsubscribed',
  EXPIRED = 'expired',
}

export type FeedbackInviteRecipient = {
  readonly id: string;
  readonly workspaceId: string;
  readonly inviteId: string;
  contactId: string;
  /**
   * Invite-time display name; not rewritten when the contact is later renamed.
   */
  name?: string | null;
  token: string;
  status: FeedbackInviteRecipientStatus;
  completedAt?: string | null;
  reviewCtaClickedAt?: string | null;
  initialSentAt?: string | null;
  reminder1SentAt?: string | null;
  reminder2SentAt?: string | null;
  lastError?: string | null;
  lastResendAt?: string | null;
  canResend?: boolean;
  resendAvailableAt?: string | null;
  readonly createdAt: string;
  readonly updatedAt: string;
};

export type FeedbackInviteDetailDto = {
  readonly id: string;
  readonly workspaceId: string;
  locationId: string;
  mode: FeedbackInviteMode;
  reviewThreshold: number;
  locale: FeedbackInviteLocale;
  title: string;
  contextLabel?: string | null;
  subject: string;
  body: string;
  sendAt?: string | null;
  reminders: Array<FeedbackInviteReminder>;
  expiryDays: number;
  expiresAt?: string | null;
  status: FeedbackInviteStatus;
  questions: Array<FeedbackQuestion>;
  formTemplateId?: string | null;
  mailTemplateId?: string | null;
  brandingSnapshot?: FeedbackInviteBrandingSnapshot;
  readonly createdByUserId: string;
  firstSentAt?: string | null;
  /**
   * Recipient count for list rows (enriched on list endpoints)
   */
  recipientCount?: number;
  /**
   * Completed recipient count for list rows
   */
  completedCount?: number;
  readonly createdAt: string;
  readonly updatedAt: string;
  recipients: Array<FeedbackInviteRecipient>;
};

export type SendFeedbackInvitePreviewDto = {
  locationId: string;
  formTemplateId: string;
  mailTemplateId: string;
};

export type FeedbackInvitePreviewSentDto = {
  sentTo: string;
};

export type UpdateFeedbackInviteDto = {
  locationId?: string;
  mode?: FeedbackInviteMode;
  reviewThreshold?: number;
  locale?: FeedbackInviteLocale;
  title?: string;
  contextLabel?: string | null;
  subject?: string;
  body?: string;
  sendAt?: string | null;
  reminders?: Array<FeedbackInviteReminderDto>;
  expiryDays?: number;
  questions?: Array<FeedbackQuestionDto>;
};

export enum PublicFeedbackTokenState {
  READY = 'ready',
  ALREADY_SUBMITTED = 'already_submitted',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
  DIRECT_REVIEW = 'direct_review',
}

export type PublicFeedbackBrandingDto = {
  workspaceName?: string | null;
  logoUrl?: string | null;
  accentColor?: string | null;
  locationDisplayName?: string | null;
};

export type PublicFeedbackTokenResponseDto = {
  state: PublicFeedbackTokenState;
  mode?: FeedbackInviteMode;
  reviewThreshold?: number;
  locale?: FeedbackInviteLocale;
  title?: string;
  contextLabel?: string | null;
  questions?: Array<FeedbackQuestion>;
  branding?: PublicFeedbackBrandingDto;
  /**
   * Whether to show up2promo branding on the public collector. Default true.
   */
  showUp2promoBranding?: boolean;
  /**
   * When mode is feedback_then_optional_review, whether CTA is eligible after submit based on stars
   */
  showReviewCtaAfterSubmit?: boolean;
  /**
   * Whether the collector should show the optional comment field. False for stars-only forms (no custom questions).
   */
  collectComment?: boolean;
  /**
   * Whether submit creates a Feedback inbox document. False for product stars-only gate-to-Google funnels.
   */
  persistFeedback?: boolean;
};

export type SubmitFeedbackAnswerDto = {
  questionId: string;
  /**
   * string | number | boolean | string[]
   */
  value: string | number | boolean | Array<string>;
};

export type SubmitPublicFeedbackDto = {
  stars: number;
  comment?: string | null;
  answers?: Array<SubmitFeedbackAnswerDto>;
};

export type PublicFeedbackSubmitResponseDto = {
  /**
   * Created Feedback id when persistFeedback was true; omitted when stars-only gate skipped persistence.
   */
  feedbackId?: string | null;
  /**
   * Whether collector should show optional Google CTA
   */
  showReviewCta: boolean;
};

export type GuidanceProgressDto = {
  tours: {
    [key: string]: unknown;
  };
  checklists: {
    [key: string]: unknown;
  };
  hints: {
    [key: string]: unknown;
  };
  announcements: {
    [key: string]: unknown;
  };
  adoption: {
    [key: string]: unknown;
  };
  storage: {
    [key: string]: string;
  };
};

export type UpdateGuidanceProgressDto = {
  /**
   * Workspace id for user×workspace scope; omit for user scope
   */
  workspaceId?: string | null;
  tours?: {
    [key: string]: unknown;
  };
  checklists?: {
    [key: string]: unknown;
  };
  hints?: {
    [key: string]: unknown;
  };
  announcements?: {
    [key: string]: unknown;
  };
  adoption?: {
    [key: string]: unknown;
  };
  storage?: {
    [key: string]: string;
  };
};

export type BillingOpsMrrDto = {
  currency: string;
  mrrMinor: number;
  arrMinor: number;
  subscriptions: number;
};

export type BillingOpsSubscriptionCountDto = {
  status: SubscriptionStatus;
  plan: WorkspacePlan;
  count: number;
};

export type BillingOpsFailedPaymentCountsDto = {
  last24h: number;
  last7d: number;
};

export type BillingOpsMovementDto = {
  newSubscriptions: number;
  newMrrMinor: number;
  trialConversions: number;
  churnedSubscriptions: number;
  churnedMrrMinor: number;
  trialsCanceled: number;
  failedPayments: number;
};

export type BillingOpsMovementWindowsDto = {
  last7d: BillingOpsMovementDto;
  last30d: BillingOpsMovementDto;
};

export type BillingOpsGrantCountDto = {
  reason: BillingGrantReason;
  plan: BillingGrantPlan;
  count: number;
};

export type BillingOpsSubscriptionRowDto = {
  workspaceId: string;
  workspaceName: string | null;
  plan: WorkspacePlan;
  status: SubscriptionStatus;
  billingCycle: BillingCycle;
  trialEnd?: string | null;
  currentPeriodEnd?: string | null;
  endsAt?: string | null;
  stripeCustomerUrl: string;
  stripeSubscriptionUrl: string;
};

export type BillingOpsFailedPaymentDto = {
  workspaceId: string | null;
  workspaceName: string | null;
  occurredAt: string;
  amountMinor: number | null;
  currency: string | null;
  attempt: number | null;
  stripeSubscriptionUrl: string | null;
};

export type BillingOpsOverviewDto = {
  generatedAt: string;
  stripeEnabled: boolean;
  priceCatalogReady: boolean;
  livemode: boolean;
  mrr: Array<BillingOpsMrrDto>;
  unpricedSubscriptions: number;
  subscriptions: Array<BillingOpsSubscriptionCountDto>;
  failedPayments: BillingOpsFailedPaymentCountsDto;
  movement: BillingOpsMovementWindowsDto;
  grants: Array<BillingOpsGrantCountDto>;
  trialsEndingSoon: Array<BillingOpsSubscriptionRowDto>;
  cancelScheduled: Array<BillingOpsSubscriptionRowDto>;
  pastDue: Array<BillingOpsSubscriptionRowDto>;
  recentFailedPayments: Array<BillingOpsFailedPaymentDto>;
};

export type GrowthKpiWindowsDto = {
  today: string;
  last7Days: string;
  last30Days: string;
};

export enum GrowthKpiKey {
  SIGNUPS = 'signups',
  NEW_WORKSPACES = 'newWorkspaces',
  ACTIVE_USERS = 'activeUsers',
  SCANS = 'scans',
  LEADS = 'leads',
  PROFILES_PUBLISHED = 'profilesPublished',
  TRIALS_STARTED = 'trialsStarted',
}

export type GrowthKpiDto = {
  key: GrowthKpiKey;
  today: number;
  last7Days: number;
  last30Days: number;
};

export type GrowthKpisDto = {
  generatedAt: string;
  from: GrowthKpiWindowsDto;
  kpis: Array<GrowthKpiDto>;
};

export type IntegrationSyncFreshnessDto = {
  provider: IntegrationProvider;
  total: number;
  /**
   * Synced in the last 24 h
   */
  under1d: number;
  /**
   * Synced 24–48 h ago
   */
  from1to2d: number;
  /**
   * Synced 2–7 days ago
   */
  from2to7d: number;
  /**
   * Synced more than 7 days ago
   */
  over7d: number;
  /**
   * Never synced
   */
  never: number;
  /**
   * Not synced for 48 h, or never synced 1 h after linking
   */
  stale: number;
  /**
   * Last sync run failed
   */
  failing: number;
  syncing: number;
};

export type IntegrationSyncLocationDto = {
  channelLocationId: string;
  provider: IntegrationProvider;
  title: string | null;
  workspaceId: string;
  workspaceName: string | null;
  /**
   * False when the workspace has no OAuth credentials for it
   */
  connected: boolean;
  lastSyncedAt: string | null;
  lastSyncFailedAt: string | null;
  syncInProgress: boolean;
  linkedAt: string;
};

export type IntegrationSyncAttentionDto = {
  total: number;
  items: Array<IntegrationSyncLocationDto>;
};

export type IntegrationSyncDto = {
  freshness: Array<IntegrationSyncFreshnessDto>;
  attention: IntegrationSyncAttentionDto;
};

export type IntegrationQueueFailuresDto = {
  queue: string;
  today: number;
  last7Days: number;
};

export enum AiUsageFeature {
  REVIEW_ANALYSIS = 'review_analysis',
  REVIEW_REPLY_SUGGESTION = 'review_reply_suggestion',
  REPUTATION_SUMMARY = 'reputation_summary',
  COMPETITOR_SUMMARY = 'competitor_summary',
  BUSINESS_CARD_SCAN = 'business_card_scan',
}

export type AiUsageFeatureCountsDto = {
  feature: AiUsageFeature;
  calls: number;
  errors: number;
  promptTokens: number;
  completionTokens: number;
};

export type AiUsageDayDto = {
  date: string;
  features: Array<AiUsageFeatureCountsDto>;
};

export type OpenAiUsageDto = {
  configured: boolean;
  available: boolean;
  days: Array<AiUsageDayDto>;
};

export type IntegrationHealthDto = {
  generatedAt: string;
  sync: IntegrationSyncDto;
  failures: Array<IntegrationQueueFailuresDto>;
  openAi: OpenAiUsageDto;
};

export type BillbeeShippingId = {
  BillbeeId: number;
  ShippingId: string;
  Shipper: string;
  Created: string;
  TrackingUrl: string;
  ShippingProviderId: number;
  ShippingProviderProductId: number;
  ShippingCarrier: number;
  ShipmentType: number;
};

export type BillbeeComment = {
  Id: number;
  FromCustomer: boolean;
  Text: string;
  Name: string;
  Created: string;
};

export type BillbeeOrderAddress = {
  BillbeeId: number;
  FirstName: string;
  LastName: string;
  Company: string;
  NameAddition?: {
    [key: string]: unknown;
  };
  Street: string;
  HouseNumber: string;
  Zip: string;
  City: string;
  CountryISO2: string;
  Country: string;
  Line2: string;
  Email: string;
  State: string;
  Phone?: string;
};

export type BillbeeProduct = {
  OldId?: {
    [key: string]: unknown;
  };
  Id?: {
    [key: string]: unknown;
  };
  Title: string;
  Weight?: number;
  SKU?: string;
  SkuOrId?: string;
  IsDigital?: boolean;
  Images?: {
    [key: string]: unknown;
  };
  EAN?: string;
  PlatformData?: {
    [key: string]: unknown;
  };
  TARICCode?: {
    [key: string]: unknown;
  };
  CountryOfOrigin?: {
    [key: string]: unknown;
  };
  BillbeeId?: number;
  Type?: number;
};

export type BillbeeAttribute = {
  Id: string;
  Name: string;
  Value?: string;
  Price: number;
};

export type BillbeeOrderItem = {
  BillbeeId: number;
  TransactionId?: string;
  Product: BillbeeProduct;
  Quantity: number;
  TotalPrice: number;
  TaxAmount: number;
  TaxIndex: number;
  Discount: number;
  Attributes: Array<BillbeeAttribute>;
  GetPriceFromArticleIfAny: boolean;
  IsCoupon: boolean;
  ShippingProfileId?: {
    [key: string]: unknown;
  };
  DontAdjustStock: boolean;
  UnrebatedTotalPrice: number;
  SerialNumber?: {
    [key: string]: unknown;
  };
  InvoiceSKU?: string;
};

export type BillbeeSeller = {
  Platform: string;
  BillbeeShopName: string;
  BillbeeShopId: number;
  Id: string;
  Nick?: {
    [key: string]: unknown;
  };
  FirstName?: {
    [key: string]: unknown;
  };
  LastName?: {
    [key: string]: unknown;
  };
  FullName: string;
  Email: string;
};

export type BillbeeDefaultMailAddress = {
  Id: number;
  TypeId: number;
  TypeName: string;
  SubType: string;
  Value: string;
};

export type BillbeeDefaultPhone1 = {
  Id: number;
  TypeId: number;
  TypeName: string;
  SubType: string;
  Value: string;
};

export type BillbeeMetaOrder = {
  Id: number;
  TypeId: number;
  TypeName: string;
  SubType: string;
  Value: string;
};

export type BillbeeCustomer = {
  Id: number;
  Name: string;
  Email: string;
  Tel1?: string;
  Tel2?: {
    [key: string]: unknown;
  };
  Number: number;
  PriceGroupId?: {
    [key: string]: unknown;
  };
  LanguageId?: {
    [key: string]: unknown;
  };
  DefaultMailAddress: BillbeeDefaultMailAddress;
  DefaultCommercialMailAddress?: {
    [key: string]: unknown;
  };
  DefaultStatusUpdatesMailAddress?: {
    [key: string]: unknown;
  };
  DefaultPhone1?: BillbeeDefaultPhone1;
  DefaultPhone2?: {
    [key: string]: unknown;
  };
  DefaultFax?: {
    [key: string]: unknown;
  };
  VatId?: {
    [key: string]: unknown;
  };
  Type?: {
    [key: string]: unknown;
  };
  MetaData: Array<BillbeeMetaOrder>;
  ArchivedAt?: {
    [key: string]: unknown;
  };
  RestoredAt?: {
    [key: string]: unknown;
  };
};

export type BillbeeHistory = {
  Created: string;
  EventTypeName: string;
  Text: string;
  EmployeeName?: {
    [key: string]: unknown;
  };
  TypeId: number;
};

export type BillbeePayment = {
  BillbeeId: number;
  TransactionId: string;
  PayDate: string;
  PaymentType: number;
  SourceTechnology: string;
  SourceText: string;
  PayValue: number;
  Purpose: string;
  Name: string;
};

export type BillbeeOrder = {
  RebateDifference: number;
  ShippingIds: Array<BillbeeShippingId>;
  AcceptLossOfReturnRight: boolean;
  Id: string;
  OrderNumber: string;
  State: number;
  VatMode: number;
  CreatedAt: string;
  ShippedAt?: string;
  ConfirmedAt?: {
    [key: string]: unknown;
  };
  PayedAt: string;
  SellerComment?: string;
  Comments: Array<BillbeeComment>;
  InvoiceNumberPrefix: string;
  InvoiceNumberPostfix?: string;
  InvoiceNumber?: number;
  InvoiceDate?: string;
  InvoiceAddress: BillbeeOrderAddress;
  ShippingAddress: BillbeeOrderAddress;
  PaymentMethod: number;
  ShippingCost: number;
  TotalCost: number;
  AdjustmentCost: number;
  AdjustmentReason?: {
    [key: string]: unknown;
  };
  OrderItems: Array<BillbeeOrderItem>;
  Currency: string;
  Seller: BillbeeSeller;
  Buyer?: {
    [key: string]: unknown;
  };
  UpdatedAt?: {
    [key: string]: unknown;
  };
  TaxRate1: number;
  TaxRate2: number;
  BillBeeOrderId: number;
  BillBeeParentOrderId?: {
    [key: string]: unknown;
  };
  VatId?: {
    [key: string]: unknown;
  };
  Tags: Array<string>;
  ShipWeightKg: number;
  LanguageCode?: {
    [key: string]: unknown;
  };
  PaidAmount: number;
  ShippingProfileId?: {
    [key: string]: unknown;
  };
  ShippingProviderId: number;
  ShippingProviderProductId: number;
  ShippingProviderName: string;
  ShippingProviderProductName: string;
  ShippingProfileName?: {
    [key: string]: unknown;
  };
  Customer: BillbeeCustomer;
  History: Array<BillbeeHistory>;
  Payments: Array<BillbeePayment>;
};

export type BillbeePackingBlockingSku = {
  sku: string;
  needed: number;
  available: number;
  warehouseStock: number;
};

export type BillbeePackingOrderEntry = {
  order: BillbeeOrder;
  isPackable: boolean;
  blockingSkus: Array<BillbeePackingBlockingSku>;
};

export type BillbeePackingOrdersResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: Array<BillbeePackingOrderEntry>;
};

export type SearchBillbeeOrdersDto = {
  /**
   * Search term used by Billbee to look up orders by order number, customer name, invoice number or external reference.
   */
  term: string;
};

export type BillbeeOrderSearchResult = {
  /**
   * Internal Billbee order id
   */
  Id: number;
  /**
   * External reference (marketplace order id)
   */
  ExternalReference?: string;
  BuyerName?: string;
  InvoiceNumber?: string;
  CustomerName?: string;
  ArticleTexts?: string;
};

export type BillbeeSearchOrdersResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: Array<BillbeeOrderSearchResult>;
};

export type BillbeeOrderResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: BillbeeOrder;
};

export type BillbeeDimensionDto = {
  /**
   * Package length in centimeters
   */
  length?: number;
  /**
   * Package width in centimeters
   */
  width?: number;
  /**
   * Package height in centimeters
   */
  height?: number;
};

export type ShipBillbeeOrderDto = {
  /**
   * Selected package dimensions forwarded to Billbee when printing the label
   */
  dimension?: BillbeeDimensionDto;
};

export type BillbeeShipOrderResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: {
    [key: string]: unknown;
  };
};

export type BillbeeAddress = {
  Id: number;
  AddressType: number;
  CustomerId: number;
  Company?: string;
  FirstName?: string;
  LastName?: string;
  Name2?: string;
  Street: string;
  Housenumber: string;
  Zip: string;
  City: string;
  State?: string;
  CountryCode: string;
  Email?: string;
  Tel1?: string;
  Tel2?: string;
  Fax?: string;
  AddressAddition?: string;
  ArchivedAt?: string;
  RestoredAt?: string;
};

export type BillbeeQueryAddressResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: BillbeeAddress;
};

export type BillbeeUpdateAddressResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: BillbeeAddress;
};

export type BillbeeStockItem = {
  sku: string;
  billbeeId?: number;
  title?: string;
  stockCurrent: number;
  stockWarning?: number;
  stockDesired?: number;
  stockId?: number;
};

export type BillbeeStockListResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data: Array<BillbeeStockItem>;
};

export type UpdateBillbeeStockDto = {
  /**
   * Product SKU in Billbee
   */
  sku: string;
  /**
   * New absolute stock quantity
   */
  newQuantity: number;
  /**
   * Optional reason for the stock change
   */
  reason?: string;
  /**
   * Optional stock location id when multi-stock is enabled
   */
  stockId?: number;
};

export type BillbeeUpdateStockResult = {
  sku?: string;
  currentStock?: number;
  message?: string;
  unfulfilledAmount?: number;
};

export type BillbeeUpdateStockResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data?: BillbeeUpdateStockResult;
};

export type UpdateBillbeeStockBulkItemDto = {
  sku: string;
  newQuantity: number;
};

export type UpdateBillbeeStockBulkDto = {
  items: Array<UpdateBillbeeStockBulkItemDto>;
  /**
   * Reason applied to all stock updates (defaults to Inventur)
   */
  reason?: string;
};

export type BillbeeUpdateStockBulkResponse = {
  ErrorMessage: {
    [key: string]: unknown;
  };
  ErrorCode: number;
  ErrorDescription: string;
  Data?: Array<BillbeeUpdateStockResult>;
};

export enum OrderChannel {
  SHOPIFY = 'SHOPIFY',
  AMAZON = 'AMAZON',
  EBAY = 'EBAY',
  MANUAL = 'MANUAL',
  UNKNOWN = 'UNKNOWN',
}

export type PackOrderExternalIdsDto = {
  billbeeOrderId?: string;
};

export type PackOrderDto = {
  channel: OrderChannel;
  /**
   * Channel order number as printed
   */
  number: string;
  externalIds?: PackOrderExternalIdsDto;
};

export enum SetupMode {
  PRECONFIGURED = 'PRECONFIGURED',
  SELF_SETUP = 'SELF_SETUP',
  UNKNOWN = 'UNKNOWN',
}

export type PackPreconfigureDto = {
  url: string;
  /**
   * Buyer e-mail, stored as the setup contact (claim by e-mail). Packing sends no mail (DEV-797).
   */
  contactEmail?: string;
  contactLocale?: string;
};

export type PackItemDto = {
  /**
   * Product hash (short or RFC UUID)
   */
  hash: string;
  /**
   * Required for setupMode PRECONFIGURED, ignored otherwise
   */
  preconfigure?: PackPreconfigureDto;
  /**
   * The packer confirmed moving a hash already sold for another order (see `REASSIGNED` / `reassignNotConfirmed`)
   */
  confirmReassign?: boolean;
};

export type PackProductsDto = {
  order: PackOrderDto;
  setupMode: SetupMode;
  items: Array<PackItemDto>;
};

export enum PackOutcome {
  RECORDED = 'RECORDED',
  ALREADY_RECORDED = 'ALREADY_RECORDED',
  REASSIGNED = 'REASSIGNED',
  FAILED = 'FAILED',
}

export type PackOrderRefDto = {
  channel: OrderChannel;
  number: string;
};

/**
 * FAILED only
 */
export enum PackFailureReason {
  HASH_INVALID = 'hashInvalid',
  HASH_NOT_REGISTERED = 'hashNotRegistered',
  HASH_ALREADY_CONFIGURED = 'hashAlreadyConfigured',
  HASH_ALREADY_CLAIMED = 'hashAlreadyClaimed',
  REASSIGN_NOT_CONFIRMED = 'reassignNotConfirmed',
  TARGET_INVALID = 'targetInvalid',
  CONTACT_INVALID = 'contactInvalid',
  ORDER_INVALID = 'orderInvalid',
  INTERNAL_ERROR = 'internalError',
}

export type PackItemResultDto = {
  hash: string;
  outcome: PackOutcome;
  /**
   * REASSIGNED / FAILED reassignNotConfirmed: the order the hash was sold for
   */
  previousOrder?: PackOrderRefDto;
  /**
   * FAILED only
   */
  reason?: PackFailureReason;
};

export type PackProductsResultDto = {
  results: Array<PackItemResultDto>;
};

export enum OrderEvent {
  SOLD = 'SOLD',
  RETURNED = 'RETURNED',
}

export enum OrderSource {
  PACKING_STATION = 'PACKING_STATION',
  GOODS_RECEIPT = 'GOODS_RECEIPT',
  MIGRATION = 'MIGRATION',
}

export type ProductOrderEntryDto = {
  channel: OrderChannel;
  number: string;
  externalIds?: {
    [key: string]: string;
  };
  setupMode: SetupMode;
  event: OrderEvent;
  source: OrderSource;
  at: string;
  packedAt?: string;
};

export type ProductOrderSearchHitDto = {
  id: string;
  hash: string;
  state: ProductState;
  workspaceId?: string;
  sku?: string;
  orders: Array<ProductOrderEntryDto>;
};

/**
 * Null for an unknown hash.
 */
export enum AdminLiveScanState {
  BLANK = 'BLANK',
  CONFIGURED_UNOWNED = 'CONFIGURED_UNOWNED',
  CLAIMED = 'CLAIMED',
}

/**
 * Null on backfilled scans (not stored).
 */
export enum AdminLiveScanOutcome {
  REDIRECT = 'redirect',
  SETUP = 'setup',
  ERROR = 'error',
  UNKNOWN = 'unknown',
}

export type AdminLiveScanDto = {
  /**
   * Unique per scan.
   */
  id: string;
  scannedAt: string;
  hash: string;
  productId: string | null;
  /**
   * Null for an unknown hash.
   */
  state: AdminLiveScanState | null;
  label: string | null;
  behavior: string | null;
  form: string | null;
  workspaceId: string | null;
  workspaceName: string | null;
  /**
   * Null on backfilled scans (not stored).
   */
  outcome: AdminLiveScanOutcome | null;
  /**
   * Redirect host + path, or the link-error reason.
   */
  outcomeDetail: string | null;
  /**
   * `qr`, `nfc` or `unknown`.
   */
  source: string;
  os: string | null;
  device: string | null;
  browser: string | null;
  /**
   * Approximate (CloudFront); live events only.
   */
  city: string | null;
  country: string | null;
};

export enum RegistrationKind {
  MANUFACTURING = 'MANUFACTURING',
  GOODS_RECEIPT = 'GOODS_RECEIPT',
  PACKING_STATION = 'PACKING_STATION',
  LEGACY_IMPORT = 'LEGACY_IMPORT',
}

export type ProductRegistrationDto = {
  kind: RegistrationKind;
  at: string;
  batch?: string;
};

export type ProductAdminFulfillmentDto = {
  stage?: FulfillmentStage;
  registration?: ProductRegistrationDto;
  orders: Array<ProductOrderEntryDto>;
};

export enum SetupOrigin {
  SETUP_FRONTEND = 'SETUP_FRONTEND',
  PACKING_STATION = 'PACKING_STATION',
  LEGACY = 'LEGACY',
  ADMIN = 'ADMIN',
}

export type ProductSetupDto = {
  origin: SetupOrigin;
  /**
   * A setup contact e-mail is on file. The address itself is only returned by the audited `GET products-admin/:id/setup-contact`.
   */
  hasContactEmail: boolean;
  contactLocale?: string;
};

export type ProductAdminDto = {
  id: string;
  /**
   * Public printed hash. Immutable.
   */
  hash: string;
  state: ProductState;
  /**
   * Owner workspace (CLAIMED only).
   */
  workspaceId?: string;
  target?: ProductTargetDto;
  item: ProductItemDto;
  fulfillment: ProductAdminFulfillmentDto;
  feedback?: ProductFeedbackDto;
  /**
   * The owner's name for the product.
   */
  label?: string;
  history?: ProductHistoryDto;
  createdAt: string;
  updatedAt: string;
  /**
   * Scans in the last `includeScansDays` days (list only).
   */
  scanCount?: number;
  /**
   * Daily scans for `includeScanSeriesDays` days (list only).
   */
  scanSeries?: Array<ProductScanSeriesPointDto>;
  /**
   * Revision; send it back as `rev` on PATCH to detect concurrent edits.
   */
  rev: number;
  /**
   * CONFIGURED_UNOWNED only.
   */
  setup?: ProductSetupDto;
  /**
   * Platform-only notes.
   */
  notes?: string;
  /**
   * Owner workspace name (admin list only; absent when unowned or the workspace is gone).
   */
  workspaceName?: string;
};

export type InspectEntityRefDto = {
  id: string;
  /**
   * Human-readable label for ops UI (name / username / email).
   */
  label: string;
  name?: string | null;
  username?: string | null;
  email?: string | null;
  address?: string | null;
};

export type InspectProductResponseDto = {
  product: ProductAdminDto;
  /**
   * Live server-resolved redirect URL (same logic as public resolve; no scan event).
   */
  resolvedTargetUrl: string;
  workspace?: InspectEntityRefDto | null;
  /**
   * User of a PROFILE target.
   */
  profile?: InspectEntityRefDto | null;
  location?: InspectEntityRefDto | null;
};

export enum ProductAdminSortField {
  CREATED_AT = 'createdAt',
  UPDATED_AT = 'updatedAt',
  HASH = 'hash',
  STATE = 'state',
  STAGE = 'stage',
  BEHAVIOR = 'behavior',
  FORM = 'form',
  LABEL = 'label',
  WORKSPACE_ID = 'workspaceId',
  CLAIMED_AT = 'claimedAt',
  RELEASE_COUNT = 'releaseCount',
  LAST_RELEASED_AT = 'lastReleasedAt',
}

export type InfinityPaginationProductAdminDtoResponseDto = {
  readonly data: Array<ProductAdminDto>;
  readonly totalPages: number;
  readonly hasNextPage: boolean;
  readonly totalCount: number;
};

export type ProductAdminStatsDto = {
  /**
   * Products matching the filters.
   */
  total: number;
  states: Array<ProductFacetValueDto>;
  stages: Array<ProductFacetValueDto>;
  /**
   * Item behaviour, else the target kind.
   */
  behaviors: Array<ProductFacetValueDto>;
  /**
   * Scans in the last 30 days, of `workspaceId` when given, else platform-wide. Other filters do not apply.
   */
  scansLast30Days: number;
};

export type CreateProductAdminDto = {
  hash: string;
  target: ProductTargetInputDto;
  /**
   * Owner label with `workspaceId`; platform notes without.
   */
  label?: string;
  item?: ProductItemInputDto;
  /**
   * Only with `workspaceId` and a GOOGLE_REVIEW target.
   */
  feedback?: ProductFeedbackInputDto;
  /**
   * Owning workspace; omit for an unowned setup.
   */
  workspaceId?: string;
  /**
   * Setup contact, only without `workspaceId`.
   */
  contact?: ProductContactDto;
};

export type ProductBatchItemInputDto = {
  form?: ProductForm;
  material?: ProductMaterial;
  size?: string;
  color?: string;
  /**
   * Factory language, e.g. `de`.
   */
  language?: string;
  sku?: string;
  behavior: ProductBehavior;
};

export type RegisterProductBatchItemDto = {
  /**
   * Public product hash (short-uuid)
   */
  hash: string;
  item: ProductBatchItemInputDto;
};

export type RegisterProductBatchDto = {
  /**
   * Minted hashes with physical identity (max 1000 per request)
   */
  items: Array<RegisterProductBatchItemDto>;
};

export type RegisterProductBatchFailureDto = {
  hash: string;
  /**
   * Machine-readable reason
   */
  reason: string;
};

export type RegisterProductBatchResultDto = {
  /**
   * Newly created GENERATED rows
   */
  created: number;
  /**
   * Existing AVAILABLE rows updated with identity / GENERATED
   */
  updated: number;
  /**
   * Items that could not be registered
   */
  failed: Array<RegisterProductBatchFailureDto>;
};

export type RegisterProductGoodsReceiptDto = {
  /**
   * Public product URL, e.g. https://up2.page/<hash>?t=GO
   */
  url: string;
  /**
   * Only behavior, form and material are read.
   */
  item?: ProductItemInputDto;
};

export type UpdateProductAdminDto = {
  /**
   * Replaces the target as a unit.
   */
  target?: ProductTargetInputDto;
  /**
   * Owner label on a CLAIMED product; platform notes on an unowned one.
   */
  label?: string;
  feedback?: ProductFeedbackInputDto;
  /**
   * Delete the scan history of this product (fresh statistics after reconfiguration).
   */
  resetUsage?: boolean;
  item?: ProductItemInputDto;
  /**
   * The `rev` the editor loaded. A product at another revision returns 409 (`revConflict`) instead of being overwritten.
   */
  rev?: number;
};

export type ClaimPersonDto = {
  id: string;
  /**
   * First and last name
   */
  name?: string;
  email?: string;
};

/**
 * REJECTED only: internal reason code
 */
export enum ClaimRejectionCode {
  MISSING_PROOF = 'MISSING_PROOF',
  DUPLICATE = 'DUPLICATE',
  OTHER_BUSINESS = 'OTHER_BUSINESS',
  OTHER = 'OTHER',
}

export type AdminClaimRequestViewDto = {
  id: string;
  /**
   * Product hash
   */
  hash: string;
  productId: string;
  workspaceId: string;
  method: ClaimMethod;
  status: ClaimRequestStatus;
  /**
   * EMAIL: masked address the verification mail went to
   */
  maskedEmail?: string;
  /**
   * MANUAL: note for the admin review
   */
  note?: string;
  expiresAt: string;
  lastSentAt?: string;
  /**
   * Verification mails re-sent so far
   */
  resendCount: number;
  /**
   * When the request left PENDING
   */
  resolvedAt?: string;
  /**
   * REJECTED only: the reason the up2promo team gave
   */
  rejectionReason?: string;
  createdAt: string;
  /**
   * The product now (absent if it was deleted)
   */
  product?: ProductAdminDto;
  /**
   * Absent if the workspace is gone
   */
  workspaceName?: string;
  /**
   * Member who asked (absent once the user is purged)
   */
  requestedBy?: ClaimPersonDto;
  /**
   * Platform admin who approved or rejected it
   */
  resolvedBy?: ClaimPersonDto;
  /**
   * REJECTED only: internal reason code
   */
  rejectionCode?: ClaimRejectionCode;
  /**
   * REJECTED only: internal comment
   */
  rejectionComment?: string;
  /**
   * Other unexpired PENDING requests for the same product
   */
  otherPendingCount: number;
};

export type RejectClaimRequestDto = {
  /**
   * Customer-visible reason, shown to the requesting workspace (trimmed)
   */
  reason: string;
  /**
   * Internal reason code (never shown to the workspace)
   */
  code: ClaimRejectionCode;
  /**
   * Internal comment (never shown to the workspace)
   */
  comment?: string;
};

export type ProductSetupContactDto = {
  origin: SetupOrigin;
  /**
   * Personal data; the read is audited.
   */
  contactEmail?: string;
  contactLocale?: string;
};

export type ProductWorkspaceTargetDto = {
  /**
   * The new owning workspace.
   */
  workspaceId: string;
};

export type FileTypeWritable = {
  id: string;
};

export type UserWritable = {
  [key: string]: unknown;
};

export type InfinityPaginationUserResponseDtoWritable = {
  [key: string]: unknown;
};

export type FileResponseDtoWritable = {
  [key: string]: unknown;
};

export type LoginResponseDtoWritable = {
  [key: string]: unknown;
};

export type WorkspaceWritable = {
  defaultLocale: LocaleEnum;
  plan: WorkspacePlan;
  subscriptionStatus?: SubscriptionStatus | null;
  seats: number;
  /**
   * Billed reputation-location add-on quantity from the billing mirror
   */
  reputationLocations: number;
  currentPeriodEnd?: string | null;
  graceUntil?: string | null;
  /**
   * Stripe Customer id for this workspace
   */
  stripeCustomerId?: string | null;
  billingCycle?: BillingCycle | null;
  /**
   * Whether the subscription is set to cancel at period end
   */
  cancelAtPeriodEnd?: boolean;
  scheduledPlan?: WorkspacePlan | null;
  scheduledBillingCycle?: BillingCycle | null;
  scheduledChangeAt?: string | null;
  scheduledChangeType?: PendingPlanChangeKind | null;
  /**
   * Platform-admin billing grant. When active, overrides Stripe for entitlements.
   */
  billingGrant?: BillingGrant | null;
};

export type WorkspaceMembershipDtoWritable = {
  /**
   * Workspace details
   */
  workspace: WorkspaceWritable;
  /**
   * Member role in the workspace
   */
  role: WorkspaceMemberRole;
  /**
   * Membership status
   */
  status: WorkspaceMemberStatus;
};

export type AuthMeResponseDtoWritable = {
  /**
   * User workspace memberships with roles
   */
  workspaceMemberships?: Array<WorkspaceMembershipDtoWritable>;
  /**
   * Present when the session is an admin impersonation of this user
   */
  impersonation?: ImpersonationContextDto;
  /**
   * Whether outbound SMS is configured so phone verification codes can be sent
   */
  smsVerificationAvailable: boolean;
};

export type InfinityPaginationWorkspaceResponseDtoWritable = {
  [key: string]: unknown;
};

export type WorkspaceMemberWithDetailsDtoWritable = {
  role: WorkspaceMemberRole;
  status: WorkspaceMemberStatus;
};

export type WorkspaceMemberWritable = {
  role: WorkspaceMemberRole;
  status: WorkspaceMemberStatus;
};

export type WorkspaceMemberWithUserDtoWritable = {
  role: WorkspaceMemberRole;
  status: WorkspaceMemberStatus;
  /**
   * User details for this workspace member
   */
  user?: UserWritable;
  /**
   * User who invited this member
   */
  invitedByUser?: UserWritable;
  /**
   * Invitee email for privileged viewers (pending invites have no display name)
   */
  email?: string | null;
};

export type InfinityPaginationWorkspaceMemberWithUserDtoResponseDtoWritable = {
  [key: string]: unknown;
};

export type InfinityPaginationWorkspaceMemberLookupRowDtoResponseDtoWritable = {
  [key: string]: unknown;
};

export type MyMembershipDtoWritable = {
  /**
   * Workspace details
   */
  workspace: WorkspaceWritable;
  /**
   * Member role in the workspace
   */
  role: WorkspaceMemberRole;
  /**
   * Custom role id when the member uses a workspace-defined role preset
   */
  customRoleId?: string | null;
  /**
   * Membership status
   */
  status: WorkspaceMemberStatus;
  /**
   * Effective permission set for this membership (empty when not active)
   */
  permissions: Array<Permission>;
};

export type WorkspaceRoleWritable = {
  name: string;
  description?: string;
  /**
   * Catalog permissions granted by this role
   */
  permissions: Array<string>;
  color?: string;
};

export type TeamWithCountsDtoWritable = {
  name: string;
  description?: string;
  color?: string;
};

export type InfinityPaginationTeamWithCountsDtoResponseDtoWritable = {
  [key: string]: unknown;
};

export type TeamWritable = {
  name: string;
  description?: string;
  color?: string;
};

export type TeamMemberWithUserDtoWritable = {
  user?: UserWritable;
};

export type ProfileStylingWritable = {
  layout?: ProfileLayout;
  theme?: ProfileTheme;
  headerStyle?: ProfileHeaderStyle;
  headerImage?: FileTypeWritable | null;
  buttonShape?: ProfileButtonShape;
  accentColor?: string;
};

export type LeadFormFieldWritable = {
  type: LeadFormFieldType;
};

export type ProfileLeadFormWritable = {
  visibilityMode: LeadFormVisibilityMode;
};

export type ProfileCalendlyIntegrationWritable = {
  displayType: CalendlyDisplayType;
};

export type ProfileIntegrationsWritable = {
  [key: string]: unknown;
};

export type ProfileTemplateContentWritable = {
  visibility?: ProfileVisibility;
  language?: ProfileLanguage;
  jobTitle?: string | null;
  company?: string | null;
  location?: string | null;
  title?: string | null;
  showProfileImage?: boolean;
  showUp2promoBranding?: boolean;
  leadsAutoShareWithWorkspace?: boolean;
  modules?: Array<unknown>;
  styling?: ProfileStylingWritable;
  leadForm?: ProfileLeadFormWritable;
  integrations?: ProfileIntegrationsWritable;
};

export type ProfileTemplateWritable = {
  name: string;
  description?: string;
  content: ProfileTemplateContentWritable;
  teamIds: Array<string>;
  /**
   * draft = editable template, member values preparable; published = live; syncing = profile jobs running, member values locked
   */
  publishStatus: ProfileTemplatePublishStatus;
  /**
   * Monotonic revision bumped when content or governance policies change.
   */
  revision: number;
};

export type InfinityPaginationProfileTemplateResponseDtoWritable = {
  [key: string]: unknown;
};

export type ProfileTemplateRevisionSummaryWritable = {
  revision: number;
  name: string;
  description?: string;
  teamIds: Array<string>;
  /**
   * Stable hash of published governance for change detection in lists.
   */
  contentSignature: string;
};

export type ProfileTemplateRevisionWritable = {
  revision: number;
  name: string;
  description?: string;
  teamIds: Array<string>;
  contentSignature: string;
};

export type ProfileModuleWritable = {
  type: ProfileModuleType;
};

export type ProfileWritable = {
  visibility: ProfileVisibility;
  language: ProfileLanguage;
  /**
   * Template revision last applied to this profile (not lock policies).
   */
  profileTemplateSyncedRevision?: number;
  /**
   * True while a template sync job is queued or running.
   */
  profileTemplateSyncPending?: boolean;
};

export type ResolveProfilePublicHashDtoWritable = {
  source: ProfileViewSource;
};

export type ProductListResponseDtoWritable = {
  /**
   * First UTC day the plan still shows (`quota.analytics_history_days`). Set only when `includeScansDays` / `includeScanSeriesDays` were cut (ADR-0025 §4).
   */
  historyLimitedTo?: string;
};

export type ExternalLinkItemWritable = {
  type: ExternalLinkType;
};

export type LocationWritable = {
  [key: string]: unknown;
};

export type InfinityPaginationLocationResponseDtoWritable = {
  [key: string]: unknown;
};

export type LeadNoteWritable = {
  /**
   * User who wrote the note
   */
  authorUserId?: string | null;
  /**
   * Last edit by the author; null when never edited
   */
  updatedAt?: string | null;
};

export type LeadAttachmentWritable = {
  kind: LeadAttachmentKind;
  title?: string | null;
  mimeType?: string | null;
  /**
   * User who uploaded the attachment
   */
  uploadedByUserId?: string | null;
};

export type LeadActivityWritable = {
  type: LeadActivityType;
  /**
   * User who performed the action
   */
  actorUserId?: string | null;
};

export type LeadWritable = {
  /**
   * Record owner (Besitzer). Null when the owner left the workspace or deleted their account; the lead is then workspace-visible.
   */
  userId?: string | null;
  /**
   * Persisted visibility. Workspace always-share policy may make effective visibility workspace on read.
   */
  visibility: LeadVisibility;
  /**
   * Current role or position
   */
  jobTitle?: string | null;
  /**
   * Postal / street address for CRM and contact export
   */
  address?: string | null;
  /**
   * Internal description for this lead (CRM notes)
   */
  description?: string | null;
  status: LeadStatus;
  source: LeadSource;
  /**
   * Present when this lead was returned for a search query.
   */
  matchReasons?: Array<LeadSearchMatchReason>;
  /**
   * Short excerpt when the match was a note (or similar).
   */
  matchExcerpt?: string | null;
};

export type BusinessCardExtractedFieldDtoWritable = {
  status: BusinessCardFieldScanStatus;
};

export type ScanBusinessCardResultDtoWritable = {
  /**
   * Unused. Job title and website are dedicated Lead fields; do not fold them into notes.
   */
  suggestedMessage?: string | null;
};

export type ExchangeBusinessCardResponseDtoWritable = {
  targetOwnerLead: LeadWritable;
  scannerLead: LeadWritable;
};

export type LeadListResponseDtoWritable = {
  items: Array<LeadWritable>;
  scopeCounts: LeadScopeCountsDto;
  scope?: LeadListScope;
  /**
   * Fuzzy “did you mean” suggestions when search has no hits.
   */
  suggestions?: Array<LeadSearchSuggestionDto>;
};

export type LeadEventWithStatusDtoWritable = {
  name: string;
  location?: string;
  startsAt: string;
  endsAt: string;
  autoTag: string;
  autoTagEnabled: boolean;
  rosterMode: LeadEventRosterMode;
  rosterUserIds: Array<string>;
  rosterTeamIds: Array<string>;
  description?: string | null;
  coverImageAssetId?: string | null;
  status: LeadEventLifecycleStatus;
  coverImage?: FileTypeWritable | null;
  leadCount: number;
  qualifiedPlusCount: number;
};

export type FeedbackWritable = {
  locationId: string;
  inviteId?: string | null;
  recipientId?: string | null;
  productId?: string | null;
  scanId?: string | null;
  stars: number;
  comment?: string | null;
  answers: Array<FeedbackAnswer>;
  status: FeedbackStatus;
  notes: Array<FeedbackNote>;
  source: FeedbackSource;
  guestEmail?: string | null;
  guestName?: string | null;
};

export type FeedbackContactWritable = {
  email: string;
  name?: string | null;
  feedbackMailOptOut: boolean;
};

export type FeedbackFormTemplateWritable = {
  name: string;
  description?: string | null;
  title: string;
  questions: Array<FeedbackQuestion>;
  showUp2promoBranding: boolean;
  accentColor?: string | null;
  isStarter: boolean;
};

export type FeedbackMailTemplateWritable = {
  name: string;
  description?: string | null;
  locale: FeedbackInviteLocale;
  subject: string;
  body: string;
  accentColor?: string | null;
  reminders: Array<FeedbackInviteReminder>;
  isStarter: boolean;
};

export type FeedbackInviteWritable = {
  locationId: string;
  mode: FeedbackInviteMode;
  reviewThreshold: number;
  locale: FeedbackInviteLocale;
  title: string;
  contextLabel?: string | null;
  subject: string;
  body: string;
  sendAt?: string | null;
  reminders: Array<FeedbackInviteReminder>;
  expiryDays: number;
  expiresAt?: string | null;
  status: FeedbackInviteStatus;
  questions: Array<FeedbackQuestion>;
  formTemplateId?: string | null;
  mailTemplateId?: string | null;
  brandingSnapshot?: FeedbackInviteBrandingSnapshot;
  firstSentAt?: string | null;
  /**
   * Recipient count for list rows (enriched on list endpoints)
   */
  recipientCount?: number;
  /**
   * Completed recipient count for list rows
   */
  completedCount?: number;
};

export type FeedbackInviteRecipientWritable = {
  contactId: string;
  /**
   * Invite-time display name; not rewritten when the contact is later renamed.
   */
  name?: string | null;
  token: string;
  status: FeedbackInviteRecipientStatus;
  completedAt?: string | null;
  reviewCtaClickedAt?: string | null;
  initialSentAt?: string | null;
  reminder1SentAt?: string | null;
  reminder2SentAt?: string | null;
  lastError?: string | null;
  lastResendAt?: string | null;
  canResend?: boolean;
  resendAvailableAt?: string | null;
};

export type FeedbackInviteDetailDtoWritable = {
  locationId: string;
  mode: FeedbackInviteMode;
  reviewThreshold: number;
  locale: FeedbackInviteLocale;
  title: string;
  contextLabel?: string | null;
  subject: string;
  body: string;
  sendAt?: string | null;
  reminders: Array<FeedbackInviteReminder>;
  expiryDays: number;
  expiresAt?: string | null;
  status: FeedbackInviteStatus;
  questions: Array<FeedbackQuestion>;
  formTemplateId?: string | null;
  mailTemplateId?: string | null;
  brandingSnapshot?: FeedbackInviteBrandingSnapshot;
  firstSentAt?: string | null;
  /**
   * Recipient count for list rows (enriched on list endpoints)
   */
  recipientCount?: number;
  /**
   * Completed recipient count for list rows
   */
  completedCount?: number;
  recipients: Array<FeedbackInviteRecipientWritable>;
};

export type InfinityPaginationProductAdminDtoResponseDtoWritable = {
  [key: string]: unknown;
};

export type GetOpsOverviewData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/overview';
};

export type GetOpsOverviewResponses = {
  200: OpsOverviewDto;
};

export type GetOpsOverviewResponse =
  GetOpsOverviewResponses[keyof GetOpsOverviewResponses];

export type RecomputeOpsMetricsDayData = {
  body: RecomputeOpsMetricsDto;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/metrics/recompute';
};

export type RecomputeOpsMetricsDayResponses = {
  202: OpsMetricsRecomputeResultDto;
};

export type RecomputeOpsMetricsDayResponse =
  RecomputeOpsMetricsDayResponses[keyof RecomputeOpsMetricsDayResponses];

export type GetOpsMetricsSeriesData = {
  body?: never;
  path: {
    domain: OpsMetricsDomain;
  };
  query?: {
    from?: string;
    to?: string;
  };
  url: '/api/v1/admin/ops/metrics/{domain}';
};

export type GetOpsMetricsSeriesResponses = {
  200: OpsMetricsSeriesDto;
};

export type GetOpsMetricsSeriesResponse =
  GetOpsMetricsSeriesResponses[keyof GetOpsMetricsSeriesResponses];

export type GetOpsHealthData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/health';
};

export type GetOpsHealthResponses = {
  200: OpsHealthDto;
};

export type GetOpsHealthResponse =
  GetOpsHealthResponses[keyof GetOpsHealthResponses];

export type GetNotificationsOpsSummaryData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/notifications';
};

export type GetNotificationsOpsSummaryResponses = {
  200: NotificationsOpsSummaryDto;
};

export type GetNotificationsOpsSummaryResponse =
  GetNotificationsOpsSummaryResponses[keyof GetNotificationsOpsSummaryResponses];

export type SearchNotificationDeliveriesData = {
  body: SearchNotificationDeliveriesDto;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/notifications/deliveries/search';
};

export type SearchNotificationDeliveriesResponses = {
  200: NotificationDeliverySearchResultDto;
};

export type SearchNotificationDeliveriesResponse =
  SearchNotificationDeliveriesResponses[keyof SearchNotificationDeliveriesResponses];

export type GetOpsJobsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/jobs';
};

export type GetOpsJobsResponses = {
  200: OpsJobsDto;
};

export type GetOpsJobsResponse = GetOpsJobsResponses[keyof GetOpsJobsResponses];

export type GetOpsJobFailuresData = {
  body?: never;
  path?: never;
  query?: {
    queue?: string;
    from?: string;
    to?: string;
    page?: number;
    limit?: number;
  };
  url: '/api/v1/admin/ops/job-failures';
};

export type GetOpsJobFailuresResponses = {
  200: OpsJobFailurePageDto;
};

export type GetOpsJobFailuresResponse =
  GetOpsJobFailuresResponses[keyof GetOpsJobFailuresResponses];

export type GetOpsJobFailureTrendData = {
  body?: never;
  path?: never;
  query?: {
    queue?: string;
    from?: string;
    to?: string;
  };
  url: '/api/v1/admin/ops/job-failures/trend';
};

export type GetOpsJobFailureTrendResponses = {
  200: OpsJobFailureTrendDto;
};

export type GetOpsJobFailureTrendResponse =
  GetOpsJobFailureTrendResponses[keyof GetOpsJobFailureTrendResponses];

export type RunIntegrityData = {
  body: RunDataIntegrityDto;
  path?: never;
  query?: never;
  url: '/api/v1/admin/data-lifecycle/integrity-runs';
};

export type RunIntegrityResponses = {
  202: unknown;
};

export type ListReportsData = {
  body?: never;
  path?: never;
  query?: {
    limit?: number;
    status?: DataDeletionStatus;
  };
  url: '/api/v1/admin/data-lifecycle/integrity-reports';
};

export type ListReportsResponses = {
  200: Array<DataIntegrityReportDto>;
};

export type ListReportsResponse =
  ListReportsResponses[keyof ListReportsResponses];

export type ListDeletionsData = {
  body?: never;
  path?: never;
  query?: {
    limit?: number;
    status?: DataDeletionStatus;
  };
  url: '/api/v1/admin/data-lifecycle/deletions';
};

export type ListDeletionsResponses = {
  200: Array<DataDeletionLogDto>;
};

export type ListDeletionsResponse =
  ListDeletionsResponses[keyof ListDeletionsResponses];

export type FindAllData = {
  body?: never;
  path?: never;
  query?: {
    page?: number;
    limit?: number;
    filters?: string;
    sort?: string;
  };
  url: '/api/v1/users';
};

export type FindAllResponses = {
  200: InfinityPaginationUserResponseDto;
};

export type FindAllResponse = FindAllResponses[keyof FindAllResponses];

export type CreateData = {
  body: CreateUserDto;
  path?: never;
  query?: never;
  url: '/api/v1/users';
};

export type CreateResponses = {
  201: User;
};

export type CreateResponse = CreateResponses[keyof CreateResponses];

export type RemoveData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/users/{id}';
};

export type RemoveResponses = {
  204: void;
};

export type RemoveResponse = RemoveResponses[keyof RemoveResponses];

export type FindOneData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/users/{id}';
};

export type FindOneResponses = {
  200: User;
};

export type FindOneResponse = FindOneResponses[keyof FindOneResponses];

export type UpdateData = {
  body: UpdateUserDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/users/{id}';
};

export type UpdateResponses = {
  200: User;
};

export type UpdateResponse = UpdateResponses[keyof UpdateResponses];

export type ClearPasswordData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/users/{id}/password';
};

export type ClearPasswordResponses = {
  /**
   * Password cleared; OTP-only again
   */
  200: unknown;
};

export type SetPasswordData = {
  body: AdminSetUserPasswordDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/users/{id}/password';
};

export type SetPasswordResponses = {
  /**
   * Password set for App Review / admin login
   */
  200: unknown;
};

export type GetUsernameProposalsData = {
  body: UsernameProposalRequestDto;
  path?: never;
  query?: never;
  url: '/api/v1/users-public/username/proposals';
};

export type GetUsernameProposalsResponses = {
  200: UsernameProposalResponseDto;
};

export type GetUsernameProposalsResponse =
  GetUsernameProposalsResponses[keyof GetUsernameProposalsResponses];

export type CheckUsernameAvailabilityData = {
  body?: never;
  path: {
    /**
     * Username to check availability for
     */
    username: string;
  };
  query?: {
    /**
     * User ID to exclude from availability check (for updates)
     */
    excludeUserId?: string;
  };
  url: '/api/v1/users-public/username/{username}/available';
};

export type CheckUsernameAvailabilityResponses = {
  200: {
    available?: boolean;
  };
};

export type CheckUsernameAvailabilityResponse =
  CheckUsernameAvailabilityResponses[keyof CheckUsernameAvailabilityResponses];

export type SearchAdminUsersData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Search query (email, name, or username). Required unless `workspaceId` is given.
     */
    q?: string;
    /**
     * Only members of this workspace (profile picker for products, DEV-749).
     */
    workspaceId?: string;
    /**
     * Maximum number of results
     */
    limit?: number;
  };
  url: '/api/v1/admin/users/search';
};

export type SearchAdminUsersResponses = {
  200: Array<AdminUserSearchResultDto>;
};

export type SearchAdminUsersResponse =
  SearchAdminUsersResponses[keyof SearchAdminUsersResponses];

export type UploadFileData = {
  body: {
    file?: Blob | File;
    /**
     * Optional workspace scope (active membership required)
     */
    workspaceId?: string;
  };
  path?: never;
  query?: never;
  url: '/api/v1/files/upload';
};

export type UploadFileResponses = {
  201: FileResponseDto;
};

export type UploadFileResponse = UploadFileResponses[keyof UploadFileResponses];

export type LoginData = {
  body: AuthEmailLoginDto;
  headers: {
    origin: string;
    referer: string;
  };
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/login';
};

export type LoginResponses = {
  200: AuthMagicLinkRequestResponseDto;
};

export type LoginResponse = LoginResponses[keyof LoginResponses];

export type ResolveLoginData = {
  body: AuthEmailLoginResolveDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/login/resolve';
};

export type ResolveLoginResponses = {
  200: AuthLoginResolveResponseDto;
};

export type ResolveLoginResponse =
  ResolveLoginResponses[keyof ResolveLoginResponses];

export type VerifyMagicLinkData = {
  body: AuthMagicLinkVerifyDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/login/verify';
};

export type VerifyMagicLinkResponses = {
  200: LoginResponseDto;
};

export type VerifyMagicLinkResponse =
  VerifyMagicLinkResponses[keyof VerifyMagicLinkResponses];

export type LoginWithPasswordData = {
  body: AuthEmailPasswordLoginDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/login/password';
};

export type LoginWithPasswordResponses = {
  200: LoginResponseDto;
};

export type LoginWithPasswordResponse =
  LoginWithPasswordResponses[keyof LoginWithPasswordResponses];

export type GetPublicConfigData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/public-config';
};

export type GetPublicConfigResponses = {
  200: AuthPublicConfigDto;
};

export type GetPublicConfigResponse =
  GetPublicConfigResponses[keyof GetPublicConfigResponses];

export type RegisterData = {
  body: AuthRegisterLoginDto;
  headers: {
    origin: string;
    referer: string;
  };
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/register';
};

export type RegisterResponses = {
  200: AuthMagicLinkRequestResponseDto;
};

export type RegisterResponse = RegisterResponses[keyof RegisterResponses];

export type ConfirmNewEmailData = {
  body: AuthConfirmEmailDto;
  headers: {
    origin: string;
    referer: string;
  };
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/confirm/new';
};

export type ConfirmNewEmailResponses = {
  /**
   * Email confirmed successfully
   */
  200: unknown;
};

export type DeleteData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/me';
};

export type DeleteResponses = {
  /**
   * Account deletion confirmation email sent
   */
  200: unknown;
};

export type MeData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/me';
};

export type MeResponses = {
  200: AuthMeResponseDto;
};

export type MeResponse = MeResponses[keyof MeResponses];

export type Update2Data = {
  body: AuthUpdateDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/me';
};

export type Update2Responses = {
  200: User;
};

export type Update2Response = Update2Responses[keyof Update2Responses];

export type GetIntercomIdentityData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/intercom-identity';
};

export type GetIntercomIdentityResponses = {
  200: AuthIntercomIdentityResponseDto;
};

export type GetIntercomIdentityResponse =
  GetIntercomIdentityResponses[keyof GetIntercomIdentityResponses];

export type RefreshData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/refresh';
};

export type RefreshResponses = {
  200: RefreshResponseDto;
};

export type RefreshResponse = RefreshResponses[keyof RefreshResponses];

export type LogoutData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/logout';
};

export type LogoutResponses = {
  204: void;
};

export type LogoutResponse = LogoutResponses[keyof LogoutResponses];

export type RequestEmailChangeData = {
  body: AuthRequestEmailChangeDto;
  headers: {
    origin: string;
    referer: string;
  };
  path?: never;
  query?: never;
  url: '/api/v1/auth/email/change/request';
};

export type RequestEmailChangeResponses = {
  /**
   * Email change request sent
   */
  200: unknown;
};

export type RequestPhoneVerificationData = {
  body: AuthPhoneRequestVerificationDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/phone/request-verification';
};

export type RequestPhoneVerificationResponses = {
  /**
   * Phone verification code sent via SMS
   */
  200: unknown;
};

export type VerifyPhoneData = {
  body: AuthPhoneVerifyDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/phone/verify';
};

export type VerifyPhoneResponses = {
  /**
   * Phone number verified successfully
   */
  200: unknown;
};

export type RemovePhoneData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/phone';
};

export type RemovePhoneResponses = {
  /**
   * Phone number removed
   */
  200: unknown;
};

export type StartImpersonationData = {
  body: StartImpersonationDto;
  path?: never;
  query?: never;
  url: '/api/v1/auth/impersonate';
};

export type StartImpersonationResponses = {
  200: LoginResponseDto;
};

export type StartImpersonationResponse =
  StartImpersonationResponses[keyof StartImpersonationResponses];

export type StopImpersonationData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/auth/impersonate/stop';
};

export type StopImpersonationResponses = {
  200: LoginResponseDto;
};

export type StopImpersonationResponse =
  StopImpersonationResponses[keyof StopImpersonationResponses];

export type ConfirmAccountDeletionData = {
  body: AuthConfirmEmailDto;
  headers: {
    origin: string;
    referer: string;
  };
  path?: never;
  query?: never;
  url: '/api/v1/auth/account/delete/confirm';
};

export type ConfirmAccountDeletionResponses = {
  /**
   * Account deleted successfully
   */
  200: unknown;
};

export type CapabilitiesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/notifications/capabilities';
};

export type CapabilitiesResponses = {
  200: NotificationCapabilitiesDto;
};

export type CapabilitiesResponse =
  CapabilitiesResponses[keyof CapabilitiesResponses];

export type RevokeDeviceData = {
  body: RevokeDevicePushTokenDto;
  path?: never;
  query?: never;
  url: '/api/v1/notifications/devices';
};

export type RevokeDeviceResponses = {
  200: RevokeDevicePushTokenResponseDto;
};

export type RevokeDeviceResponse =
  RevokeDeviceResponses[keyof RevokeDeviceResponses];

export type RegisterDeviceData = {
  body: RegisterDevicePushTokenDto;
  path?: never;
  query?: never;
  url: '/api/v1/notifications/devices';
};

export type RegisterDeviceResponses = {
  200: RegisterDevicePushTokenResponseDto;
};

export type RegisterDeviceResponse =
  RegisterDeviceResponses[keyof RegisterDeviceResponses];

export type ListTypesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/notifications/types';
};

export type ListTypesResponses = {
  200: Array<NotificationTypeDefinitionDto>;
};

export type ListTypesResponse = ListTypesResponses[keyof ListTypesResponses];

export type ListInboxData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query: {
    unreadOnly: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/notifications';
};

export type ListInboxResponses = {
  200: Array<UserNotification>;
};

export type ListInboxResponse = ListInboxResponses[keyof ListInboxResponses];

export type UnreadCountData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/notifications/unread-count';
};

export type UnreadCountResponses = {
  200: UnreadNotificationCountDto;
};

export type UnreadCountResponse =
  UnreadCountResponses[keyof UnreadCountResponses];

export type MarkReadData = {
  body?: never;
  path: {
    workspaceId: string;
    notificationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/notifications/{notificationId}/read';
};

export type MarkReadResponses = {
  200: UserNotification;
};

export type MarkReadResponse = MarkReadResponses[keyof MarkReadResponses];

export type MarkAllReadData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/notifications/mark-all-read';
};

export type MarkAllReadResponses = {
  200: MarkAllNotificationsReadResponseDto;
};

export type MarkAllReadResponse =
  MarkAllReadResponses[keyof MarkAllReadResponses];

export type GetUserPreferencesData = {
  body?: never;
  path?: never;
  query: {
    workspaceId: string;
  };
  url: '/api/v1/users/me/notification-preferences';
};

export type GetUserPreferencesResponses = {
  200: unknown;
};

export type UpdateUserPreferencesData = {
  body: UpdateUserNotificationPreferencesDto;
  path?: never;
  query?: never;
  url: '/api/v1/users/me/notification-preferences';
};

export type UpdateUserPreferencesResponses = {
  200: Array<UserNotificationPreferenceDto>;
};

export type UpdateUserPreferencesResponse =
  UpdateUserPreferencesResponses[keyof UpdateUserPreferencesResponses];

export type ApplyPushGrantDefaultsData = {
  body: ApplyPushGrantDefaultsDto;
  path?: never;
  query?: never;
  url: '/api/v1/users/me/push/grant-defaults';
};

export type ApplyPushGrantDefaultsResponses = {
  200: ApplyPushGrantDefaultsResponseDto;
};

export type ApplyPushGrantDefaultsResponse =
  ApplyPushGrantDefaultsResponses[keyof ApplyPushGrantDefaultsResponses];

export type GetTeamStatusData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/workspaces/{id}/team-status';
};

export type GetTeamStatusResponses = {
  200: WorkspaceTeamStatusDto;
};

export type GetTeamStatusResponse =
  GetTeamStatusResponses[keyof GetTeamStatusResponses];

export type GetMyPermissionsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/workspaces/{id}/me/permissions';
};

export type GetMyPermissionsResponses = {
  200: MyWorkspacePermissionsDto;
};

export type GetMyPermissionsResponse =
  GetMyPermissionsResponses[keyof GetMyPermissionsResponses];

export type FindAll2Data = {
  body?: never;
  path?: never;
  query?: {
    page?: number;
    limit?: number;
    filters?: string;
    sort?: string;
  };
  url: '/api/v1/workspaces';
};

export type FindAll2Responses = {
  200: InfinityPaginationWorkspaceResponseDto;
};

export type FindAll2Response = FindAll2Responses[keyof FindAll2Responses];

export type Create2Data = {
  body: CreateWorkspaceDto;
  path?: never;
  query?: never;
  url: '/api/v1/workspaces';
};

export type Create2Responses = {
  201: Workspace;
};

export type Create2Response = Create2Responses[keyof Create2Responses];

export type GetUsernameProposals2Data = {
  body: WorkspaceUsernameProposalRequestDto;
  path?: never;
  query?: never;
  url: '/api/v1/workspaces/username/proposals';
};

export type GetUsernameProposals2Responses = {
  200: WorkspaceUsernameProposalResponseDto;
};

export type GetUsernameProposals2Response =
  GetUsernameProposals2Responses[keyof GetUsernameProposals2Responses];

export type CheckUsernameAvailability2Data = {
  body?: never;
  path: {
    /**
     * Workspace username to check availability for
     */
    username: string;
  };
  query?: {
    /**
     * Workspace ID to exclude from availability check (for updates)
     */
    excludeWorkspaceId?: string;
  };
  url: '/api/v1/workspaces/username/{username}/available';
};

export type CheckUsernameAvailability2Responses = {
  200: {
    available?: boolean;
  };
};

export type CheckUsernameAvailability2Response =
  CheckUsernameAvailability2Responses[keyof CheckUsernameAvailability2Responses];

export type Remove2Data = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{id}';
};

export type Remove2Responses = {
  204: void;
};

export type Remove2Response = Remove2Responses[keyof Remove2Responses];

export type FindOne2Data = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{id}';
};

export type FindOne2Responses = {
  200: Workspace;
};

export type FindOne2Response = FindOne2Responses[keyof FindOne2Responses];

export type Update3Data = {
  body: UpdateWorkspaceDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{id}';
};

export type Update3Responses = {
  200: Workspace;
};

export type Update3Response = Update3Responses[keyof Update3Responses];

export type InviteUserData = {
  body: InviteUserDto;
  headers: {
    origin: string;
    referer: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{id}/invite';
};

export type InviteUserResponses = {
  204: void;
};

export type InviteUserResponse = InviteUserResponses[keyof InviteUserResponses];

export type GetPendingInvitationsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/workspace-invitations/pending';
};

export type GetPendingInvitationsResponses = {
  200: Array<WorkspaceMemberWithDetailsDto>;
};

export type GetPendingInvitationsResponse =
  GetPendingInvitationsResponses[keyof GetPendingInvitationsResponses];

export type AcceptInvitationData = {
  body?: never;
  path: {
    membershipId: string;
  };
  query?: never;
  url: '/api/v1/workspace-invitations/{membershipId}/accept';
};

export type AcceptInvitationResponses = {
  200: WorkspaceMember;
};

export type AcceptInvitationResponse =
  AcceptInvitationResponses[keyof AcceptInvitationResponses];

export type RejectInvitationData = {
  body?: never;
  path: {
    membershipId: string;
  };
  query?: never;
  url: '/api/v1/workspace-invitations/{membershipId}/reject';
};

export type RejectInvitationResponses = {
  200: WorkspaceMember;
};

export type RejectInvitationResponse =
  RejectInvitationResponses[keyof RejectInvitationResponses];

export type FindAll3Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    page?: number;
    limit?: number;
    /**
     * Search query to filter members by name, email, role, or status
     */
    search?: string;
    /**
     * Sort field for the members list
     */
    sortBy?: WorkspaceMemberQuerySortBy;
    /**
     * Sort order
     */
    sortOrder?: QuerySortDirection;
  };
  url: '/api/v1/workspaces/{workspaceId}/members';
};

export type FindAll3Responses = {
  200: InfinityPaginationWorkspaceMemberWithUserDtoResponseDto;
};

export type FindAll3Response = FindAll3Responses[keyof FindAll3Responses];

export type LookupData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    page?: number;
    limit?: number;
    /**
     * Search query to filter members by name, email, role, or status
     */
    search?: string;
    /**
     * Sort field for the members list
     */
    sortBy?: WorkspaceMemberQuerySortBy;
    /**
     * Sort order
     */
    sortOrder?: QuerySortDirection;
  };
  url: '/api/v1/workspaces/{workspaceId}/members/lookup';
};

export type LookupResponses = {
  200: InfinityPaginationWorkspaceMemberLookupRowDtoResponseDto;
};

export type LookupResponse = LookupResponses[keyof LookupResponses];

export type UpdateRoleData = {
  body: UpdateMemberRoleDto;
  path: {
    workspaceId: string;
    memberId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/members/{memberId}/role';
};

export type UpdateRoleResponses = {
  200: WorkspaceMember;
};

export type UpdateRoleResponse = UpdateRoleResponses[keyof UpdateRoleResponses];

export type Remove3Data = {
  body?: never;
  path: {
    workspaceId: string;
    memberId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/members/{memberId}';
};

export type Remove3Responses = {
  204: void;
};

export type Remove3Response = Remove3Responses[keyof Remove3Responses];

export type GetMyMembershipsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/workspace-members/me/memberships';
};

export type GetMyMembershipsResponses = {
  /**
   * Get current user workspace memberships with roles and workspace details
   */
  200: Array<MyMembershipDto>;
};

export type GetMyMembershipsResponse =
  GetMyMembershipsResponses[keyof GetMyMembershipsResponses];

export type GetEntitlementsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/entitlements';
};

export type GetEntitlementsResponses = {
  200: WorkspaceEntitlementsDto;
};

export type GetEntitlementsResponse =
  GetEntitlementsResponses[keyof GetEntitlementsResponses];

export type FindAll4Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/roles';
};

export type FindAll4Responses = {
  200: Array<WorkspaceRoleListItemDto>;
};

export type FindAll4Response = FindAll4Responses[keyof FindAll4Responses];

export type Create3Data = {
  body: CreateWorkspaceRoleDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/roles';
};

export type Create3Responses = {
  201: WorkspaceRole;
};

export type Create3Response = Create3Responses[keyof Create3Responses];

export type Remove4Data = {
  body?: never;
  path: {
    workspaceId: string;
    roleId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/roles/{roleId}';
};

export type Remove4Responses = {
  204: void;
};

export type Remove4Response = Remove4Responses[keyof Remove4Responses];

export type Update4Data = {
  body: UpdateWorkspaceRoleDto;
  path: {
    workspaceId: string;
    roleId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/roles/{roleId}';
};

export type Update4Responses = {
  200: WorkspaceRole;
};

export type Update4Response = Update4Responses[keyof Update4Responses];

export type FindAll5Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    page?: number;
    limit?: number;
    /**
     * Search query to filter teams by name or description
     */
    search?: string;
    /**
     * When true (default for non-privileged callers) returns only teams the caller is a member of. Owners/admins can pass `false` to list every team in the workspace.
     */
    onlyMine?: boolean;
  };
  url: '/api/v1/workspaces/{workspaceId}/teams';
};

export type FindAll5Responses = {
  200: InfinityPaginationTeamWithCountsDtoResponseDto;
};

export type FindAll5Response = FindAll5Responses[keyof FindAll5Responses];

export type Create4Data = {
  body: CreateTeamDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams';
};

export type Create4Responses = {
  201: Team;
};

export type Create4Response = Create4Responses[keyof Create4Responses];

export type Remove5Data = {
  body?: never;
  path: {
    workspaceId: string;
    teamId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}';
};

export type Remove5Responses = {
  204: void;
};

export type Remove5Response = Remove5Responses[keyof Remove5Responses];

export type FindOne3Data = {
  body?: never;
  path: {
    workspaceId: string;
    teamId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}';
};

export type FindOne3Responses = {
  200: TeamWithCountsDto;
};

export type FindOne3Response = FindOne3Responses[keyof FindOne3Responses];

export type Update5Data = {
  body: UpdateTeamDto;
  path: {
    workspaceId: string;
    teamId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}';
};

export type Update5Responses = {
  200: Team;
};

export type Update5Response = Update5Responses[keyof Update5Responses];

export type ListMembersData = {
  body?: never;
  path: {
    workspaceId: string;
    teamId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}/members';
};

export type ListMembersResponses = {
  200: Array<TeamMemberWithUserDto>;
};

export type ListMembersResponse =
  ListMembersResponses[keyof ListMembersResponses];

export type AddMemberData = {
  body: AddTeamMemberDto;
  path: {
    workspaceId: string;
    teamId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}/members';
};

export type AddMemberResponses = {
  201: TeamMemberWithUserDto;
};

export type AddMemberResponse = AddMemberResponses[keyof AddMemberResponses];

export type RemoveMemberData = {
  body?: never;
  path: {
    workspaceId: string;
    teamId: string;
    teamMemberId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/teams/{teamId}/members/{teamMemberId}';
};

export type RemoveMemberResponses = {
  204: void;
};

export type RemoveMemberResponse =
  RemoveMemberResponses[keyof RemoveMemberResponses];

export type FindAll6Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    page?: number;
    limit?: number;
    search?: string;
    /**
     * When true, only templates assigned to teams the viewer belongs to are returned.
     */
    onlyMine?: boolean;
  };
  url: '/api/v1/workspaces/{workspaceId}/profile-templates';
};

export type FindAll6Responses = {
  200: InfinityPaginationProfileTemplateResponseDto;
};

export type FindAll6Response = FindAll6Responses[keyof FindAll6Responses];

export type Create5Data = {
  body: CreateProfileTemplateDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates';
};

export type Create5Responses = {
  201: ProfileTemplate;
};

export type Create5Response = Create5Responses[keyof Create5Responses];

export type Remove6Data = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}';
};

export type Remove6Responses = {
  204: void;
};

export type Remove6Response = Remove6Responses[keyof Remove6Responses];

export type FindOne4Data = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}';
};

export type FindOne4Responses = {
  200: ProfileTemplate;
};

export type FindOne4Response = FindOne4Responses[keyof FindOne4Responses];

export type Update6Data = {
  body: UpdateProfileTemplateDto;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}';
};

export type Update6Responses = {
  200: ProfileTemplate;
};

export type Update6Response = Update6Responses[keyof Update6Responses];

export type PublishData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/publish';
};

export type PublishResponses = {
  200: ProfileTemplate;
};

export type PublishResponse = PublishResponses[keyof PublishResponses];

export type DiscardChangesData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/discard-changes';
};

export type DiscardChangesResponses = {
  200: ProfileTemplate;
};

export type DiscardChangesResponse =
  DiscardChangesResponses[keyof DiscardChangesResponses];

export type ListRevisionsData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/revisions';
};

export type ListRevisionsResponses = {
  200: Array<ProfileTemplateRevisionSummary>;
};

export type ListRevisionsResponse =
  ListRevisionsResponses[keyof ListRevisionsResponses];

export type GetRevisionData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
    revision: number;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/revisions/{revision}';
};

export type GetRevisionResponses = {
  200: ProfileTemplateRevision;
};

export type GetRevisionResponse =
  GetRevisionResponses[keyof GetRevisionResponses];

export type RestoreRevisionData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
    revision: number;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/revisions/{revision}/restore';
};

export type RestoreRevisionResponses = {
  200: ProfileTemplate;
};

export type RestoreRevisionResponse =
  RestoreRevisionResponses[keyof RestoreRevisionResponses];

export type GetMemberValuesData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query: {
    kind: TemplateMemberValueColumnKind;
    key?: string;
    platform?: string;
    entryId?: string;
    moduleId?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/member-values';
};

export type GetMemberValuesResponses = {
  200: BulkMemberValuesResponseDto;
};

export type GetMemberValuesResponse =
  GetMemberValuesResponses[keyof GetMemberValuesResponses];

export type SetMemberValuesData = {
  body: BulkSetMemberValuesDto;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/member-values';
};

export type SetMemberValuesResponses = {
  204: void;
};

export type SetMemberValuesResponse =
  SetMemberValuesResponses[keyof SetMemberValuesResponses];

export type ApplyData = {
  body: ApplyProfileTemplateDto;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/profile-templates/{templateId}/apply';
};

export type ApplyResponses = {
  200: Profile;
};

export type ApplyResponse = ApplyResponses[keyof ApplyResponses];

export type CreateCheckoutSessionData = {
  body: CreateCheckoutSessionDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/billing/checkout-session';
};

export type CreateCheckoutSessionResponses = {
  200: BillingSessionResponseDto;
};

export type CreateCheckoutSessionResponse =
  CreateCheckoutSessionResponses[keyof CreateCheckoutSessionResponses];

export type PreviewPlanChangeData = {
  body: ChangePlanRequestDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/billing/preview-plan-change';
};

export type PreviewPlanChangeResponses = {
  200: PreviewPlanChangeResponseDto;
};

export type PreviewPlanChangeResponse =
  PreviewPlanChangeResponses[keyof PreviewPlanChangeResponses];

export type ChangeSubscriptionPlanData = {
  body: ChangePlanRequestDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/billing/change-plan';
};

export type ChangeSubscriptionPlanResponses = {
  200: ChangeSubscriptionPlanResponseDto;
};

export type ChangeSubscriptionPlanResponse =
  ChangeSubscriptionPlanResponses[keyof ChangeSubscriptionPlanResponses];

export type CancelScheduledPlanChangeData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/billing/cancel-scheduled-change';
};

export type CancelScheduledPlanChangeResponses = {
  200: ChangeSubscriptionPlanResponseDto;
};

export type CancelScheduledPlanChangeResponse =
  CancelScheduledPlanChangeResponses[keyof CancelScheduledPlanChangeResponses];

export type CreatePortalSessionData = {
  body?: CreatePortalSessionDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/billing/portal-session';
};

export type CreatePortalSessionResponses = {
  200: BillingSessionResponseDto;
};

export type CreatePortalSessionResponse =
  CreatePortalSessionResponses[keyof CreatePortalSessionResponses];

export type SearchAdminWorkspacesData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Search query (workspace name, username, or email)
     */
    q: string;
    /**
     * Maximum number of results
     */
    limit?: number;
  };
  url: '/api/v1/admin/workspaces/search';
};

export type SearchAdminWorkspacesResponses = {
  200: Array<AdminWorkspaceSearchResultDto>;
};

export type SearchAdminWorkspacesResponse =
  SearchAdminWorkspacesResponses[keyof SearchAdminWorkspacesResponses];

export type GetBillingGrantContextData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/admin/workspaces/{workspaceId}/billing-grant/context';
};

export type GetBillingGrantContextResponses = {
  200: BillingGrantConflictDto;
};

export type GetBillingGrantContextResponse =
  GetBillingGrantContextResponses[keyof GetBillingGrantContextResponses];

export type RevokeBillingGrantData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/admin/workspaces/{workspaceId}/billing-grant';
};

export type RevokeBillingGrantResponses = {
  204: void;
};

export type RevokeBillingGrantResponse =
  RevokeBillingGrantResponses[keyof RevokeBillingGrantResponses];

export type UpsertBillingGrantData = {
  body: UpsertBillingGrantDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/admin/workspaces/{workspaceId}/billing-grant';
};

export type UpsertBillingGrantResponses = {
  200: AdminWorkspaceSearchResultDto;
};

export type UpsertBillingGrantResponse =
  UpsertBillingGrantResponses[keyof UpsertBillingGrantResponses];

export type Create6Data = {
  body: CreateProfileDto;
  path?: never;
  query?: never;
  url: '/api/v1/profiles';
};

export type Create6Responses = {
  201: Profile;
};

export type Create6Response = Create6Responses[keyof Create6Responses];

export type FindByUserAndWorkspaceData = {
  body?: never;
  path: {
    userId: string;
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/profiles/user/{userId}/workspace/{workspaceId}';
};

export type FindByUserAndWorkspaceResponses = {
  200: Profile;
};

export type FindByUserAndWorkspaceResponse =
  FindByUserAndWorkspaceResponses[keyof FindByUserAndWorkspaceResponses];

export type Remove7Data = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles/{id}';
};

export type Remove7Responses = {
  204: void;
};

export type Remove7Response = Remove7Responses[keyof Remove7Responses];

export type FindOne5Data = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles/{id}';
};

export type FindOne5Responses = {
  200: Profile;
};

export type FindOne5Response = FindOne5Responses[keyof FindOne5Responses];

export type Update7Data = {
  body: UpdateProfileDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles/{id}';
};

export type Update7Responses = {
  200: Profile;
};

export type Update7Response = Update7Responses[keyof Update7Responses];

export type ResyncTemplateData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles/{id}/resync-template';
};

export type ResyncTemplateResponses = {
  200: Profile;
};

export type ResyncTemplateResponse =
  ResyncTemplateResponses[keyof ResyncTemplateResponses];

export type DownloadWalletPassData = {
  body?: never;
  path: {
    /**
     * Profile ID
     */
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles/{id}/wallet-pass';
};

export type DownloadWalletPassResponses = {
  /**
   * Wallet pass file (.pkpass)
   */
  200: Blob | File;
};

export type DownloadWalletPassResponse =
  DownloadWalletPassResponses[keyof DownloadWalletPassResponses];

export type GetWalletCardStatusData = {
  body?: never;
  path: {
    /**
     * Profile ID
     */
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles/{id}/wallet-card';
};

export type GetWalletCardStatusResponses = {
  200: WalletCardStatusDto;
};

export type GetWalletCardStatusResponse =
  GetWalletCardStatusResponses[keyof GetWalletCardStatusResponses];

export type FindByWorkspaceAndUsernameData = {
  body?: never;
  path: {
    /**
     * Workspace username
     */
    workspaceUsername: string;
    /**
     * Username of the profile owner
     */
    username: string;
  };
  query?: never;
  url: '/api/v1/profiles-public/workspace/{workspaceUsername}/username/{username}';
};

export type FindByWorkspaceAndUsernameResponses = {
  200: Profile;
};

export type FindByWorkspaceAndUsernameResponse =
  FindByWorkspaceAndUsernameResponses[keyof FindByWorkspaceAndUsernameResponses];

export type FindByIdData = {
  body?: never;
  path: {
    /**
     * Profile ID
     */
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles-public/id/{id}';
};

export type FindByIdResponses = {
  200: Profile;
};

export type FindByIdResponse = FindByIdResponses[keyof FindByIdResponses];

export type ResolveByPublicHashData = {
  body?: never;
  path: {
    /**
     * Profile publicHash
     */
    hash: string;
  };
  query?: {
    /**
     * View attribution (wallet | qr | …)
     */
    src?: ProfileViewSource;
  };
  url: '/api/v1/profiles-public/hash/{hash}';
};

export type ResolveByPublicHashResponses = {
  200: ResolveProfilePublicHashDto;
};

export type ResolveByPublicHashResponse =
  ResolveByPublicHashResponses[keyof ResolveByPublicHashResponses];

export type FindByWorkspaceIdAndUserIdData = {
  body?: never;
  path: {
    /**
     * Workspace ID
     */
    workspaceId: string;
    /**
     * User ID
     */
    userId: string;
  };
  query?: never;
  url: '/api/v1/profiles-public/workspace/{workspaceId}/user/{userId}';
};

export type FindByWorkspaceIdAndUserIdResponses = {
  200: Profile;
};

export type FindByWorkspaceIdAndUserIdResponse =
  FindByWorkspaceIdAndUserIdResponses[keyof FindByWorkspaceIdAndUserIdResponses];

export type RecordDirectViewData = {
  body?: never;
  path: {
    /**
     * Profile ID
     */
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles-public/id/{id}/view';
};

export type RecordDirectViewResponses = {
  204: void;
};

export type RecordDirectViewResponse =
  RecordDirectViewResponses[keyof RecordDirectViewResponses];

export type DownloadContactVcfData = {
  body?: never;
  path: {
    /**
     * Profile ID
     */
    id: string;
  };
  query?: never;
  url: '/api/v1/profiles-public/id/{id}/contact.vcf';
};

export type DownloadContactVcfResponses = {
  /**
   * Public profile contact card (vCard)
   */
  200: Blob | File;
};

export type DownloadContactVcfResponse =
  DownloadContactVcfResponses[keyof DownloadContactVcfResponses];

export type GetUsageData = {
  body?: never;
  path: {
    workspaceId: string;
    profileId: string;
  };
  query: {
    /**
     * Current Aufrufe window in days (previous window is equal length).
     */
    days: ProfileUsageRangeDays;
  };
  url: '/api/v1/workspaces/{workspaceId}/profiles/{profileId}/usage';
};

export type GetUsageResponses = {
  200: ProfileUsageDto;
};

export type GetUsageResponse = GetUsageResponses[keyof GetUsageResponses];

export type Create7Data = {
  body: CreateProductDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}';
};

export type Create7Responses = {
  201: ProductDto;
};

export type Create7Response = Create7Responses[keyof Create7Responses];

export type CreateWithMailData = {
  body: CreateProductWithMailDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/with-mail';
};

export type CreateWithMailResponses = {
  201: ProductDto;
};

export type CreateWithMailResponse =
  CreateWithMailResponses[keyof CreateWithMailResponses];

export type ListClaimRequestsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    status?: ClaimRequestStatus;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/claim-requests';
};

export type ListClaimRequestsResponses = {
  200: Array<ClaimRequestViewDto>;
};

export type ListClaimRequestsResponse =
  ListClaimRequestsResponses[keyof ListClaimRequestsResponses];

export type CountClaimRequestsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/claim-requests/count';
};

export type CountClaimRequestsResponses = {
  200: ClaimRequestCountDto;
};

export type CountClaimRequestsResponse =
  CountClaimRequestsResponses[keyof CountClaimRequestsResponses];

export type FindAll7Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    /**
     * Free-text search
     */
    filter?: string;
    /**
     * Only products targeting this location
     */
    locationId?: string;
    /**
     * Only PROFILE products of this user
     */
    userId?: string;
    /**
     * Filter by item behaviour (GOOGLE_REVIEW, PROFILE, …); __unknown__ = unknown. Comma-separated or repeated.
     */
    behaviors?: Array<string>;
    /**
     * Filter by form (STAND, CARD, BADGE); __unknown__ = unknown. Comma-separated or repeated.
     */
    forms?: Array<string>;
    /**
     * Filter by material; __unknown__ = unknown. Comma-separated or repeated.
     */
    materials?: Array<string>;
    /**
     * Filter by color; __unknown__ = unknown. Comma-separated or repeated.
     */
    colors?: Array<string>;
    /**
     * Filter by size; __unknown__ = unknown. Comma-separated or repeated.
     */
    sizes?: Array<string>;
    /**
     * Filter by factory language; __unknown__ = unknown. Comma-separated or repeated.
     */
    languages?: Array<string>;
    /**
     * Only products with a known item behaviour (facets always count those only).
     */
    knownOnly?: boolean;
    page?: number;
    limit?: number;
    /**
     * Include per-item scanCount for the last N days (page-scoped aggregation). Cut to the plan history; see `historyLimitedTo`.
     */
    includeScansDays?: number;
    /**
     * Include per-item daily scanSeries for the last N days (page-scoped). Cut to the plan history; see `historyLimitedTo`.
     */
    includeScanSeriesDays?: number;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/search';
};

export type FindAll7Responses = {
  200: ProductListResponseDto;
};

export type FindAll7Response = FindAll7Responses[keyof FindAll7Responses];

export type FindFacetsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    /**
     * Free-text search
     */
    filter?: string;
    /**
     * Only products targeting this location
     */
    locationId?: string;
    /**
     * Only PROFILE products of this user
     */
    userId?: string;
    /**
     * Filter by item behaviour (GOOGLE_REVIEW, PROFILE, …); __unknown__ = unknown. Comma-separated or repeated.
     */
    behaviors?: Array<string>;
    /**
     * Filter by form (STAND, CARD, BADGE); __unknown__ = unknown. Comma-separated or repeated.
     */
    forms?: Array<string>;
    /**
     * Filter by material; __unknown__ = unknown. Comma-separated or repeated.
     */
    materials?: Array<string>;
    /**
     * Filter by color; __unknown__ = unknown. Comma-separated or repeated.
     */
    colors?: Array<string>;
    /**
     * Filter by size; __unknown__ = unknown. Comma-separated or repeated.
     */
    sizes?: Array<string>;
    /**
     * Filter by factory language; __unknown__ = unknown. Comma-separated or repeated.
     */
    languages?: Array<string>;
    /**
     * Only products with a known item behaviour (facets always count those only).
     */
    knownOnly?: boolean;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/facets';
};

export type FindFacetsResponses = {
  200: ProductFacetsDto;
};

export type FindFacetsResponse = FindFacetsResponses[keyof FindFacetsResponses];

export type FindOneByHashData = {
  body?: never;
  path: {
    workspaceId: string;
    hash: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/hash/{hash}';
};

export type FindOneByHashResponses = {
  200: ProductDto;
};

export type FindOneByHashResponse =
  FindOneByHashResponses[keyof FindOneByHashResponses];

export type ResolveProductHashData = {
  body?: never;
  path: {
    workspaceId: string;
    hash: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/hash/{hash}/resolution';
};

export type ResolveProductHashResponses = {
  200: ProductHashResolutionDto;
};

export type ResolveProductHashResponse =
  ResolveProductHashResponses[keyof ResolveProductHashResponses];

export type Remove8Data = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/{id}';
};

export type Remove8Responses = {
  204: void;
};

export type Remove8Response = Remove8Responses[keyof Remove8Responses];

export type FindOne6Data = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/{id}';
};

export type FindOne6Responses = {
  200: ProductDto;
};

export type FindOne6Response = FindOne6Responses[keyof FindOne6Responses];

export type Update8Data = {
  body: UpdateProductDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/{id}';
};

export type Update8Responses = {
  200: ProductDto;
};

export type Update8Response = Update8Responses[keyof Update8Responses];

export type FindScansData = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: {
    days?: number;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/{id}/scans';
};

export type FindScansResponses = {
  200: ProductScansDto;
};

export type FindScansResponse = FindScansResponses[keyof FindScansResponses];

export type ClaimRequestData = {
  body: ClaimRequestDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/claim-request';
};

export type ClaimRequestResponses = {
  200: ClaimRequestResponseDto;
};

export type ClaimRequestResponse =
  ClaimRequestResponses[keyof ClaimRequestResponses];

export type ClaimRequestManualData = {
  body: ClaimRequestManualDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/claim-request/manual';
};

export type ClaimRequestManualResponses = {
  201: ClaimRequestViewDto;
};

export type ClaimRequestManualResponse =
  ClaimRequestManualResponses[keyof ClaimRequestManualResponses];

export type ResendClaimRequestData = {
  body: ClaimResendDto;
  path: {
    workspaceId: string;
    requestId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/claim-requests/{requestId}/resend';
};

export type ResendClaimRequestResponses = {
  200: ClaimRequestResponseDto;
};

export type ResendClaimRequestResponse =
  ResendClaimRequestResponses[keyof ResendClaimRequestResponses];

export type CancelClaimRequestData = {
  body?: never;
  path: {
    workspaceId: string;
    requestId: string;
  };
  query?: never;
  url: '/api/v1/products/workspaces/{workspaceId}/claim-requests/{requestId}/cancel';
};

export type CancelClaimRequestResponses = {
  200: ClaimRequestViewDto;
};

export type CancelClaimRequestResponse =
  CancelClaimRequestResponses[keyof CancelClaimRequestResponses];

export type SummarizeEventsByMetadataFieldData = {
  body: ProductUsageSummarizedBodyDto;
  path: {
    workspaceId: string;
  };
  query: {
    limit: number;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/usage/summarize';
};

export type SummarizeEventsByMetadataFieldResponses = {
  200: Array<ProductUsageDataDto>;
};

export type SummarizeEventsByMetadataFieldResponse =
  SummarizeEventsByMetadataFieldResponses[keyof SummarizeEventsByMetadataFieldResponses];

export type FindTopUsedData = {
  body: ProductUsageBodyDto;
  path: {
    workspaceId: string;
  };
  query: {
    limit: number;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/usage/top-used';
};

export type FindTopUsedResponses = {
  200: Array<ProductUsageDataDto>;
};

export type FindTopUsedResponse =
  FindTopUsedResponses[keyof FindTopUsedResponses];

export type FindRecentScansData = {
  body: ProductUsageBodyDto;
  path: {
    workspaceId: string;
  };
  query: {
    limit: number;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/usage/recent-scans';
};

export type FindRecentScansResponses = {
  200: Array<ProductUsageDataDto>;
};

export type FindRecentScansResponse =
  FindRecentScansResponses[keyof FindRecentScansResponses];

export type FindUsageTimeSeriesData = {
  body: ProductUsageBodyDto;
  path: {
    workspaceId: string;
  };
  query: {
    granularity: string;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/usage/time-series';
};

export type FindUsageTimeSeriesResponses = {
  200: Array<ProductUsageDataDto>;
};

export type FindUsageTimeSeriesResponse =
  FindUsageTimeSeriesResponses[keyof FindUsageTimeSeriesResponses];

export type FindOneByHashOnlyData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/products-public/hash/{hash}';
};

export type FindOneByHashOnlyResponses = {
  200: PublicProductDto;
};

export type FindOneByHashOnlyResponse =
  FindOneByHashOnlyResponses[keyof FindOneByHashOnlyResponses];

export type ResolveTargetUrlData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/products-public/hash/{hash}/resolve';
};

export type ResolveTargetUrlResponses = {
  200: ResolveProductResponseDto;
};

export type ResolveTargetUrlResponse =
  ResolveTargetUrlResponses[keyof ResolveTargetUrlResponses];

export type SetupProductData = {
  body: SetupProductDto;
  path?: never;
  query?: never;
  url: '/api/v1/products-public/setup';
};

export type SetupProductResponses = {
  201: PublicProductDto;
};

export type SetupProductResponse =
  SetupProductResponses[keyof SetupProductResponses];

export type VerifyAndDeleteResetCodeData = {
  body?: never;
  path: {
    /**
     * Reset code (UUID) to verify and release product
     */
    resetCode: string;
  };
  query?: never;
  url: '/api/v1/products-public/reset/{resetCode}';
};

export type VerifyAndDeleteResetCodeResponses = {
  200: VerifyResetCodeResponseDto;
};

export type VerifyAndDeleteResetCodeResponse =
  VerifyAndDeleteResetCodeResponses[keyof VerifyAndDeleteResetCodeResponses];

export type ClaimVerifyData = {
  body: ClaimVerifyDto;
  path?: never;
  query?: never;
  url: '/api/v1/products-public/claim/verify';
};

export type ClaimVerifyResponses = {
  200: ClaimVerifyResponseDto;
};

export type ClaimVerifyResponse =
  ClaimVerifyResponses[keyof ClaimVerifyResponses];

export type ListProductEventsData = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: {
    /**
     * `nextCursor` of the previous page. Omit for the newest page.
     */
    cursor?: string;
    limit?: number;
  };
  url: '/api/v1/products/workspaces/{workspaceId}/{id}/events';
};

export type ListProductEventsResponses = {
  200: ProductEventPageDto;
};

export type ListProductEventsResponse =
  ListProductEventsResponses[keyof ListProductEventsResponses];

export type ListProductEventsAdminData = {
  body?: never;
  path: {
    id: string;
  };
  query?: {
    /**
     * `nextCursor` of the previous page. Omit for the newest page.
     */
    cursor?: string;
    limit?: number;
  };
  url: '/api/v1/products-admin/{id}/events';
};

export type ListProductEventsAdminResponses = {
  200: ProductEventPageDto;
};

export type ListProductEventsAdminResponse =
  ListProductEventsAdminResponses[keyof ListProductEventsAdminResponses];

export type FindAll8Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    page?: number;
    limit?: number;
    filters?: string;
    sort?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/locations';
};

export type FindAll8Responses = {
  200: InfinityPaginationLocationResponseDto;
};

export type FindAll8Response = FindAll8Responses[keyof FindAll8Responses];

export type Create8Data = {
  body: CreateLocationDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations';
};

export type Create8Responses = {
  201: Location;
};

export type Create8Response = Create8Responses[keyof Create8Responses];

export type GetReplyPromptTemplatesData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/reply-prompt-templates';
};

export type GetReplyPromptTemplatesResponses = {
  /**
   * Liste der Vorlagen für KI-Antworten (Kontext pro Standort)
   */
  200: Array<{
    id?: string;
    name?: string;
    description?: string;
    context?: string;
    tone?: string;
    considerations?: string;
    mustInclude?: string;
  }>;
};

export type GetReplyPromptTemplatesResponse =
  GetReplyPromptTemplatesResponses[keyof GetReplyPromptTemplatesResponses];

export type Remove9Data = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{id}';
};

export type Remove9Responses = {
  204: void;
};

export type Remove9Response = Remove9Responses[keyof Remove9Responses];

export type FindById2Data = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{id}';
};

export type FindById2Responses = {
  200: Location;
};

export type FindById2Response = FindById2Responses[keyof FindById2Responses];

export type Update9Data = {
  body: UpdateLocationDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{id}';
};

export type Update9Responses = {
  200: Location;
};

export type Update9Response = Update9Responses[keyof Update9Responses];

export type SearchGooglePlacesData = {
  body?: never;
  headers?: {
    /**
     * Fallback result language when `language` is omitted.
     */
    'x-custom-lang'?: string;
  };
  path?: never;
  query: {
    /**
     * Search query for Google Places
     */
    input: string;
    /**
     * When true, only return establishments and points of interest (excludes address-only predictions). Default false.
     */
    establishmentPoiOnly?: boolean;
    /**
     * When false, return autocomplete predictions only (id, name, address, types) without the billable Place Details per result; resolve the picked place via `google-places/{placeId}`. Default true.
     */
    includeDetails?: boolean;
    /**
     * Result language as locale (e.g. `de`, `en`, `de-AT`). Falls back to the `x-custom-lang` header, then German (`de`), like maps.google.de.
     */
    language?: string;
  };
  url: '/api/v1/locations-public/google-places/search';
};

export type SearchGooglePlacesResponses = {
  200: Array<GooglePlaceDto>;
};

export type SearchGooglePlacesResponse =
  SearchGooglePlacesResponses[keyof SearchGooglePlacesResponses];

export type GetGooglePlaceByIdData = {
  body?: never;
  headers?: {
    /**
     * Fallback result language when `language` is omitted.
     */
    'x-custom-lang'?: string;
  };
  path: {
    placeId: string;
  };
  query?: {
    /**
     * Result language as locale (e.g. `de`, `en`, `de-AT`). Falls back to the `x-custom-lang` header, then German (`de`), like maps.google.de.
     */
    language?: string;
  };
  url: '/api/v1/locations-public/google-places/{placeId}';
};

export type GetGooglePlaceByIdResponses = {
  200: GooglePlaceDto;
};

export type GetGooglePlaceByIdResponse =
  GetGooglePlaceByIdResponses[keyof GetGooglePlaceByIdResponses];

export type SearchAdminLocationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Workspace whose locations to search.
     */
    workspaceId: string;
    /**
     * Name or address contains.
     */
    q?: string;
    limit?: number;
  };
  url: '/api/v1/admin/locations/search';
};

export type SearchAdminLocationsResponses = {
  200: Array<AdminLocationSearchResultDto>;
};

export type SearchAdminLocationsResponse =
  SearchAdminLocationsResponses[keyof SearchAdminLocationsResponses];

export type FindData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    /**
     * Profile ID to filter leads by
     */
    profileId?: string;
    /**
     * Search query (name, email, company, phone, tags, notes, message, events)
     */
    q?: string;
    /**
     * Meine / Workspace / Privat anderer. When omitted, returns all leads readable by the viewer.
     */
    scope?: LeadListScope;
    /**
     * Filter by pipeline status (archived is not a status)
     */
    status?: LeadStatus;
    /**
     * Filter by tags
     */
    tags?: Array<string>;
    /**
     * Filter by linked Event ids (match any)
     */
    eventIds?: Array<string>;
    /**
     * Filter by source
     */
    source?: LeadSource;
    /**
     * Sort field. Use "order" for board/list: status (asc), then manual order, then createdAt. sortOrder applies to order and createdAt only.
     */
    sortBy?: LeadQuerySortBy;
    /**
     * Sort order
     */
    sortOrder?: QuerySortDirection;
    /**
     * When true, each lead includes the full `activity` array (large payload). Default is false — use GET /leads/:id for timeline on detail views.
     */
    includeActivities?: boolean;
    /**
     * Include archived leads (archivedAt set). Default false excludes them.
     */
    includeArchived?: boolean;
    /**
     * When true, return only archived leads (implies includeArchived).
     */
    archivedOnly?: boolean;
    /**
     * When true, return a compact suggestion list (limit applied) with matchReasons.
     */
    suggest?: boolean;
    /**
     * Max leads to return (hard-capped). Omitted → cap.
     */
    limit?: number;
    /**
     * Offset for list paging (used with limit).
     */
    skip?: number;
  };
  url: '/api/v1/workspaces/{workspaceId}/leads';
};

export type FindResponses = {
  200: LeadListResponseDto;
};

export type FindResponse = FindResponses[keyof FindResponses];

export type Create9Data = {
  body: CreateLeadDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads';
};

export type Create9Responses = {
  201: Lead;
};

export type Create9Response = Create9Responses[keyof Create9Responses];

export type ScanBusinessCardData = {
  body: ScanBusinessCardDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/scan-business-card';
};

export type ScanBusinessCardResponses = {
  200: ScanBusinessCardResultDto;
};

export type ScanBusinessCardResponse =
  ScanBusinessCardResponses[keyof ScanBusinessCardResponses];

export type ExchangeBusinessCardData = {
  body: ExchangeBusinessCardDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/exchange-business-card';
};

export type ExchangeBusinessCardResponses = {
  201: ExchangeBusinessCardResponseDto;
};

export type ExchangeBusinessCardResponse =
  ExchangeBusinessCardResponses[keyof ExchangeBusinessCardResponses];

export type BulkUpdateData = {
  body: BulkUpdateLeadsDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/bulk';
};

export type BulkUpdateResponses = {
  /**
   * Updated leads after bulk organize (status, assignee, tags, events)
   */
  200: Array<Lead>;
};

export type BulkUpdateResponse = BulkUpdateResponses[keyof BulkUpdateResponses];

export type Remove10Data = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}';
};

export type Remove10Responses = {
  204: void;
};

export type Remove10Response = Remove10Responses[keyof Remove10Responses];

export type FindOne7Data = {
  body?: never;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}';
};

export type FindOne7Responses = {
  200: Lead;
};

export type FindOne7Response = FindOne7Responses[keyof FindOne7Responses];

export type Update10Data = {
  body: UpdateLeadDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}';
};

export type Update10Responses = {
  200: Lead;
};

export type Update10Response = Update10Responses[keyof Update10Responses];

export type ContactViaData = {
  body: ContactLeadViaDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/contact';
};

export type ContactViaResponses = {
  200: Lead;
};

export type ContactViaResponse = ContactViaResponses[keyof ContactViaResponses];

export type AddNoteData = {
  body: AddLeadNoteDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/notes';
};

export type AddNoteResponses = {
  200: Lead;
};

export type AddNoteResponse = AddNoteResponses[keyof AddNoteResponses];

export type RemoveNoteData = {
  body?: never;
  path: {
    workspaceId: string;
    noteId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/notes/{noteId}';
};

export type RemoveNoteResponses = {
  200: Lead;
};

export type RemoveNoteResponse = RemoveNoteResponses[keyof RemoveNoteResponses];

export type UpdateNoteData = {
  body: UpdateLeadNoteDto;
  path: {
    workspaceId: string;
    noteId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/notes/{noteId}';
};

export type UpdateNoteResponses = {
  200: Lead;
};

export type UpdateNoteResponse = UpdateNoteResponses[keyof UpdateNoteResponses];

export type AddAttachmentData = {
  body: LeadAttachmentInputDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/attachments';
};

export type AddAttachmentResponses = {
  200: Lead;
};

export type AddAttachmentResponse =
  AddAttachmentResponses[keyof AddAttachmentResponses];

export type ReorderAttachmentsData = {
  body: ReorderLeadAttachmentsDto;
  path: {
    workspaceId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/attachments/reorder';
};

export type ReorderAttachmentsResponses = {
  200: Lead;
};

export type ReorderAttachmentsResponse =
  ReorderAttachmentsResponses[keyof ReorderAttachmentsResponses];

export type RemoveAttachmentData = {
  body?: never;
  path: {
    workspaceId: string;
    attachmentId: string;
    id: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/leads/{id}/attachments/{attachmentId}';
};

export type RemoveAttachmentResponses = {
  200: Lead;
};

export type RemoveAttachmentResponse =
  RemoveAttachmentResponses[keyof RemoveAttachmentResponses];

export type SubmitLeadFormData = {
  body: SubmitPublicLeadFormDto;
  path: {
    /**
     * Profile ID
     */
    profileId: string;
  };
  query?: never;
  url: '/api/v1/public/profiles/{profileId}/leads';
};

export type SubmitLeadFormResponses = {
  /**
   * Submit a lead form on a public profile
   */
  201: PublicLeadFormSubmittedDto;
};

export type SubmitLeadFormResponse =
  SubmitLeadFormResponses[keyof SubmitLeadFormResponses];

export type FindAll9Data = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    /**
     * Filter by derived lifecycle status
     */
    status?: LeadEventLifecycleStatus;
    /**
     * Max events to return (hard-capped). Omitted → cap.
     */
    limit?: number;
    /**
     * Offset for list paging (used with limit).
     */
    skip?: number;
  };
  url: '/api/v1/workspaces/{workspaceId}/events';
};

export type FindAll9Responses = {
  200: Array<LeadEventWithStatusDto>;
};

export type FindAll9Response = FindAll9Responses[keyof FindAll9Responses];

export type Create10Data = {
  body: CreateLeadEventDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events';
};

export type Create10Responses = {
  201: LeadEventWithStatusDto;
};

export type Create10Response = Create10Responses[keyof Create10Responses];

export type ResolveRosterData = {
  body?: never;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/roster/resolved';
};

export type ResolveRosterResponses = {
  200: LeadEventRosterResolvedDto;
};

export type ResolveRosterResponse =
  ResolveRosterResponses[keyof ResolveRosterResponses];

export type FindLeadsData = {
  body?: never;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/leads';
};

export type FindLeadsResponses = {
  200: Array<Lead>;
};

export type FindLeadsResponse = FindLeadsResponses[keyof FindLeadsResponses];

export type GetEventAnalyticsData = {
  body?: never;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/analytics';
};

export type GetEventAnalyticsResponses = {
  200: LeadEventAnalyticsDto;
};

export type GetEventAnalyticsResponse =
  GetEventAnalyticsResponses[keyof GetEventAnalyticsResponses];

export type Remove11Data = {
  body?: never;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}';
};

export type Remove11Responses = {
  204: void;
};

export type Remove11Response = Remove11Responses[keyof Remove11Responses];

export type FindOne8Data = {
  body?: never;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}';
};

export type FindOne8Responses = {
  200: LeadEventWithStatusDto;
};

export type FindOne8Response = FindOne8Responses[keyof FindOne8Responses];

export type Update11Data = {
  body: UpdateLeadEventDto;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}';
};

export type Update11Responses = {
  200: LeadEventWithStatusDto;
};

export type Update11Response = Update11Responses[keyof Update11Responses];

export type UpdateRosterData = {
  body: UpdateLeadEventRosterDto;
  path: {
    workspaceId: string;
    eventId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/events/{eventId}/roster';
};

export type UpdateRosterResponses = {
  200: LeadEventWithStatusDto;
};

export type UpdateRosterResponse =
  UpdateRosterResponses[keyof UpdateRosterResponses];

export type AppInfoData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/';
};

export type AppInfoResponses = {
  200: unknown;
};

export type GetBoardData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query: {
    /**
     * Current KPI / chart window in days (previous window is equal length).
     */
    rangeDays: StatusBoardRangeDays;
  };
  url: '/api/v1/workspaces/{workspaceId}/status-board';
};

export type GetBoardResponses = {
  200: StatusBoardDto;
};

export type GetBoardResponse = GetBoardResponses[keyof GetBoardResponses];

export type ListReviewsData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: {
    provider?: IntegrationProvider;
    sentiment?: SentimentPolarity;
    aspect?: string;
    minRating?: number;
    maxRating?: number;
    responded?: ReviewRespondedFilter;
    /**
     * Max reviews to return (hard-capped at 100). Omitted → 100.
     */
    limit?: number;
  };
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews';
};

export type ListReviewsResponses = {
  /**
   * List of reviews (from DB) with reply status
   */
  200: ListReviewsResponseDto;
};

export type ListReviewsResponse =
  ListReviewsResponses[keyof ListReviewsResponses];

export type SuggestReplyData = {
  body: SuggestReplyDto;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/suggest-reply';
};

export type SuggestReplyResponses = {
  /**
   * KI-generated reply suggestion for one review
   */
  200: {
    suggestedText?: string;
  };
};

export type SuggestReplyResponse =
  SuggestReplyResponses[keyof SuggestReplyResponses];

export type SuggestReplyPreviewData = {
  body: SuggestReplyPreviewDto;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/suggest-reply-preview';
};

export type SuggestReplyPreviewResponses = {
  /**
   * KI-generated reply suggestions for multiple reviews (preview)
   */
  200: {
    suggestions?: Array<{
      reviewId?: string;
      suggestedText?: string;
    }>;
  };
};

export type SuggestReplyPreviewResponse =
  SuggestReplyPreviewResponses[keyof SuggestReplyPreviewResponses];

export type CreateBulkReplyDraftsData = {
  body: BulkCreateReplyDraftsDto;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/reply-drafts/bulk';
};

export type CreateBulkReplyDraftsResponses = {
  /**
   * Bulk AI reply draft job accepted — poll GET reply-drafts/bulk/:batchId
   */
  202: BulkCreateReplyDraftsResponseDto;
};

export type CreateBulkReplyDraftsResponse =
  CreateBulkReplyDraftsResponses[keyof CreateBulkReplyDraftsResponses];

export type GetBulkReplyDraftBatchData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
    batchId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/reply-drafts/bulk/{batchId}';
};

export type GetBulkReplyDraftBatchResponses = {
  /**
   * Bulk AI reply draft batch status
   */
  200: BulkReplyDraftBatchStatusDto;
};

export type GetBulkReplyDraftBatchResponse =
  GetBulkReplyDraftBatchResponses[keyof GetBulkReplyDraftBatchResponses];

export type CreateReplyDraftData = {
  body: CreateReplyDraftDto;
  path: {
    workspaceId: string;
    locationId: string;
    reviewId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply-drafts';
};

export type CreateReplyDraftResponses = {
  /**
   * Reply draft created
   */
  200: unknown;
};

export type PublishReplyDraftData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
    reviewId: string;
    draftId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply-drafts/{draftId}/publish';
};

export type PublishReplyDraftResponses = {
  /**
   * Publish job enqueued
   */
  200: unknown;
};

export type DeleteReplyData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
    reviewId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply';
};

export type DeleteReplyResponses = {
  /**
   * Reply deleted (on provider and locally)
   */
  204: void;
};

export type DeleteReplyResponse =
  DeleteReplyResponses[keyof DeleteReplyResponses];

export type GetReplyData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
    reviewId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/reviews/{reviewId}/reply';
};

export type GetReplyResponses = {
  /**
   * Published reply status for the review
   */
  200: unknown;
};

export type GetPresetsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/reputation/presets';
};

export type GetPresetsResponses = {
  200: ReputationPresetListDto;
};

export type GetPresetsResponse = GetPresetsResponses[keyof GetPresetsResponses];

export type GetOverviewData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
    from?: string;
    to?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/overview';
};

export type GetOverviewResponses = {
  200: ReputationOverviewDto;
};

export type GetOverviewResponse =
  GetOverviewResponses[keyof GetOverviewResponses];

export type GetSummaryData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/summary';
};

export type GetSummaryResponses = {
  200: ReputationSummaryDto;
};

export type GetSummaryResponse = GetSummaryResponses[keyof GetSummaryResponses];

export type GetDriversData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
    from?: string;
    to?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/drivers';
};

export type GetDriversResponses = {
  200: DriversResponseDto;
};

export type GetDriversResponse = GetDriversResponses[keyof GetDriversResponses];

export type GetAnalyticsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
    from?: string;
    to?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/analytics';
};

export type GetAnalyticsResponses = {
  200: ReputationAnalyticsDto;
};

export type GetAnalyticsResponse =
  GetAnalyticsResponses[keyof GetAnalyticsResponses];

export type ListWorkspaceReviewsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
    /**
     * Comma-separated location IDs.
     */
    locationIds?: string;
    provider?: string;
    sentiment?: SentimentPolarity;
    /**
     * Comma-separated sentiment values.
     */
    sentiments?: string;
    aspect?: string;
    /**
     * Comma-separated aspect keys.
     */
    aspects?: string;
    minRating?: number;
    maxRating?: number;
    /**
     * Comma-separated star ratings (1–5).
     */
    ratings?: string;
    responded?: ReviewRespondedFilter;
    from?: string;
    to?: string;
    /**
     * Search review text or author name.
     */
    q?: string;
    page?: number;
    pageSize?: number;
    /**
     * Pin this review on page 1 when it matches the active filters (deep links).
     */
    reviewId?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/reviews';
};

export type ListWorkspaceReviewsResponses = {
  200: PaginatedReviewsResponseDto;
};

export type ListWorkspaceReviewsResponse =
  ListWorkspaceReviewsResponses[keyof ListWorkspaceReviewsResponses];

export type MarkReviewsSeenData = {
  body: MarkReviewsSeenDto;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/reviews/mark-seen';
};

export type MarkReviewsSeenResponses = {
  200: MarkReviewsSeenResponseDto;
};

export type MarkReviewsSeenResponse =
  MarkReviewsSeenResponses[keyof MarkReviewsSeenResponses];

export type GetCompetitorsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
    from?: string;
    to?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/competitors';
};

export type GetCompetitorsResponses = {
  200: CompetitorCompareListDto;
};

export type GetCompetitorsResponse =
  GetCompetitorsResponses[keyof GetCompetitorsResponses];

export type GetChannelLocationsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    locationId?: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/reputation/channel-locations';
};

export type GetChannelLocationsResponses = {
  200: ChannelLocationStatusListDto;
};

export type GetChannelLocationsResponse =
  GetChannelLocationsResponses[keyof GetChannelLocationsResponses];

export type ListData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/integrations';
};

export type ListResponses = {
  200: IntegrationsListResponseDto;
};

export type ListResponse = ListResponses[keyof ListResponses];

export type GetConnectUrlData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query: {
    state: string;
  };
  url: '/api/v1/workspaces/{workspaceId}/integrations/google/connect-url';
};

export type GetConnectUrlResponses = {
  /**
   * Returns URL to redirect user to Google OAuth
   */
  200: unknown;
};

export type DisconnectData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/integrations/google';
};

export type DisconnectResponses = {
  204: void;
};

export type DisconnectResponse = DisconnectResponses[keyof DisconnectResponses];

export type GetStatusData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/integrations/google';
};

export type GetStatusResponses = {
  /**
   * Connection status for Google
   */
  200: unknown;
};

export type ListLocationsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/integrations/google/locations';
};

export type ListLocationsResponses = {
  /**
   * List Google Business Profile locations the workspace can link to
   */
  200: unknown;
};

export type CallbackData = {
  body?: never;
  path?: never;
  query: {
    code: string;
  };
  url: '/api/v1/integrations/google/callback';
};

export type UnlinkData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/link';
};

export type UnlinkResponses = {
  /**
   * Google Business Profile link removed
   */
  200: unknown;
};

export type LinkData = {
  body: LinkGooglePlaceDto;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/link';
};

export type LinkResponses = {
  /**
   * Location linked to Google Business Profile
   */
  200: unknown;
};

export type ClearSkipData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/skip';
};

export type ClearSkipResponses = {
  /**
   * Google opt-out cleared for this location
   */
  200: unknown;
};

export type SkipData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/integrations/google/skip';
};

export type SkipResponses = {
  /**
   * Location marked as not using Google Business Profile
   */
  200: unknown;
};

export type List2Data = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors';
};

export type List2Responses = {
  200: CompetitorBenchmarkListDto;
};

export type List2Response = List2Responses[keyof List2Responses];

export type AddData = {
  body: AddCompetitorDto;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors';
};

export type AddResponses = {
  201: CompetitorBenchmarkDto;
};

export type AddResponse = AddResponses[keyof AddResponses];

export type NearbyData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: {
    /**
     * Search radius in meters (default 3000).
     */
    radiusMeters?: CompetitorNearbyRadius;
  };
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors/nearby';
};

export type NearbyResponses = {
  200: CompetitorNearbyListDto;
};

export type NearbyResponse = NearbyResponses[keyof NearbyResponses];

export type SummaryData = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors/summary';
};

export type SummaryResponses = {
  200: CompetitorBoardSummaryDto;
};

export type SummaryResponse = SummaryResponses[keyof SummaryResponses];

export type Remove12Data = {
  body?: never;
  path: {
    workspaceId: string;
    locationId: string;
    competitorId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/locations/{locationId}/competitors/{competitorId}';
};

export type Remove12Responses = {
  204: void;
};

export type Remove12Response = Remove12Responses[keyof Remove12Responses];

export type ListEntriesData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    status?: FeedbackStatus;
    locationId?: string;
    limit?: number;
    skip?: number;
  };
  url: '/api/v1/workspaces/{workspaceId}/feedback/entries';
};

export type ListEntriesResponses = {
  200: Array<Feedback>;
};

export type ListEntriesResponse =
  ListEntriesResponses[keyof ListEntriesResponses];

export type GetEntryData = {
  body?: never;
  path: {
    workspaceId: string;
    entryId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/entries/{entryId}';
};

export type GetEntryResponses = {
  200: Feedback;
};

export type GetEntryResponse = GetEntryResponses[keyof GetEntryResponses];

export type PatchEntryData = {
  body: PatchFeedbackEntryDto;
  path: {
    workspaceId: string;
    entryId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/entries/{entryId}';
};

export type PatchEntryResponses = {
  200: Feedback;
};

export type PatchEntryResponse = PatchEntryResponses[keyof PatchEntryResponses];

export type GetStatsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/stats';
};

export type GetStatsResponses = {
  200: FeedbackStatsDto;
};

export type GetStatsResponse = GetStatsResponses[keyof GetStatsResponses];

export type ListContactsData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    search?: string;
    limit?: number;
  };
  url: '/api/v1/workspaces/{workspaceId}/feedback/contacts';
};

export type ListContactsResponses = {
  200: Array<FeedbackContact>;
};

export type ListContactsResponse =
  ListContactsResponses[keyof ListContactsResponses];

export type ListFormTemplatesData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates';
};

export type ListFormTemplatesResponses = {
  200: Array<FeedbackFormTemplate>;
};

export type ListFormTemplatesResponse =
  ListFormTemplatesResponses[keyof ListFormTemplatesResponses];

export type CreateFormTemplateData = {
  body: CreateFeedbackFormTemplateDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates';
};

export type CreateFormTemplateResponses = {
  201: FeedbackFormTemplate;
};

export type CreateFormTemplateResponse =
  CreateFormTemplateResponses[keyof CreateFormTemplateResponses];

export type DeleteFormTemplateData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates/{templateId}';
};

export type DeleteFormTemplateResponses = {
  204: void;
};

export type DeleteFormTemplateResponse =
  DeleteFormTemplateResponses[keyof DeleteFormTemplateResponses];

export type GetFormTemplateData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates/{templateId}';
};

export type GetFormTemplateResponses = {
  200: FeedbackFormTemplate;
};

export type GetFormTemplateResponse =
  GetFormTemplateResponses[keyof GetFormTemplateResponses];

export type UpdateFormTemplateData = {
  body: UpdateFeedbackFormTemplateDto;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/form-templates/{templateId}';
};

export type UpdateFormTemplateResponses = {
  200: FeedbackFormTemplate;
};

export type UpdateFormTemplateResponse =
  UpdateFormTemplateResponses[keyof UpdateFormTemplateResponses];

export type ListMailTemplatesData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates';
};

export type ListMailTemplatesResponses = {
  200: Array<FeedbackMailTemplate>;
};

export type ListMailTemplatesResponse =
  ListMailTemplatesResponses[keyof ListMailTemplatesResponses];

export type CreateMailTemplateData = {
  body: CreateFeedbackMailTemplateDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates';
};

export type CreateMailTemplateResponses = {
  201: FeedbackMailTemplate;
};

export type CreateMailTemplateResponse =
  CreateMailTemplateResponses[keyof CreateMailTemplateResponses];

export type DeleteMailTemplateData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates/{templateId}';
};

export type DeleteMailTemplateResponses = {
  204: void;
};

export type DeleteMailTemplateResponse =
  DeleteMailTemplateResponses[keyof DeleteMailTemplateResponses];

export type GetMailTemplateData = {
  body?: never;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates/{templateId}';
};

export type GetMailTemplateResponses = {
  200: FeedbackMailTemplate;
};

export type GetMailTemplateResponse =
  GetMailTemplateResponses[keyof GetMailTemplateResponses];

export type UpdateMailTemplateData = {
  body: UpdateFeedbackMailTemplateDto;
  path: {
    workspaceId: string;
    templateId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/mail-templates/{templateId}';
};

export type UpdateMailTemplateResponses = {
  200: FeedbackMailTemplate;
};

export type UpdateMailTemplateResponse =
  UpdateMailTemplateResponses[keyof UpdateMailTemplateResponses];

export type ListInvitesData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: {
    status?: FeedbackInviteStatus;
    limit?: number;
  };
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites';
};

export type ListInvitesResponses = {
  200: Array<FeedbackInvite>;
};

export type ListInvitesResponse =
  ListInvitesResponses[keyof ListInvitesResponses];

export type CreateInviteData = {
  body: CreateFeedbackInviteDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites';
};

export type CreateInviteResponses = {
  201: FeedbackInviteDetailDto;
};

export type CreateInviteResponse =
  CreateInviteResponses[keyof CreateInviteResponses];

export type SendPreviewMailData = {
  body: SendFeedbackInvitePreviewDto;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites/preview';
};

export type SendPreviewMailResponses = {
  200: FeedbackInvitePreviewSentDto;
};

export type SendPreviewMailResponse =
  SendPreviewMailResponses[keyof SendPreviewMailResponses];

export type GetInviteData = {
  body?: never;
  path: {
    workspaceId: string;
    inviteId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}';
};

export type GetInviteResponses = {
  200: FeedbackInviteDetailDto;
};

export type GetInviteResponse = GetInviteResponses[keyof GetInviteResponses];

export type UpdateInviteData = {
  body: UpdateFeedbackInviteDto;
  path: {
    workspaceId: string;
    inviteId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}';
};

export type UpdateInviteResponses = {
  200: FeedbackInviteDetailDto;
};

export type UpdateInviteResponse =
  UpdateInviteResponses[keyof UpdateInviteResponses];

export type SendInviteData = {
  body?: never;
  path: {
    workspaceId: string;
    inviteId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}/send';
};

export type SendInviteResponses = {
  200: FeedbackInviteDetailDto;
};

export type SendInviteResponse = SendInviteResponses[keyof SendInviteResponses];

export type CancelInviteData = {
  body?: never;
  path: {
    workspaceId: string;
    inviteId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}/cancel';
};

export type CancelInviteResponses = {
  200: FeedbackInviteDetailDto;
};

export type CancelInviteResponse =
  CancelInviteResponses[keyof CancelInviteResponses];

export type ResendInviteRecipientData = {
  body?: never;
  path: {
    workspaceId: string;
    inviteId: string;
    recipientId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/feedback/invites/{inviteId}/recipients/{recipientId}/resend';
};

export type ResendInviteRecipientResponses = {
  200: FeedbackInviteDetailDto;
};

export type ResendInviteRecipientResponse =
  ResendInviteRecipientResponses[keyof ResendInviteRecipientResponses];

export type GetByTokenData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/tokens/{token}';
};

export type GetByTokenResponses = {
  200: PublicFeedbackTokenResponseDto;
};

export type GetByTokenResponse = GetByTokenResponses[keyof GetByTokenResponses];

export type SubmitData = {
  body: SubmitPublicFeedbackDto;
  path: {
    token: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/tokens/{token}/submit';
};

export type SubmitResponses = {
  201: PublicFeedbackSubmitResponseDto;
};

export type SubmitResponse = SubmitResponses[keyof SubmitResponses];

export type ReviewCtaGetData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/tokens/{token}/review-cta';
};

export type ReviewCtaGetResponses = {
  200: unknown;
};

export type ReviewCtaPostData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/tokens/{token}/review-cta';
};

export type ReviewCtaPostResponses = {
  201: unknown;
};

export type GetProductFunnelData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/products/{hash}';
};

export type GetProductFunnelResponses = {
  200: PublicFeedbackTokenResponseDto;
};

export type GetProductFunnelResponse =
  GetProductFunnelResponses[keyof GetProductFunnelResponses];

export type SubmitProductData = {
  body: SubmitPublicFeedbackDto;
  path: {
    hash: string;
  };
  query?: {
    scanId?: string;
  };
  url: '/api/v1/public/feedback/products/{hash}/submit';
};

export type SubmitProductResponses = {
  201: PublicFeedbackSubmitResponseDto;
};

export type SubmitProductResponse =
  SubmitProductResponses[keyof SubmitProductResponses];

export type ProductReviewCtaGetData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/products/{hash}/review-cta';
};

export type ProductReviewCtaGetResponses = {
  200: unknown;
};

export type ProductReviewCtaPostData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/products/{hash}/review-cta';
};

export type ProductReviewCtaPostResponses = {
  201: unknown;
};

export type UnsubscribeData = {
  body?: never;
  path: {
    token: string;
  };
  query?: never;
  url: '/api/v1/public/feedback/unsubscribe/{token}';
};

export type UnsubscribeResponses = {
  200: unknown;
};

export type GetData = {
  body?: never;
  path?: never;
  query?: {
    workspaceId?: string;
  };
  url: '/api/v1/users/me/guidance-progress';
};

export type GetResponses = {
  200: GuidanceProgressDto;
};

export type GetResponse = GetResponses[keyof GetResponses];

export type Update12Data = {
  body: UpdateGuidanceProgressDto;
  path?: never;
  query?: never;
  url: '/api/v1/users/me/guidance-progress';
};

export type Update12Responses = {
  200: GuidanceProgressDto;
};

export type Update12Response = Update12Responses[keyof Update12Responses];

export type GetOpsBillingData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/billing';
};

export type GetOpsBillingResponses = {
  200: BillingOpsOverviewDto;
};

export type GetOpsBillingResponse =
  GetOpsBillingResponses[keyof GetOpsBillingResponses];

export type GetOpsGrowthData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/growth';
};

export type GetOpsGrowthResponses = {
  200: GrowthKpisDto;
};

export type GetOpsGrowthResponse =
  GetOpsGrowthResponses[keyof GetOpsGrowthResponses];

export type GetOpsIntegrationsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/admin/ops/integrations';
};

export type GetOpsIntegrationsResponses = {
  200: IntegrationHealthDto;
};

export type GetOpsIntegrationsResponse =
  GetOpsIntegrationsResponses[keyof GetOpsIntegrationsResponses];

export type FindBillbeePackingStationOrdersData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/billbee-admin/packing-station/orders';
};

export type FindBillbeePackingStationOrdersResponses = {
  200: BillbeePackingOrdersResponse;
};

export type FindBillbeePackingStationOrdersResponse =
  FindBillbeePackingStationOrdersResponses[keyof FindBillbeePackingStationOrdersResponses];

export type SearchBillbeeOrdersData = {
  body: SearchBillbeeOrdersDto;
  path?: never;
  query?: never;
  url: '/api/v1/billbee-admin/orders/search';
};

export type SearchBillbeeOrdersResponses = {
  200: BillbeeSearchOrdersResponse;
};

export type SearchBillbeeOrdersResponse =
  SearchBillbeeOrdersResponses[keyof SearchBillbeeOrdersResponses];

export type FindBillbeeOrderByIdData = {
  body?: never;
  path: {
    orderId: string;
  };
  query?: never;
  url: '/api/v1/billbee-admin/orders/{orderId}';
};

export type FindBillbeeOrderByIdResponses = {
  200: BillbeeOrderResponse;
};

export type FindBillbeeOrderByIdResponse =
  FindBillbeeOrderByIdResponses[keyof FindBillbeeOrderByIdResponses];

export type ShipBillbeeOrderData = {
  body: ShipBillbeeOrderDto;
  path: {
    orderId: string;
  };
  query?: never;
  url: '/api/v1/billbee-admin/orders/{orderId}/ship';
};

export type ShipBillbeeOrderResponses = {
  200: BillbeeShipOrderResponse;
};

export type ShipBillbeeOrderResponse =
  ShipBillbeeOrderResponses[keyof ShipBillbeeOrderResponses];

export type FindBillbeeAddressByIdData = {
  body?: never;
  path: {
    addressId: string;
  };
  query?: never;
  url: '/api/v1/billbee-admin/customer-addresses/{addressId}';
};

export type FindBillbeeAddressByIdResponses = {
  200: BillbeeQueryAddressResponse;
};

export type FindBillbeeAddressByIdResponse =
  FindBillbeeAddressByIdResponses[keyof FindBillbeeAddressByIdResponses];

export type UpdateBillbeeAddressByIdData = {
  body: BillbeeAddress;
  path: {
    addressId: string;
  };
  query?: never;
  url: '/api/v1/billbee-admin/customer-addresses/{addressId}';
};

export type UpdateBillbeeAddressByIdResponses = {
  200: BillbeeUpdateAddressResponse;
};

export type UpdateBillbeeAddressByIdResponse =
  UpdateBillbeeAddressByIdResponses[keyof UpdateBillbeeAddressByIdResponses];

export type FindBillbeeStockItemsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Filter by SKU or product title (case-insensitive substring)
     */
    search?: string;
  };
  url: '/api/v1/billbee-admin/stock';
};

export type FindBillbeeStockItemsResponses = {
  200: BillbeeStockListResponse;
};

export type FindBillbeeStockItemsResponse =
  FindBillbeeStockItemsResponses[keyof FindBillbeeStockItemsResponses];

export type UpdateBillbeeStockData = {
  body: UpdateBillbeeStockDto;
  path?: never;
  query?: never;
  url: '/api/v1/billbee-admin/stock';
};

export type UpdateBillbeeStockResponses = {
  200: BillbeeUpdateStockResponse;
};

export type UpdateBillbeeStockResponse =
  UpdateBillbeeStockResponses[keyof UpdateBillbeeStockResponses];

export type UpdateBillbeeStockBulkData = {
  body: UpdateBillbeeStockBulkDto;
  path?: never;
  query?: never;
  url: '/api/v1/billbee-admin/stock/bulk';
};

export type UpdateBillbeeStockBulkResponses = {
  200: BillbeeUpdateStockBulkResponse;
};

export type UpdateBillbeeStockBulkResponse =
  UpdateBillbeeStockBulkResponses[keyof UpdateBillbeeStockBulkResponses];

export type StreamData = {
  body?: never;
  path: {
    workspaceId: string;
  };
  query?: never;
  url: '/api/v1/workspaces/{workspaceId}/realtime/stream';
};

export type StreamResponses = {
  200: unknown;
};

export type PackProductsData = {
  body: PackProductsDto;
  path?: never;
  query?: never;
  url: '/api/v1/products-admin/pack';
};

export type PackProductsResponses = {
  200: PackProductsResultDto;
};

export type PackProductsResponse =
  PackProductsResponses[keyof PackProductsResponses];

export type SearchProductsByOrderData = {
  body?: never;
  path?: never;
  query: {
    orderNumber: string;
    channel?: OrderChannel;
  };
  url: '/api/v1/products-admin/search';
};

export type SearchProductsByOrderResponses = {
  200: Array<ProductOrderSearchHitDto>;
};

export type SearchProductsByOrderResponse =
  SearchProductsByOrderResponses[keyof SearchProductsByOrderResponses];

export type FindRecentLiveScansAdminData = {
  body?: never;
  path?: never;
  query?: {
    minutes?: number;
    limit?: number;
  };
  url: '/api/v1/products-admin/live-scans/recent';
};

export type FindRecentLiveScansAdminResponses = {
  200: Array<AdminLiveScanDto>;
};

export type FindRecentLiveScansAdminResponse =
  FindRecentLiveScansAdminResponses[keyof FindRecentLiveScansAdminResponses];

export type StreamLiveScansAdminData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/products-admin/live-scans/stream';
};

export type StreamLiveScansAdminResponses = {
  200: unknown;
};

export type AdminCountClaimRequestsData = {
  body?: never;
  path?: never;
  query?: never;
  url: '/api/v1/products-admin/claim-requests/count';
};

export type AdminCountClaimRequestsResponses = {
  200: ClaimRequestCountDto;
};

export type AdminCountClaimRequestsResponse =
  AdminCountClaimRequestsResponses[keyof AdminCountClaimRequestsResponses];

export type InspectByHashAdminData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/products-admin/hash/{hash}/inspect';
};

export type InspectByHashAdminResponses = {
  200: InspectProductResponseDto;
};

export type InspectByHashAdminResponse =
  InspectByHashAdminResponses[keyof InspectByHashAdminResponses];

export type FindAllAdminData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Free-text search
     */
    filter?: string;
    /**
     * Only products targeting this location
     */
    locationId?: string;
    /**
     * Only PROFILE products of this user
     */
    userId?: string;
    /**
     * Filter by item behaviour (GOOGLE_REVIEW, PROFILE, …); __unknown__ = unknown. Comma-separated or repeated.
     */
    behaviors?: Array<string>;
    /**
     * Filter by form (STAND, CARD, BADGE); __unknown__ = unknown. Comma-separated or repeated.
     */
    forms?: Array<string>;
    /**
     * Filter by material; __unknown__ = unknown. Comma-separated or repeated.
     */
    materials?: Array<string>;
    /**
     * Filter by color; __unknown__ = unknown. Comma-separated or repeated.
     */
    colors?: Array<string>;
    /**
     * Filter by size; __unknown__ = unknown. Comma-separated or repeated.
     */
    sizes?: Array<string>;
    /**
     * Filter by factory language; __unknown__ = unknown. Comma-separated or repeated.
     */
    languages?: Array<string>;
    /**
     * Only products with a known item behaviour (facets always count those only).
     */
    knownOnly?: boolean;
    page?: number;
    limit?: number;
    /**
     * Include per-item scanCount for the last N days (page-scoped aggregation). Cut to the plan history; see `historyLimitedTo`.
     */
    includeScansDays?: number;
    /**
     * Include per-item daily scanSeries for the last N days (page-scoped). Cut to the plan history; see `historyLimitedTo`.
     */
    includeScanSeriesDays?: number;
    /**
     * Only products of this workspace; omit for all workspaces.
     */
    workspaceId?: string;
    /**
     * Filter by lifecycle state. Comma-separated or repeated.
     */
    states?: Array<ProductState>;
    /**
     * Filter by fulfillment stage. Comma-separated or repeated.
     */
    stages?: Array<FulfillmentStage>;
    /**
     * Filter by registration kind. Comma-separated or repeated.
     */
    registrationKinds?: Array<RegistrationKind>;
    /**
     * Only products with an order of this channel.
     */
    orderChannel?: OrderChannel;
    /**
     * Only products carrying this exact order number (e.g. `#UP2-PROMO-ORD-1`), optionally of `orderChannel`.
     */
    orderNumber?: string;
    sort?: ProductAdminSortField;
    order?: QuerySortDirection;
  };
  url: '/api/v1/products-admin';
};

export type FindAllAdminResponses = {
  200: InfinityPaginationProductAdminDtoResponseDto;
};

export type FindAllAdminResponse =
  FindAllAdminResponses[keyof FindAllAdminResponses];

export type FindFacetsAdminData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Free-text search
     */
    filter?: string;
    /**
     * Only products targeting this location
     */
    locationId?: string;
    /**
     * Only PROFILE products of this user
     */
    userId?: string;
    /**
     * Filter by item behaviour (GOOGLE_REVIEW, PROFILE, …); __unknown__ = unknown. Comma-separated or repeated.
     */
    behaviors?: Array<string>;
    /**
     * Filter by form (STAND, CARD, BADGE); __unknown__ = unknown. Comma-separated or repeated.
     */
    forms?: Array<string>;
    /**
     * Filter by material; __unknown__ = unknown. Comma-separated or repeated.
     */
    materials?: Array<string>;
    /**
     * Filter by color; __unknown__ = unknown. Comma-separated or repeated.
     */
    colors?: Array<string>;
    /**
     * Filter by size; __unknown__ = unknown. Comma-separated or repeated.
     */
    sizes?: Array<string>;
    /**
     * Filter by factory language; __unknown__ = unknown. Comma-separated or repeated.
     */
    languages?: Array<string>;
    /**
     * Only products with a known item behaviour (facets always count those only).
     */
    knownOnly?: boolean;
    /**
     * Only products of this workspace; omit for all workspaces.
     */
    workspaceId?: string;
    /**
     * Filter by lifecycle state. Comma-separated or repeated.
     */
    states?: Array<ProductState>;
    /**
     * Filter by fulfillment stage. Comma-separated or repeated.
     */
    stages?: Array<FulfillmentStage>;
    /**
     * Filter by registration kind. Comma-separated or repeated.
     */
    registrationKinds?: Array<RegistrationKind>;
    /**
     * Only products with an order of this channel.
     */
    orderChannel?: OrderChannel;
    /**
     * Only products carrying this exact order number (e.g. `#UP2-PROMO-ORD-1`), optionally of `orderChannel`.
     */
    orderNumber?: string;
  };
  url: '/api/v1/products-admin/facets';
};

export type FindFacetsAdminResponses = {
  200: ProductFacetsDto;
};

export type FindFacetsAdminResponse =
  FindFacetsAdminResponses[keyof FindFacetsAdminResponses];

export type FindStatsAdminData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Free-text search
     */
    filter?: string;
    /**
     * Only products targeting this location
     */
    locationId?: string;
    /**
     * Only PROFILE products of this user
     */
    userId?: string;
    /**
     * Filter by item behaviour (GOOGLE_REVIEW, PROFILE, …); __unknown__ = unknown. Comma-separated or repeated.
     */
    behaviors?: Array<string>;
    /**
     * Filter by form (STAND, CARD, BADGE); __unknown__ = unknown. Comma-separated or repeated.
     */
    forms?: Array<string>;
    /**
     * Filter by material; __unknown__ = unknown. Comma-separated or repeated.
     */
    materials?: Array<string>;
    /**
     * Filter by color; __unknown__ = unknown. Comma-separated or repeated.
     */
    colors?: Array<string>;
    /**
     * Filter by size; __unknown__ = unknown. Comma-separated or repeated.
     */
    sizes?: Array<string>;
    /**
     * Filter by factory language; __unknown__ = unknown. Comma-separated or repeated.
     */
    languages?: Array<string>;
    /**
     * Only products with a known item behaviour (facets always count those only).
     */
    knownOnly?: boolean;
    /**
     * Only products of this workspace; omit for all workspaces.
     */
    workspaceId?: string;
    /**
     * Filter by lifecycle state. Comma-separated or repeated.
     */
    states?: Array<ProductState>;
    /**
     * Filter by fulfillment stage. Comma-separated or repeated.
     */
    stages?: Array<FulfillmentStage>;
    /**
     * Filter by registration kind. Comma-separated or repeated.
     */
    registrationKinds?: Array<RegistrationKind>;
    /**
     * Only products with an order of this channel.
     */
    orderChannel?: OrderChannel;
    /**
     * Only products carrying this exact order number (e.g. `#UP2-PROMO-ORD-1`), optionally of `orderChannel`.
     */
    orderNumber?: string;
  };
  url: '/api/v1/products-admin/stats';
};

export type FindStatsAdminResponses = {
  200: ProductAdminStatsDto;
};

export type FindStatsAdminResponse =
  FindStatsAdminResponses[keyof FindStatsAdminResponses];

export type CreateAdminData = {
  body: CreateProductAdminDto;
  path?: never;
  query?: never;
  url: '/api/v1/products-admin/create';
};

export type CreateAdminResponses = {
  201: ProductAdminDto;
};

export type CreateAdminResponse =
  CreateAdminResponses[keyof CreateAdminResponses];

export type RegisterBatchAdminData = {
  body: RegisterProductBatchDto;
  path?: never;
  query?: never;
  url: '/api/v1/products-admin/register-batch';
};

export type RegisterBatchAdminResponses = {
  200: RegisterProductBatchResultDto;
};

export type RegisterBatchAdminResponse =
  RegisterBatchAdminResponses[keyof RegisterBatchAdminResponses];

export type RegisterGoodsReceiptAdminData = {
  body: RegisterProductGoodsReceiptDto;
  path?: never;
  query?: never;
  url: '/api/v1/products-admin/register-goods-receipt';
};

export type RegisterGoodsReceiptAdminResponses = {
  201: ProductAdminDto;
};

export type RegisterGoodsReceiptAdminResponse =
  RegisterGoodsReceiptAdminResponses[keyof RegisterGoodsReceiptAdminResponses];

export type MarkProgrammedAdminData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/products-admin/hash/{hash}/mark-programmed';
};

export type MarkProgrammedAdminResponses = {
  200: ProductAdminDto;
};

export type MarkProgrammedAdminResponse =
  MarkProgrammedAdminResponses[keyof MarkProgrammedAdminResponses];

export type MarkGeneratedAdminData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/products-admin/hash/{hash}/mark-generated';
};

export type MarkGeneratedAdminResponses = {
  200: ProductAdminDto;
};

export type MarkGeneratedAdminResponse =
  MarkGeneratedAdminResponses[keyof MarkGeneratedAdminResponses];

export type RemoveAdminData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/products-admin/{id}';
};

export type RemoveAdminResponses = {
  204: void;
};

export type RemoveAdminResponse =
  RemoveAdminResponses[keyof RemoveAdminResponses];

export type FindOneAdminData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/products-admin/{id}';
};

export type FindOneAdminResponses = {
  200: ProductAdminDto;
};

export type FindOneAdminResponse =
  FindOneAdminResponses[keyof FindOneAdminResponses];

export type UpdateAdminData = {
  body: UpdateProductAdminDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/products-admin/{id}';
};

export type UpdateAdminErrors = {
  /**
   * Stale `rev`: another write changed the product.
   */
  409: unknown;
};

export type UpdateAdminResponses = {
  200: ProductAdminDto;
};

export type UpdateAdminResponse =
  UpdateAdminResponses[keyof UpdateAdminResponses];

export type AdminListClaimRequestsData = {
  body?: never;
  path?: never;
  query?: {
    status?: ClaimRequestStatus;
    /**
     * Defaults to MANUAL (the review queue); any method with `productId`
     */
    method?: ClaimMethod;
    /**
     * Every status but PENDING, most recently resolved first (the "done" tab). Overrides `status`.
     */
    resolved?: boolean;
    /**
     * One product's requests, newest first; any status unless `status` / `resolved` is given
     */
    productId?: string;
  };
  url: '/api/v1/products-admin/claim-requests';
};

export type AdminListClaimRequestsResponses = {
  200: Array<AdminClaimRequestViewDto>;
};

export type AdminListClaimRequestsResponse =
  AdminListClaimRequestsResponses[keyof AdminListClaimRequestsResponses];

export type ApproveClaimRequestData = {
  body?: never;
  path: {
    requestId: string;
  };
  query?: never;
  url: '/api/v1/products-admin/claim-requests/{requestId}/approve';
};

export type ApproveClaimRequestResponses = {
  200: ClaimVerifyResponseDto;
};

export type ApproveClaimRequestResponse =
  ApproveClaimRequestResponses[keyof ApproveClaimRequestResponses];

export type RejectClaimRequestData = {
  body: RejectClaimRequestDto;
  path: {
    requestId: string;
  };
  query?: never;
  url: '/api/v1/products-admin/claim-requests/{requestId}/reject';
};

export type RejectClaimRequestResponses = {
  200: ClaimRequestViewDto;
};

export type RejectClaimRequestResponse =
  RejectClaimRequestResponses[keyof RejectClaimRequestResponses];

export type DeleteByHashAdminData = {
  body?: never;
  path: {
    hash: string;
  };
  query?: never;
  url: '/api/v1/products-admin/hash/{hash}';
};

export type DeleteByHashAdminResponses = {
  204: void;
};

export type DeleteByHashAdminResponse =
  DeleteByHashAdminResponses[keyof DeleteByHashAdminResponses];

export type FindScansAdminData = {
  body?: never;
  path: {
    id: string;
  };
  query?: {
    days?: number;
  };
  url: '/api/v1/products-admin/{id}/scans';
};

export type FindScansAdminResponses = {
  200: ProductScansDto;
};

export type FindScansAdminResponse =
  FindScansAdminResponses[keyof FindScansAdminResponses];

export type RevealSetupContactAdminData = {
  body?: never;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/products-admin/{id}/setup-contact';
};

export type RevealSetupContactAdminResponses = {
  200: ProductSetupContactDto;
};

export type RevealSetupContactAdminResponse =
  RevealSetupContactAdminResponses[keyof RevealSetupContactAdminResponses];

export type AssignAdminData = {
  body: ProductWorkspaceTargetDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/products-admin/{id}/assign';
};

export type AssignAdminResponses = {
  200: ProductAdminDto;
};

export type AssignAdminResponse =
  AssignAdminResponses[keyof AssignAdminResponses];

export type MoveAdminData = {
  body: ProductWorkspaceTargetDto;
  path: {
    id: string;
  };
  query?: never;
  url: '/api/v1/products-admin/{id}/move';
};

export type MoveAdminResponses = {
  200: ProductAdminDto;
};

export type MoveAdminResponse = MoveAdminResponses[keyof MoveAdminResponses];
